<template>
    <div class="energyOverview app-bg">
    <div id="base" class="">

    

      <!-- Unnamed (Rectangle) -->
      <div id="u3794" class="ax_default box_1">
        <div id="u3794_div" class=""></div>
        <div id="u3794_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3795" class="ax_default box_1">
        <div id="u3795_div" class=""></div>
        <div id="u3795_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3796" class="ax_default button" @click="setFlag1(1)">
        <div id="u3796_div" class=""></div>
        <div id="u3796_text" class="text ">
          <p><span>月</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3797" class="ax_default button" @click="setFlag1(2)">
        <div id="u3797_div" class=""></div>
        <div id="u3797_text" class="text ">
          <p><span>季</span></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u3798" class="ax_default line">
        <img id="u3798_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u336.svg"/>
        <div id="u3798_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3799" class="ax_default button" @click="setFlag1(3)">
        <div id="u3799_div" class=""></div>
        <div id="u3799_text" class="text ">
          <p><span>年</span></p>
        </div>
      </div>



      <!-- Unnamed (Rectangle) -->
      <div id="u3801" class="ax_default box_1">
        <div id="u3801_div" class=""></div>
        <div id="u3801_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3802" class="ax_default box_1">
        <div id="u3802_div" class=""></div>
        <div id="u3802_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u3803" class="ax_default line">
        <img id="u3803_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u338.svg"/>
        <div id="u3803_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3804" class="ax_default label">
        <div id="u3804_div" class=""></div>
        <div id="u3804_text" class="text ">
          <p><span>月度能效&amp;评价&amp;预测</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3805" class="ax_default box_1">
        <div id="u3805_div" class=""></div>
        <div id="u3805_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3806" class="ax_default heading_1">
        <div id="u3806_div" class=""></div>
        <div id="u3806_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>
    <div id="u38071" class="ax_default button" >
    <el-radio-group v-model="radio" @change="getChange">
            <el-radio :label="0" ><font size="2"><b>能源绩效</b></font></el-radio>
            <el-radio :label="1"  style="margin-left:2px"><font size="2"><b>单位产值能耗</b></font></el-radio>
            <el-radio :label="2"  style="margin-left:2px"><font size="2"><b>单位面积能耗</b></font></el-radio>
            <el-radio :label="3" style="margin-left:2px"><font size="2"><b>单位面积电耗</b></font></el-radio>
            <el-radio :label="4" style="margin-left:2px"><font size="2"><b>单位面积用水</b></font></el-radio>
            <el-radio :label="5" style="margin-left:2px"><font size="2"><b>单位空调用电</b></font></el-radio>
            <el-radio :label="6" style="margin-left:2px"><font size="2"><b>人均能耗</b></font></el-radio>
            <el-radio :label="7" style="margin-left:2px"><font size="2"><b>单位人均电耗</b></font></el-radio>
            <el-radio :label="8" style="margin-left:2px"><font size="2"><b>单位人均用水</b></font></el-radio>
  </el-radio-group>
    </div>
  

      <!-- Unnamed (Rectangle) -->
      <div id="u3816" class="ax_default box_1">
        <div id="u3816_div" class=""></div>
        <div id="u3816_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3817" class="ax_default box_1">
        <div id="u3817_div" class=""></div>
        <div id="u3817_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3818" class="ax_default" data-left="257" data-top="962" data-width="1149" data-height="203">

        <!-- Unnamed (Rectangle) -->
        <div id="u3819" class="ax_default label">
          <div id="u3819_div" class=""></div>
          <div id="u3819_text" class="text ">
            <p><span>能耗绩效详情</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3820" class="ax_default box_1">
          <div id="u3820_div" class=""></div>
          <div id="u3820_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3821" class="ax_default label">
          <div id="u3821_div" class=""></div>
          <div id="u3821_text" class="text ">
            <p><span>能效类型</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u3822" class="ax_default droplist">
          <div id="u3822_div" class=""></div>
          <select id="u3822_input" class="u3822_input" v-model="queryParams.performancetype">
            <option class="u3822_input_option" selected value="">请选择</option>
            <option class="u3822_input_option" value="0">总能耗</option>
            <option class="u3822_input_option" value="1">单位产值能耗</option>
            <option class="u3822_input_option" value="2">单位面积能耗</option>
            <option class="u3822_input_option" value="3">单位面积电耗</option>
            <option class="u3822_input_option" value="4">单位面积用水</option>
            <option class="u3822_input_option" value="5">单位面积空调用电</option>
            <option class="u3822_input_option" value="6">人均能耗</option>
            <option class="u3822_input_option" value="7">单位人均电耗</option>
            <option class="u3822_input_option" value="8">单位人均用水</option>
          </select>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3823" class="ax_default label">
          <div id="u3823_div" class=""></div>
          <div id="u3823_text" class="text ">
            <p><span>周期</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u3824" class="ax_default image">
           <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              type="monthrange"
              range-separator=":"
              size="small"
              class="date-item"
              format="yyyy-MM"
              value-format="yyyy-MM-dd HH:mm:ss"
               v-model="pickerOpts.pickerData"
                  :picker-options="pickerOpts"
                   @change="setDateRange"
              start-placeholder="起始时间"
              end-placeholder="截止时间"
            />
          <div id="u3824_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3825" class="ax_default primary_button"  @click="handleQuery">
          <div id="u3825_div" class=""></div>
          <div id="u3825_text" class="text ">
            <p><span>查询</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3826" class="ax_default box_1">
          
        
<div class="innerbox"  style="width: 100%; height:350px;position: absolute;z-index: 99;">
                <el-table  :data="consumptionList"  v-loading="loading"
                style="width: 100%;"
                 show-header="false"
                >
         
                <el-table-column label="时间" align="center" prop="performancemonth" />
                <el-table-column label="能耗类型" align="center" prop="performancetype" />
                <el-table-column label="能耗绩效" align="center" prop="performance" />
             
               
             </el-table>
               <pagination v-show="total>0" 
                  :total="total" 
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
             </div>
        </div>
        <!-- Unnamed (Rectangle) -->
      

        <!-- Unnamed (Line) -->
        <div id="u3828" class="ax_default _水平线">
          <img id="u3828_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u396.svg"/>
          <div id="u3828_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3829" class="ax_default heading_1">
          <div id="u3829_div" class=""></div>
          <div id="u3829_text" class="text ">
            <p><span style="font-family:'Arial-BoldMT', 'Arial Bold', 'Arial', sans-serif;font-weight:700;">时间</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3830" class="ax_default primary_button">
          <div id="u3830_div" class=""></div>
          <div id="u3830_text" class="text ">
            <p><span>导出</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3831" class="ax_default label">
          <div id="u3831_div" class=""></div>
          <div id="u3831_text" class="text ">
            <p><span>暂无数据</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
       

        <!-- Unnamed (Rectangle) -->
      
      </div>

 

      <!-- Unnamed (Group) -->
      <div id="u3857" class="ax_default" data-left="1081" data-top="274" data-width="303" data-height="599">

        <!-- Unnamed (Group) -->
        <div id="u3858" class="ax_default" data-left="1081" data-top="274" data-width="303" data-height="599">

          <!-- Unnamed (Rectangle) -->
          <div id="u3859" class="ax_default box_1">
            <div id="u3859_div" class=""></div>
            <div id="u3859_text" class="text " style="display:none; visibility: hidden">
              <p></p>
            </div>
          </div>

    

          <!-- Unnamed (Rectangle) -->
          <div id="u3864" class="ax_default label">
            <div id="u3864_div" class=""></div>
            <div id="u3864_text" class="text ">
              <p><span>能效评价</span></p>
            </div>
          </div>

          <!-- Unnamed (Image) -->
          <div id="u3865" class="ax_default image">
           <!-- <img id="u3865_img" class="img " src="../../../../../../assets/common/quota/icon/month/u1741.png"/>-->
            <div id="u3865_text" class="text " style="display:none; visibility: hidden">
              <p></p>
            </div>
          </div>

             <div id="u31401" class="ax_default">
           
            <table>
           
              <tr width="300" v-for='item in tableData' :key='item.date'>
                <td  width="100" height="29">{{item.date}}</td>
                <td  width="100" height="29">{{item.name}}</td>
                 <td  width="100" v-if="item.name==='优秀'">
                  <img  src="../../../../../../assets/common/performanc/icon/month/u3153.png" class="img" width="31" height="29">
                  </td>
                  <td  width="100" v-if="item.name==='良好'">
                  <img  src="../../../../../../assets/common/performanc/icon/month/u3154.png" class="img" width="31" height="29">
                  </td>
                   <td  width="100" v-if="item.name==='加油'">
                  <img  src="../../../../../../assets/common/performanc/icon/month/u3152.png" class="img" width="31" height="29">
                  </td>
                </tr>
            
                </table>
                
            </div>


         

         


      
        </div>

    
      </div>

    

      <!-- Unnamed (Rectangle) -->
      <div id="u3883" class="ax_default box_1">
        <div id="u3883_div" class=""></div>
        <div id="u3883_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3889" class="ax_default box_1">
 
            <el-table
              :data="rightsDate"     
                border
                
                width="100%"
                height="95%"
                class="customer-table"
                :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                >
              <el-table-column
                  v-for="info in rightHeader" :key="info.key"     

                  :property="info.key"
                  :label="info.label"
                >
             <template slot-scope="scope">
                   {{scope.row[scope.column.property]}}  
              </template>
              </el-table-column>
   
              </el-table>
            </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3901" class="ax_default label">
        <div id="u3901_div" class=""></div>
        <div id="u3901_text" class="text ">
          <p><span>能效预测</span></p>
        </div>
      </div>



      <!-- Unnamed (Group) -->
     <div id="u3183" v-if="jxflag==0">
         <v-chart
          ref="barChart"
          style="width: 100%;height:300px"
          :options="monthlyProportionOptions"
          theme="macarons"
          :auto-resize="true">
          </v-chart>

      
     </div>
      <div id="u3183" v-if="jxflag==1">
         <v-chart
          ref="barChart"
          style="width: 100%;height:300px"
          :options="monthlyProportionOptions1"
          theme="macarons"
          :auto-resize="true">
          </v-chart>

      
     </div>
      <!-- Unnamed (Rectangle) -->
      <div id="u3917" class="ax_default label">
        <div id="u3917_div" class=""></div>
        <div id="u3917_text" class="text ">
          <p><span>月度能源绩效</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3918" class="ax_default label">
        <div id="u3918_div" class=""></div>
        <div id="u3918_text" class="text ">
          <p><span>{{totalmonth}}</span></p>
        </div>
      </div>
    </div>
    </div>
    
 

</template>
<script>
import "echarts/theme/macarons";
import {
  getPerformanceLevel1,
  listPerformance,
} from "@/api/business/energy/performance";
import Pagination from '@/components/Pagination';
export default {
  name: "energyOverview",
   components: {Pagination},
      props: {
      //接收父组件传来的值
      flag: Number
    },
  data() {
    
    return {
        flag: 1,
        jxflag: 0,
        radio: 0,
        // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      quotaList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
      queryParams: {
                   pageNum: 1,
                   pageSize: 10,
                   performancetype: '',
               
                   startTime: null,
                   endTime: null
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
   feeTypeList: [
        { itemCode: 1, itemName: "单位产值" },
        { itemCode: 2, itemName: "单位面积综合" },
        { itemCode: 3, itemName: "单位面积电耗" },
        { itemCode: 4, itemName: "单位面积用水" },     
        { itemCode: 5, itemName: "单位面积空调" },
        { itemCode: 6, itemName: "人均综合能耗" },     
        { itemCode: 7, itemName: "单位人均电耗" },
        { itemCode: 8, itemName: "单位人均用水" },
    
      ],

      //1 总能耗
      yearAnalysis: [],
      seasonAnalysis: [],
      monthAnalysis: [],

      //2---单位产值
      unitoutputyearAnalysis: [],
      unitoutputseasonAnalysis: [],
      unitoutputmonthAnalysis: [],

      //3---单位面积能耗
      unitareaenergyyearAnalysis: [],
      unitareaenergyseasonAnalysis: [],
      unitareaenergymonthAnalysis: [],

      //4---单位面积电耗

      unitareapoweryearAnalysis: [],
      unitareapowerseasonAnalysis: [],
      unitareapowermonthAnalysis: [],

      //5--单位面积水耗
      unitareawateryearAnalysis: [],
      unitareawaterseasonAnalysis: [],
      unitareawatermonthAnalysis: [],

     //6--单位面积空调
      unitareaairyearAnalysis: [],
      unitareaairseasonAnalysis: [],
      unitareaairmonthAnalysis: [],

       //7---人均能耗
      peryearAnalysis: [],
      perseasonAnalysis: [],
      permonthAnalysis: [],
     
      //8--人均面积水耗
      perareawateryearAnalysis: [],
      perareawaterseasonAnalysis: [],
      perareawatermonthAnalysis: [],

      //9---单位面积电耗

      perareapoweryearAnalysis: [],
      perareapowerseasonAnalysis: [],
      perareapowermonthAnalysis: [],
     
      paramsData: [],

      //1 总能耗
      monthlyProportionOptions: null,
      monthlyProportionOptions1: null,
      seasonProportionOptions: null,
      seasonProportionOptions1: null,
      yearlyProportionOptions: null,
      monthlyProportionOptionsRate: null,
      seasonProportionOptionsRate: null,
      yearlyProportionOptionsRate: null,

      //2---单位产值
      unitoutputmonthlyProportionOptions: null,
      unitoutputseasonProportionOptions: null,
      unitoutputyearlyProportionOptions: null,
      unitoutputmonthlyProportionOptionsRate: null,
      unitoutputseasonProportionOptionsRate: null,
      unitoutputyearlyProportionOptionsRate: null,

       //3---单位面积能耗   
      unitareaenergymonthlyProportionOptions: null,
      unitareaenergyseasonProportionOptions: null,
      unitareaenergyyearlyProportionOptions: null,
      unitareaenergymonthlyProportionOptionsRate: null,
      unitareaenergyseasonProportionOptionsRate: null,
      unitareaenergyyearlyProportionOptionsRate: null,

      //4---单位面积电耗
      unitareapowermonthlyProportionOptions: null,
      unitareapowerseasonProportionOptions: null,
      unitareapoweryearlyProportionOptions: null,
      unitareapowermonthlyProportionOptionsRate: null,
      unitareapowerseasonProportionOptionsRate: null,
      unitareapoweryearlyProportionOptionsRate: null,
 
       //5---单位面积水耗
      unitareawatermonthlyProportionOptions: null,
      unitareawaterseasonProportionOptions: null,
      unitareawateryearlyProportionOptions: null,
      unitareawatermonthlyProportionOptionsRate: null,
      unitareawaterseasonProportionOptionsRate: null,
      unitareawateryearlyProportionOptionsRate: null,    

       //6---单位面积空调
      unitareaairmonthlyProportionOptions: null,
      unitareaairseasonProportionOptions: null,
      unitareaairyearlyProportionOptions: null,
      unitareaairmonthlyProportionOptionsRate: null,
      unitareaairseasonProportionOptionsRate: null,
      unitareaairyearlyProportionOptionsRate: null,  

       //7---人均能耗
      permonthlyProportionOptions: null,
      perseasonProportionOptions: null,
      peryearlyProportionOptions: null,
      permonthlyProportionOptionsRate: null,
      perseasonProportionOptionsRate: null,
      peryearlyProportionOptionsRate: null,    

       //8---人均电耗
      perpowermonthlyProportionOptions: null,
      perpowerseasonProportionOptions: null,
      perpoweryearlyProportionOptions: null,
      perpowermonthlyProportionOptionsRate: null,
      perpowerseasonProportionOptionsRate: null,
      perpoweryearlyProportionOptionsRate: null,    
       //9---人均水耗
      perwatermonthlyProportionOptions: null,
      perwaterseasonProportionOptions: null,
      perwateryearlyProportionOptions: null,
      perwatermonthlyProportionOptionsRate: null,
      perwaterseasonProportionOptionsRate: null,
      perwateryearlyProportionOptionsRate: null,    
        
        totalmonth: '',
        montharr: [],//月份
      montharr2: [],//月份
      dataarr: [],//目标值
      dataarr2: [],//实际值
      dataarr3: [],//预测值
      dataarr4: [],//评价
      forcastdata:null,
      rightHeader: [],
      rightsDate: [],
       tableData: [],
       besturl: "../../../../../../assets/common/performanc/icon/month/u3153.png",
       betterurl: "../../../../../../assets/common/performanc/icon/month/u3154.png",
       goodurl: "../../../../../../assets/common/performanc/icon/month/u3152.png",
      performanceLevel1VO: {
 //----------汇总数据-------------
    //今年总量
    totalYear: "",//0
    outputYear: "",//1
    areaenergyYear: "",//2
    areapowerYear: "",//3
    areawaterYear: "",//4
    areaairYear: "",//5
    perYear: "",//6
    perpowerYear: "",//7
    perwaterYear: "",//8


    //---今年用量变化
    totalChangeYear: "",//0
    outputChangeYear: "",//1
    areaenergyChangeYear: "",//2
    areapowerChangeYear: "",//3
    areawaterChangeYear: "",//4
    areaairChangeYear: "",//5
    perChangeYear: "",//6
    perpowerChangeYear: "",//7
    perwaterChangeYear: "",//8

    //---今年用量变化率
    totalChangerateYear: "",//0
    outputChangerateYear: "",//1
    areaenergyChangerateYear: "",//2
    areapowerChangerateYear: "",//3
    areawaterChangerateYear: "",//4
    areaairChangerateYear: "",//5
    perChangerateYear: "",//6
    perpowerChangerateYear: "",//7
    perwaterChangerateYear: "",//8


    //---今年用量评价
    totalEvaluateYear: "",//0
    outputEvaluateYear: "",//1
    areaenergyEvaluateYear: "",//2
    areapowerEvaluateYear: "",//3
    areawaterEvaluateYear: "",//4
    areaairEvaluateYear: "",//5
    perEvaluateYear: "",//6
    perpowerEvaluateYear: "",//7
    perwaterEvaluateYear: "",//8

    //--下一周期预测
    totalForecastYear: "",//0
    outputForecastYear: "",//1
    areaenergyForecastYear: "",//2
    areapowerForecastYear: "",//3
    areawaterForecastYear: "",//4
    areaairForecastYear: "",//5
    perForecastYear: "",//6
    perpowerForecastYear: "",//7
    perwaterForecastYear: "",//8




    //---------------总季度----------------------------------------

    //----总量
    totalSeason1: "",
    totalSeason2: "",
    totalSeason3: "",
    totalSeason4: "",
    //---用量变化
    totalChangeSeason1: "",
    totalChangeSeason2: "",
    totalChangeSeason3: "",
    totalChangeSeason4: "",
    //---用量变化率
    totalChangeRateSeason1: "",
    totalChangeRateSeason2: "",
    totalChangeRateSeason3: "",
    totalChangeRateSeason4: "",
    //--用量评价
    totalEvaluateSeason1: "",
    totalEvaluateSeason2: "",
    totalEvaluateSeason3: "",
    totalEvaluateSeason4: "",
    //--下一周期预测
    totalForecastSeason1: "",
    totalForecastSeason2: "",
    totalForecastSeason3: "",
    totalForecastSeason4: "",

    //---------------单位产值季度----------------------------------------

    //----用量
    outputSeason1: "",
    outputSeason2: "",
    outputSeason3: "",
    outputSeason4: "",
    //---用量变化
    outputChangeSeason1: "",
    outputChangeSeason2: "",
    outputChangeSeason3: "",
    outputChangeSeason4: "",
    //---用量变化率
    outputChangeRateSeason1: "",
    outputChangeRateSeason2: "",
    outputChangeRateSeason3: "",
    outputChangeRateSeason4: "",
    //--用量评价
    outputEvaluateSeason1: "",
    outputEvaluateSeason2: "",
    outputEvaluateSeason3: "",
    outputEvaluateSeason4: "",
    //--下一周期预测
    outputForecastSeason1: "",
    outputForecastSeason2: "",
    outputForecastSeason3: "",
    outputForecastSeason4: "",

    //---------------单位面积季度----------------------------------------

    //----用量
    areaenergySeason1: "",
    areaenergySeason2: "",
    areaenergySeason3: "",
    areaenergySeason4: "",
    //---用量变化
    areaenergyChangeSeason1: "",
    areaenergyChangeSeason2: "",
    areaenergyChangeSeason3: "",
    areaenergyChangeSeason4: "",
    //---用量变化率
    areaenergyChangeRateSeason1: "",
    areaenergyChangeRateSeason2: "",
    areaenergyChangeRateSeason3: "",
    areaenergyChangeRateSeason4: "",
    //--用量评价
    areaenergyEvaluateSeason1: "",
    areaenergyEvaluateSeason2: "",
    areaenergyEvaluateSeason3: "",
    areaenergyEvaluateSeason4: "",
    //--下一周期预测
    areaenergyForecastSeason1: "",
    areaenergyForecastSeason2: "",
    areaenergyForecastSeason3: "",
    areaenergyForecastSeason4: "",


//---------------单位面积电耗季度----------------------------------------

    //----用量
    areapowerSeason1: "",
    areapowerSeason2: "",
    areapowerSeason3: "",
    areapowerSeason4: "",
    //---用量变化
    areapowerChangeSeason1: "",
    areapowerChangeSeason2: "",
    areapowerChangeSeason3: "",
    areapowerChangeSeason4: "",
    //---用量变化率
    areapowerChangeRateSeason1: "",
    areapowerChangeRateSeason2: "",
    areapowerChangeRateSeason3: "",
    areapowerChangeRateSeason4: "",
    //--用量评价
    areapowerEvaluateSeason1: "",
    areapowerEvaluateSeason2: "",
    areapowerEvaluateSeason3: "",
    areapowerEvaluateSeason4: "",
    //--下一周期预测
    areapowerForecastSeason1: "",
    areapowerForecastSeason2: "",
    areapowerForecastSeason3: "",
    areapowerForecastSeason4: "",


//---------------单位面积用水季度----------------------------------------

    //----用量
    areawaterSeason1: "",
    areawaterSeason2: "",
    areawaterSeason3: "",
    areawaterSeason4: "",
    //---用量变化
    areawaterChangeSeason1: "",
    areawaterChangeSeason2: "",
    areawaterChangeSeason3: "",
    areawaterChangeSeason4: "",
    //---用量变化率
    areawaterChangeRateSeason1: "",
    areawaterChangeRateSeason2: "",
    areawaterChangeRateSeason3: "",
    areawaterChangeRateSeason4: "",
    //--用量评价
    areawaterEvaluateSeason1: "",
    areawaterEvaluateSeason2: "",
    areawaterEvaluateSeason3: "",
    areawaterEvaluateSeason4: "",
    //--下一周期预测
    areawaterForecastSeason1: "",
    areawaterForecastSeason2: "",
    areawaterForecastSeason3: "",
    areawaterForecastSeason4: "",


//---------------单位空调季度----------------------------------------

    //----用量
    areaairSeason1: "",
    areaairSeason2: "",
    areaairSeason3: "",
    areaairSeason4: "",
    //---用量变化
    areaairChangeSeason1: "",
    areaairChangeSeason2: "",
    areaairChangeSeason3: "",
    areaairChangeSeason4: "",
    //---用量变化率
    areaairChangeRateSeason1: "",
    areaairChangeRateSeason2: "",
    areaairChangeRateSeason3: "",
    areaairChangeRateSeason4: "",
    //--用量评价
    areaairEvaluateSeason1: "",
    areaairEvaluateSeason2: "",
    areaairEvaluateSeason3: "",
    areaairEvaluateSeason4: "",
    //--下一周期预测
    areaairForecastSeason1: "",
    areaairForecastSeason2: "",
    areaairForecastSeason3: "",
    areaairForecastSeason4: "",


//---------------单位人均能耗季度----------------------------------------

    //----用量
    perSeason1: "",
    perSeason2: "",
    perSeason3: "",
    perSeason4: "",
    //---用量变化
    perChangeSeason1: "",
    perChangeSeason2: "",
    perChangeSeason3: "",
    perChangeSeason4: "",
    //---用量变化率
    perChangeRateSeason1: "",
    perChangeRateSeason2: "",
    perChangeRateSeason3: "",
    perChangeRateSeason4: "",
    //--用量评价
    perEvaluateSeason1: "",
    perEvaluateSeason2: "",
    perEvaluateSeason3: "",
    perEvaluateSeason4: "",
    //--下一周期预测
    perForecastSeason1: "",
    perForecastSeason2: "",
    perForecastSeason3: "",
    perForecastSeason4: "",


//---------------单位人均电耗季度----------------------------------------

    //----用量
    perpowerSeason1: "",
    perpowerSeason2: "",
    perpowerSeason3: "",
    perpowerSeason4: "",
    //---用量变化
    perpowerChangeSeason1: "",
    perpowerChangeSeason2: "",
    perpowerChangeSeason3: "",
    perpowerChangeSeason4: "",
    //---用量变化率
    perpowerChangeRateSeason1: "",
    perpowerChangeRateSeason2: "",
    perpowerChangeRateSeason3: "",
    perpowerChangeRateSeason4: "",
    //--用量评价
    perpowerEvaluateSeason1: "",
    perpowerEvaluateSeason2: "",
    perpowerEvaluateSeason3: "",
    perpowerEvaluateSeason4: "",
    //--下一周期预测
    perpowerForecastSeason1: "",
    perpowerForecastSeason2: "",
    perpowerForecastSeason3: "",
    perpowerForecastSeason4: "",


//---------------单位人均水耗季度----------------------------------------

    //----用量
    perwaterSeason1: "",
    perwaterSeason2: "",
    perwaterSeason3: "",
    perwaterSeason4: "",
    //---用量变化
    perwaterChangeSeason1: "",
    perwaterChangeSeason2: "",
    perwaterChangeSeason3: "",
    perwaterChangeSeason4: "",
    //---用量变化率
    perwaterChangeRateSeason1: "",
    perwaterChangeRateSeason2: "",
    perwaterChangeRateSeason3: "",
    perwaterChangeRateSeason4: "",
    //--用量评价
    perwaterEvaluateSeason1: "",
    perwaterEvaluateSeason2: "",
    perwaterEvaluateSeason3: "",
    perwaterEvaluateSeason4: "",
    //--下一周期预测
    perwaterForecastSeason1: "",
    perwaterForecastSeason2: "",
    perwaterForecastSeason3: "",
    perwaterForecastSeason4: "",

    //-------------总能耗月量----------------------------月量----------------------------
    //总量
    totalMonth1: "",
    totalMonth2: "",
    totalMonth3: "",
    totalMonth4: "",
    totalMonth5: "",
    totalMonth6: "",
    totalMonth7: "",
    totalMonth8: "",
    totalMonth9: "",
    totalMonth10: "",
    totalMonth11: "",
    totalMonth12: "",

    //变化
    totalChangeMonth1: "",
    totalChangeMonth2: "",
    totalChangeMonth3: "",
    totalChangeMonth4: "",
    totalChangeMonth5: "",
    totalChangeMonth6: "",
    totalChangeMonth7: "",
    totalChangeMonth8: "",
    totalChangeMonth9: "",
    totalChangeMonth10: "",
    totalChangeMonth11: "",
    totalChangeMonth12: "",
    //---变化率
    totalChangeRateMonth1: "",
    totalChangeRateMonth2: "",
    totalChangeRateMonth3: "",
    totalChangeRateMonth4: "",
    totalChangeRateMonth5: "",
    totalChangeRateMonth6: "",
    totalChangeRateMonth7: "",
    totalChangeRateMonth8: "",
    totalChangeRateMonth9: "",
    totalChangeRateMonth10: "",
    totalChangeRateMonth11: "",
    totalChangeRateMonth12: "",
    //--评价
    totalEvaluateMonth1: "",
    totalEvaluateMonth2: "",
    totalEvaluateMonth3: "",
    totalEvaluateMonth4: "",
    totalEvaluateMonth5: "",
    totalEvaluateMonth6: "",
    totalEvaluateMonth7: "",
    totalEvaluateMonth8: "",
    totalEvaluateMonth9: "",
    totalEvaluateMonth10: "",
    totalEvaluateMonth11: "",
    totalEvaluateMonth12: "",

    //--下一周期预测
    totalForecastMonth1: "",
    totalForecastMonth2: "",
    totalForecastMonth3: "",
    totalForecastMonth4: "",
    totalForecastMonth5: "",
    totalForecastMonth6: "",
    totalForecastMonth7: "",
    totalForecastMonth8: "",
    totalForecastMonth9: "",
    totalForecastMonth10: "",
    totalForecastMonth11: "",
    totalForecastMonth12: "",

    //-------------单位产值能耗月量----------------------------
    //总量
    outputMonth1: "",
    outputMonth2: "",
    outputMonth3: "",
    outputMonth4: "",
    outputMonth5: "",
    outputMonth6: "",
    outputMonth7: "",
    outputMonth8: "",
    outputMonth9: "",
    outputMonth10: "",
    outputMonth11: "",
    outputMonth12: "",

    //变化
    outputChangeMonth1: "",
    outputChangeMonth2: "",
    outputChangeMonth3: "",
    outputChangeMonth4: "",
    outputChangeMonth5: "",
    outputChangeMonth6: "",
    outputChangeMonth7: "",
    outputChangeMonth8: "",
    outputChangeMonth9: "",
    outputChangeMonth10: "",
    outputChangeMonth11: "",
    outputChangeMonth12: "",
    //---变化率
    outputChangeRateMonth1: "",
    outputChangeRateMonth2: "",
    outputChangeRateMonth3: "",
    outputChangeRateMonth4: "",
    outputChangeRateMonth5: "",
    outputChangeRateMonth6: "",
    outputChangeRateMonth7: "",
    outputChangeRateMonth8: "",
    outputChangeRateMonth9: "",
    outputChangeRateMonth10: "",
    outputChangeRateMonth11: "",
    outputChangeRateMonth12: "",
    //--评价
    outputEvaluateMonth1: "",
    outputEvaluateMonth2: "",
    outputEvaluateMonth3: "",
    outputEvaluateMonth4: "",
    outputEvaluateMonth5: "",
    outputEvaluateMonth6: "",
    outputEvaluateMonth7: "",
    outputEvaluateMonth8: "",
    outputEvaluateMonth9: "",
    outputEvaluateMonth10: "",
    outputEvaluateMonth11: "",
    outputEvaluateMonth12: "",

    //--下一周期预测
    outputForecastMonth1: "",
    outputForecastMonth2: "",
    outputForecastMonth3: "",
    outputForecastMonth4: "",
    outputForecastMonth5: "",
    outputForecastMonth6: "",
    outputForecastMonth7: "",
    outputForecastMonth8: "",
    outputForecastMonth9: "",
    outputForecastMonth10: "",
    outputForecastMonth11: "",
    outputForecastMonth12: "",

    //-------------单位面积能耗月量----------------------------
    //总量
    areaenergyMonth1: "",
    areaenergyMonth2: "",
    areaenergyMonth3: "",
    areaenergyMonth4: "",
    areaenergyMonth5: "",
    areaenergyMonth6: "",
    areaenergyMonth7: "",
    areaenergyMonth8: "",
    areaenergyMonth9: "",
    areaenergyMonth10: "",
    areaenergyMonth11: "",
    areaenergyMonth12: "",

    //变化
    areaenergyChangeMonth1: "",
    areaenergyChangeMonth2: "",
    areaenergyChangeMonth3: "",
    areaenergyChangeMonth4: "",
    areaenergyChangeMonth5: "",
    areaenergyChangeMonth6: "",
    areaenergyChangeMonth7: "",
    areaenergyChangeMonth8: "",
    areaenergyChangeMonth9: "",
    areaenergyChangeMonth10: "",
    areaenergyChangeMonth11: "",
    areaenergyChangeMonth12: "",
    //---变化率
    areaenergyChangeRateMonth1: "",
    areaenergyChangeRateMonth2: "",
    areaenergyChangeRateMonth3: "",
    areaenergyChangeRateMonth4: "",
    areaenergyChangeRateMonth5: "",
    areaenergyChangeRateMonth6: "",
    areaenergyChangeRateMonth7: "",
    areaenergyChangeRateMonth8: "",
    areaenergyChangeRateMonth9: "",
    areaenergyChangeRateMonth10: "",
    areaenergyChangeRateMonth11: "",
    areaenergyChangeRateMonth12: "",
    //--评价
    areaenergyEvaluateMonth1: "",
    areaenergyEvaluateMonth2: "",
    areaenergyEvaluateMonth3: "",
    areaenergyEvaluateMonth4: "",
    areaenergyEvaluateMonth5: "",
    areaenergyEvaluateMonth6: "",
    areaenergyEvaluateMonth7: "",
    areaenergyEvaluateMonth8: "",
    areaenergyEvaluateMonth9: "",
    areaenergyEvaluateMonth10: "",
    areaenergyEvaluateMonth11: "",
    areaenergyEvaluateMonth12: "",

    //--下一周期预测
    areaenergyForecastMonth1: "",
    areaenergyForecastMonth2: "",
    areaenergyForecastMonth3: "",
    areaenergyForecastMonth4: "",
    areaenergyForecastMonth5: "",
    areaenergyForecastMonth6: "",
    areaenergyForecastMonth7: "",
    areaenergyForecastMonth8: "",
    areaenergyForecastMonth9: "",
    areaenergyForecastMonth10: "",
    areaenergyForecastMonth11: "",
    areaenergyForecastMonth12: "",

    //-------------单位面积能耗月量----------------------------
    //总量
    areapowerMonth1: "",
    areapowerMonth2: "",
    areapowerMonth3: "",
    areapowerMonth4: "",
    areapowerMonth5: "",
    areapowerMonth6: "",
    areapowerMonth7: "",
    areapowerMonth8: "",
    areapowerMonth9: "",
    areapowerMonth10: "",
    areapowerMonth11: "",
    areapowerMonth12: "",

    //变化
    areapowerChangeMonth1: "",
    areapowerChangeMonth2: "",
    areapowerChangeMonth3: "",
    areapowerChangeMonth4: "",
    areapowerChangeMonth5: "",
    areapowerChangeMonth6: "",
    areapowerChangeMonth7: "",
    areapowerChangeMonth8: "",
    areapowerChangeMonth9: "",
    areapowerChangeMonth10: "",
    areapowerChangeMonth11: "",
    areapowerChangeMonth12: "",
    //---变化率
    areapowerChangeRateMonth1: "",
    areapowerChangeRateMonth2: "",
    areapowerChangeRateMonth3: "",
    areapowerChangeRateMonth4: "",
    areapowerChangeRateMonth5: "",
    areapowerChangeRateMonth6: "",
    areapowerChangeRateMonth7: "",
    areapowerChangeRateMonth8: "",
    areapowerChangeRateMonth9: "",
    areapowerChangeRateMonth10: "",
    areapowerChangeRateMonth11: "",
    areapowerChangeRateMonth12: "",
    //--评价
    areapowerEvaluateMonth1: "",
    areapowerEvaluateMonth2: "",
    areapowerEvaluateMonth3: "",
    areapowerEvaluateMonth4: "",
    areapowerEvaluateMonth5: "",
    areapowerEvaluateMonth6: "",
    areapowerEvaluateMonth7: "",
    areapowerEvaluateMonth8: "",
    areapowerEvaluateMonth9: "",
    areapowerEvaluateMonth10: "",
    areapowerEvaluateMonth11: "",
    areapowerEvaluateMonth12: "",

    //--下一周期预测
    areapowerForecastMonth1: "",
    areapowerForecastMonth2: "",
    areapowerForecastMonth3: "",
    areapowerForecastMonth4: "",
    areapowerForecastMonth5: "",
    areapowerForecastMonth6: "",
    areapowerForecastMonth7: "",
    areapowerForecastMonth8: "",
    areapowerForecastMonth9: "",
    areapowerForecastMonth10: "",
    areapowerForecastMonth11: "",
    areapowerForecastMonth12: "",

    //-------------单位面积单耗月量----------------------------
    //总量
    areawaterMonth1: "",
    areawaterMonth2: "",
    areawaterMonth3: "",
    areawaterMonth4: "",
    areawaterMonth5: "",
    areawaterMonth6: "",
    areawaterMonth7: "",
    areawaterMonth8: "",
    areawaterMonth9: "",
    areawaterMonth10: "",
    areawaterMonth11: "",
    areawaterMonth12: "",

    //变化
    areawaterChangeMonth1: "",
    areawaterChangeMonth2: "",
    areawaterChangeMonth3: "",
    areawaterChangeMonth4: "",
    areawaterChangeMonth5: "",
    areawaterChangeMonth6: "",
    areawaterChangeMonth7: "",
    areawaterChangeMonth8: "",
    areawaterChangeMonth9: "",
    areawaterChangeMonth10: "",
    areawaterChangeMonth11: "",
    areawaterChangeMonth12: "",
    //---变化率
    areawaterChangeRateMonth1: "",
    areawaterChangeRateMonth2: "",
    areawaterChangeRateMonth3: "",
    areawaterChangeRateMonth4: "",
    areawaterChangeRateMonth5: "",
    areawaterChangeRateMonth6: "",
    areawaterChangeRateMonth7: "",
    areawaterChangeRateMonth8: "",
    areawaterChangeRateMonth9: "",
    areawaterChangeRateMonth10: "",
    areawaterChangeRateMonth11: "",
    areawaterChangeRateMonth12: "",
    //--评价
    areawaterEvaluateMonth1: "",
    areawaterEvaluateMonth2: "",
    areawaterEvaluateMonth3: "",
    areawaterEvaluateMonth4: "",
    areawaterEvaluateMonth5: "",
    areawaterEvaluateMonth6: "",
    areawaterEvaluateMonth7: "",
    areawaterEvaluateMonth8: "",
    areawaterEvaluateMonth9: "",
    areawaterEvaluateMonth10: "",
    areawaterEvaluateMonth11: "",
    areawaterEvaluateMonth12: "",

    //--下一周期预测
    areawaterForecastMonth1: "",
    areawaterForecastMonth2: "",
    areawaterForecastMonth3: "",
    areawaterForecastMonth4: "",
    areawaterForecastMonth5: "",
    areawaterForecastMonth6: "",
    areawaterForecastMonth7: "",
    areawaterForecastMonth8: "",
    areawaterForecastMonth9: "",
    areawaterForecastMonth10: "",
    areawaterForecastMonth11: "",
    areawaterForecastMonth12: "",

    //-------------单位空调月量----------------------------
    //总量
    areaairMonth1: "",
    areaairMonth2: "",
    areaairMonth3: "",
    areaairMonth4: "",
    areaairMonth5: "",
    areaairMonth6: "",
    areaairMonth7: "",
    areaairMonth8: "",
    areaairMonth9: "",
    areaairMonth10: "",
    areaairMonth11: "",
    areaairMonth12: "",

    //变化
    areaairChangeMonth1: "",
    areaairChangeMonth2: "",
    areaairChangeMonth3: "",
    areaairChangeMonth4: "",
    areaairChangeMonth5: "",
    areaairChangeMonth6: "",
    areaairChangeMonth7: "",
    areaairChangeMonth8: "",
    areaairChangeMonth9: "",
    areaairChangeMonth10: "",
    areaairChangeMonth11: "",
    areaairChangeMonth12: "",
    //---变化率
    areaairChangeRateMonth1: "",
    areaairChangeRateMonth2: "",
    areaairChangeRateMonth3: "",
    areaairChangeRateMonth4: "",
    areaairChangeRateMonth5: "",
    areaairChangeRateMonth6: "",
    areaairChangeRateMonth7: "",
    areaairChangeRateMonth8: "",
    areaairChangeRateMonth9: "",
    areaairChangeRateMonth10: "",
    areaairChangeRateMonth11: "",
    areaairChangeRateMonth12: "",
    //--评价
    areaairEvaluateMonth1: "",
    areaairEvaluateMonth2: "",
    areaairEvaluateMonth3: "",
    areaairEvaluateMonth4: "",
    areaairEvaluateMonth5: "",
    areaairEvaluateMonth6: "",
    areaairEvaluateMonth7: "",
    areaairEvaluateMonth8: "",
    areaairEvaluateMonth9: "",
    areaairEvaluateMonth10: "",
    areaairEvaluateMonth11: "",
    areaairEvaluateMonth12: "",

    //--下一周期预测
    areaairForecastMonth1: "",
    areaairForecastMonth2: "",
    areaairForecastMonth3: "",
    areaairForecastMonth4: "",
    areaairForecastMonth5: "",
    areaairForecastMonth6: "",
    areaairForecastMonth7: "",
    areaairForecastMonth8: "",
    areaairForecastMonth9: "",
    areaairForecastMonth10: "",
    areaairForecastMonth11: "",
    areaairForecastMonth12: "",

    //-------------人均能耗月量----------------------------
    //总量
    perMonth1: "",
    perMonth2: "",
    perMonth3: "",
    perMonth4: "",
    perMonth5: "",
    perMonth6: "",
    perMonth7: "",
    perMonth8: "",
    perMonth9: "",
    perMonth10: "",
    perMonth11: "",
    perMonth12: "",

    //变化
    perChangeMonth1: "",
    perChangeMonth2: "",
    perChangeMonth3: "",
    perChangeMonth4: "",
    perChangeMonth5: "",
    perChangeMonth6: "",
    perChangeMonth7: "",
    perChangeMonth8: "",
    perChangeMonth9: "",
    perChangeMonth10: "",
    perChangeMonth11: "",
    perChangeMonth12: "",
    //---变化率
    perChangeRateMonth1: "",
    perChangeRateMonth2: "",
    perChangeRateMonth3: "",
    perChangeRateMonth4: "",
    perChangeRateMonth5: "",
    perChangeRateMonth6: "",
    perChangeRateMonth7: "",
    perChangeRateMonth8: "",
    perChangeRateMonth9: "",
    perChangeRateMonth10: "",
    perChangeRateMonth11: "",
    perChangeRateMonth12: "",
    //--评价
    perEvaluateMonth1: "",
    perEvaluateMonth2: "",
    perEvaluateMonth3: "",
    perEvaluateMonth4: "",
    perEvaluateMonth5: "",
    perEvaluateMonth6: "",
    perEvaluateMonth7: "",
    perEvaluateMonth8: "",
    perEvaluateMonth9: "",
    perEvaluateMonth10: "",
    perEvaluateMonth11: "",
    perEvaluateMonth12: "",

    //--下一周期预测
    perForecastMonth1: "",
    perForecastMonth2: "",
    perForecastMonth3: "",
    perForecastMonth4: "",
    perForecastMonth5: "",
    perForecastMonth6: "",
    perForecastMonth7: "",
    perForecastMonth8: "",
    perForecastMonth9: "",
    perForecastMonth10: "",
    perForecastMonth11: "",
    perForecastMonth12: "",

    //-------------人均电耗月量----------------------------
    //总量
    perpowerMonth1: "",
    perpowerMonth2: "",
    perpowerMonth3: "",
    perpowerMonth4: "",
    perpowerMonth5: "",
    perpowerMonth6: "",
    perpowerMonth7: "",
    perpowerMonth8: "",
    perpowerMonth9: "",
    perpowerMonth10: "",
    perpowerMonth11: "",
    perpowerMonth12: "",

    //变化
    perpowerChangeMonth1: "",
    perpowerChangeMonth2: "",
    perpowerChangeMonth3: "",
    perpowerChangeMonth4: "",
    perpowerChangeMonth5: "",
    perpowerChangeMonth6: "",
    perpowerChangeMonth7: "",
    perpowerChangeMonth8: "",
    perpowerChangeMonth9: "",
    perpowerChangeMonth10: "",
    perpowerChangeMonth11: "",
    perpowerChangeMonth12: "",
    //---变化率
    perpowerChangeRateMonth1: "",
    perpowerChangeRateMonth2: "",
    perpowerChangeRateMonth3: "",
    perpowerChangeRateMonth4: "",
    perpowerChangeRateMonth5: "",
    perpowerChangeRateMonth6: "",
    perpowerChangeRateMonth7: "",
    perpowerChangeRateMonth8: "",
    perpowerChangeRateMonth9: "",
    perpowerChangeRateMonth10: "",
    perpowerChangeRateMonth11: "",
    perpowerChangeRateMonth12: "",
    //--评价
    perpowerEvaluateMonth1: "",
    perpowerEvaluateMonth2: "",
    perpowerEvaluateMonth3: "",
    perpowerEvaluateMonth4: "",
    perpowerEvaluateMonth5: "",
    perpowerEvaluateMonth6: "",
    perpowerEvaluateMonth7: "",
    perpowerEvaluateMonth8: "",
    perpowerEvaluateMonth9: "",
    perpowerEvaluateMonth10: "",
    perpowerEvaluateMonth11: "",
    perpowerEvaluateMonth12: "",

    //--下一周期预测
    perpowerForecastMonth1: "",
    perpowerForecastMonth2: "",
    perpowerForecastMonth3: "",
    perpowerForecastMonth4: "",
    perpowerForecastMonth5: "",
    perpowerForecastMonth6: "",
    perpowerForecastMonth7: "",
    perpowerForecastMonth8: "",
    perpowerForecastMonth9: "",
    perpowerForecastMonth10: "",
    perpowerForecastMonth11: "",
    perpowerForecastMonth12: "",


    //-------------人均水耗月量----------------------------
    //总量
    perwaterMonth1: "",
    perwaterMonth2: "",
    perwaterMonth3: "",
    perwaterMonth4: "",
    perwaterMonth5: "",
    perwaterMonth6: "",
    perwaterMonth7: "",
    perwaterMonth8: "",
    perwaterMonth9: "",
    perwaterMonth10: "",
    perwaterMonth11: "",
    perwaterMonth12: "",

    //变化
    perwaterChangeMonth1: "",
    perwaterChangeMonth2: "",
    perwaterChangeMonth3: "",
    perwaterChangeMonth4: "",
    perwaterChangeMonth5: "",
    perwaterChangeMonth6: "",
    perwaterChangeMonth7: "",
    perwaterChangeMonth8: "",
    perwaterChangeMonth9: "",
    perwaterChangeMonth10: "",
    perwaterChangeMonth11: "",
    perwaterChangeMonth12: "",
    //---变化率
    perwaterChangeRateMonth1: "",
    perwaterChangeRateMonth2: "",
    perwaterChangeRateMonth3: "",
    perwaterChangeRateMonth4: "",
    perwaterChangeRateMonth5: "",
    perwaterChangeRateMonth6: "",
    perwaterChangeRateMonth7: "",
    perwaterChangeRateMonth8: "",
    perwaterChangeRateMonth9: "",
    perwaterChangeRateMonth10: "",
    perwaterChangeRateMonth11: "",
    perwaterChangeRateMonth12: "",
    //--评价
    perwaterEvaluateMonth1: "",
    perwaterEvaluateMonth2: "",
    perwaterEvaluateMonth3: "",
    perwaterEvaluateMonth4: "",
    perwaterEvaluateMonth5: "",
    perwaterEvaluateMonth6: "",
    perwaterEvaluateMonth7: "",
    perwaterEvaluateMonth8: "",
    perwaterEvaluateMonth9: "",
    perwaterEvaluateMonth10: "",
    perwaterEvaluateMonth11: "",
    perwaterEvaluateMonth12: "",

    //--下一周期预测
    perwaterForecastMonth1: "",
    perwaterForecastMonth2: "",
    perwaterForecastMonth3: "",
    perwaterForecastMonth4: "",
    perwaterForecastMonth5: "",
    perwaterForecastMonth6: "",
    perwaterForecastMonth7: "",
    perwaterForecastMonth8: "",
    perwaterForecastMonth9: "",
    perwaterForecastMonth10: "",
    perwaterForecastMonth11: "",
    perwaterForecastMonth12: "",
      }
    };
  },
  created() {

    getPerformanceLevel1(this.queryParams).then((response) => {
          
          this.performanceLevel1VO = response.data;
        
     //1 总能耗
    this.monthlyProportionOptions=this.monthlyProportionRate(0);
    
      // this.monthlyProportionOptions=this.monthlyProportionRate2(0);
      // this.seasonProportionOptions=this.seasonProportion(),
      // this.yearlyProportionOptions=this.yearlyProportion(),
     // alert(22);
          
         });
    
   
  },

   methods: {
      // 设置日期范围查询条件
     setFlag1(iflag) {
        // alert("child="+iflag);
        //   this.flag=iflag;
        this.$emit("changeFlag",iflag);
       //  alert("child="+iflag);

     },
            /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
           /** 查询列表 */
    getList() {
      this.loading = true;
     
      listPerformance(this.queryParams).then((response) => {
        
        for(var i=0;i<response.rows.length;i++){
          if(response.rows[i].performancetype==0){
               response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
               response.rows[i].performancetype='总能耗';
            }
            if(response.rows[i].performancetype==1){
             response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;   response.rows[i].performancetype='电';
           response.rows[i].performancetype='单位产值能耗';
           }
            if(response.rows[i].performancetype==2){
           response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
              
               response.rows[i].performancetype='单位面积能耗';}
              if(response.rows[i].performancetype==3){
               response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
              
               response.rows[i].performancetype='单位面积电耗';}
            
            if(response.rows[i].performancetype==4){
           response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;  
               response.rows[i].performancetype='单位面积用水';
            }
              if(response.rows[i].performancetype==5){
               response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
               response.rows[i].performancetype='单位空调用电'; 
              }
               if(response.rows[i].performancetype==6){
               response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
               response.rows[i].performancetype='人均能耗';}
            
            if(response.rows[i].performancetype==7){
              response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
               response.rows[i].performancetype='单位人均电耗';
            }
              if(response.rows[i].performancetype==8){
               response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
               response.rows[i].performancetype='单位人均用水'; 
              }
        }
      
        this.consumptionList = response.rows;
         // alert(this.consumptionlist.length);
        this.total = response.total;
        this.loading = false;
      });
    },
        setDateRange(dateRange) {
        
          //alert(dateRange[0].substr(0,7));
        
         if (dateRange) {
                    this.queryParams.startTime = dateRange[0].substr(0,7);
                    this.queryParams.endTime = dateRange[1].substr(0,7);
                    
          } else {// 清空
                    this.queryParams.startTime = null;
                    this.queryParams.endTime = null;
           }
               
         },
            getChange(typeid){
              if(typeid==0){
        
          //总月度数据 
          this.jxflag=0;
          this.monthlyProportionOptions = this.monthlyProportionRate(0);
         // this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(0);
          
        }

       else if(typeid==1){
       // alert(2222);
          //电月度数据 
          this.jxflag=1;
          this.monthlyProportionOptions1 = this.monthlyProportionRate3(1);
          //this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(1);
          
        }else if(typeid==2){
          //水月度数据 
           this.jxflag=1;
          this.monthlyProportionOptions1 = this.monthlyProportionRate3(2);
          // this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(2);
        }else if(typeid==3){
           this.jxflag=1;
         //气月度数据 
         this.monthlyProportionOptions1 = this.monthlyProportionRate3(3);
          //this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(3);
        }else if(typeid==4){
           this.jxflag=1;
          //热月度数据 
          this.monthlyProportionOptions1 = this.monthlyProportionRate3(4);
           //this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(4);
        }else if(typeid==5){
           this.jxflag=1;
         // 其他月度数据 
         this.monthlyProportionOptions1 = this.monthlyProportionRate3(5);
         // this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(5);
        }else if(typeid==6){
           this.jxflag=1;
         // 其他月度数据 
         this.monthlyProportionOptions1 = this.monthlyProportionRate3(6);
         // this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(5);
        }else if(typeid==7){
           this.jxflag=1;
         // 其他月度数据 
         this.monthlyProportionOptions1 = this.monthlyProportionRate3(7);
         // this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(5);
        }else if(typeid==8){
           this.jxflag=1;
         // 其他月度数据 
         this.monthlyProportionOptions1 = this.monthlyProportionRate3(8);
         // this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(5);
        }
      },
       monthlyProportionRate2(flag) {
           alert(flag);
              return {
                  
        title: {
          text: "",
          textStyle: {
            fontSize: 16,
            color: "#fa12d4",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "cross" },
        },
         color:['#00BFFF','#FFB90F'],
        legend: {
          x: "right",
          right: 50,
          data: ["目标节能", "实际节能"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: ["1","2","3"],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
              formatter: "{value} ",
            },
          },
        ],
        series: [
          {
            name: "目标节能",
            type: "bar",
            data: [1,2,3],
     
          },
         {
            name: "实际节能",
            type: "bar",
            data: [1,2,3],
       
          },
         
        ],
        
      };
       },
       monthlyProportionRate(flag) {
 if(flag==null || flag=="undefined")
             flag=0;
            //change=this.consumptionLevel1VO.powerChangeMonth1;
           // changerate=this.consumptionLevel1VO.powerChangeRateMonth1;
           var value="";
           var change="";
           var changerate="";
           var jyn=0,lhn=0,yxn=0;//l1,加油,l2，良好，l3优秀
           var jy='',lh='',yx='';
           var date = new Date();
           var curmonth=date .getMonth(); 
           // alert(curmonth);
           var dwcz=0,dwmj=0,dwmjd=0,dwmjs=0,dwkt=0,dwrjd=0,dwrjs=0,rjnh=0;
           if(flag==0){
             switch(curmonth){
                case 0:

                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          // {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.totalForecastMonth1,
                      //  "2月": this.performanceLevel1VO.totalForecastMonth2,
                      //   "3月": this.performanceLevel1VO.totalForecastMonth3,
                      //   "4月": this.performanceLevel1VO.totalForecastMonth4,
                      //   "5月": this.performanceLevel1VO.totalForecastMonth5,
                      //    "6月": this.performanceLevel1VO.totalForecastMonth6,
                      //     "7月": this.performanceLevel1VO.totalForecastMonth7,
                      //     "8月": this.performanceLevel1VO.totalForecastMonth8,
                      //     "9月": this.performanceLevel1VO.totalForecastMonth9,
                      //     "10月": this.performanceLevel1VO.totalForecastMonth10,
                      //     "11月": this.performanceLevel1VO.totalForecastMonth11,
                      //     "12月": this.performanceLevel1VO.totalForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performanceLevel1VO.totalEvaluateMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[this.performanceLevel1VO.totalMonth1];//目标值
                  this.totalmonth=this.performanceLevel1VO.totalMonth1;
                  //------统计分类--------
                   dwcz=this.performanceLevel1VO.outputEvaluateMonth1;
                   dwmj=this.performanceLevel1VO.areaenergyEvaluateMonth1;
                   dwmjd=this.performanceLevel1VO.areapowerEvaluateMonth1;
                   dwmjs=this.performanceLevel1VO.areawaterEvaluateMonth1;
                   dwkt=this.performanceLevel1VO.areaairEvaluateMonth1;
                   dwrjd=this.performanceLevel1VO.perpowerEvaluateMonth1;
                   dwrjs=this.performanceLevel1VO.perwaterEvaluateMonth1;
                   rjnh=this.performanceLevel1VO.perEvaluateMonth1;
                   //-1
                     if(dwcz!=null && dwcz=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位产值能耗<br>';
                    }else if(dwcz=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位产值能耗<br>';
                    }else if(dwcz=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位产值能耗<br>';
                    }
                   //-2
                   if(dwmj!=null && dwmj=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积能耗<br>';
                    }else if(dwmj=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积能耗<br>';
                    }else if(dwmj=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积能耗<br>';
                    }
                     //-3
                   if(dwmjd!=null && dwmjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积电耗<br>';
                    }else if(dwmjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积电耗<br>';
                    }else if(dwmjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积电耗<br>';
                    }
                      //-4
                   if(dwmjs!=null && dwmjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积用水<br>';
                    }else if(dwmjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积用水<br>';
                    }else if(dwmjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积用水<br>';
                    }
                   //-5
                   if(dwkt!=null && dwkt=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位空调用电<br>';
                    }else if(dwkt=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位空调用电<br>';
                    }else if(dwkt=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位空调用电<br>';
                    }
                     //-6
                   if(dwrjd!=null && dwrjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'人均能耗<br>';
                    }else if(dwrjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'人均能耗<br>';
                    }else if(dwrjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'人均能耗<br>';
                    }
                    //-7
                   if(dwrjs!=null && dwrjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均电耗<br>';
                    }else if(dwrjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均电耗<br>';
                    }else if(dwrjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均电耗<br>';
                    }
                     //-8
                   if(rjnh!=null && rjnh=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均用水<br>';
                    }else if(rjnh=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均用水<br>';
                    }else if(rjnh=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均用水<br>';
                    }
                   
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.totalForecastMonth1,
                       "2月": this.performanceLevel1VO.totalForecastMonth2,
                        // "3月": this.performanceLevel1VO.totalForecastMonth3,
                        // "4月": this.performanceLevel1VO.totalForecastMonth4,
                        // "5月": this.performanceLevel1VO.totalForecastMonth5,
                        //  "6月": this.performanceLevel1VO.totalForecastMonth6,
                        //   "7月": this.performanceLevel1VO.totalForecastMonth7,
                        //   "8月": this.performanceLevel1VO.totalForecastMonth8,
                        //   "9月": this.performanceLevel1VO.totalForecastMonth9,
                        //   "10月": this.performanceLevel1VO.totalForecastMonth10,
                        //   "11月": this.performanceLevel1VO.totalForecastMonth11,
                        //   "12月": this.performanceLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                             this.performanceLevel1VO.totalMonth2];//目标值
            
                     this.tableData=[{
                        date: '1月',
                        name: this.performanceLevel1VO.totalEvaluateMonth1,
                        //image: require(besturl)
                        }, 
                      {
                        date: '2月',
                        name: this.performanceLevel1VO.totalEvaluateMonth2,
                      // image: require(besturl)
                        }, 
                  ];    
                  this.totalmonth=this.performanceLevel1VO.totalMonth2;
                  //------统计分类--------
                   dwcz=this.performanceLevel1VO.outputEvaluateMonth2;
                   dwmj=this.performanceLevel1VO.areaenergyEvaluateMonth2;
                   dwmjd=this.performanceLevel1VO.areapowerEvaluateMonth2;
                   dwmjs=this.performanceLevel1VO.areawaterEvaluateMonth2;
                   dwkt=this.performanceLevel1VO.areaairEvaluateMonth2;
                   dwrjd=this.performanceLevel1VO.perpowerEvaluateMonth2;
                   dwrjs=this.performanceLevel1VO.perwaterEvaluateMonth2;
                   rjnh=this.performanceLevel1VO.perEvaluateMonth2;
                   //-1
                   if(dwcz!=null && dwcz=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位产值能耗<br>';
                    }else if(dwcz=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位产值能耗<br>';
                    }else if(dwcz=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位产值能耗<br>';
                    }
                   //-2
                   if(dwmj!=null && dwmj=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积能耗<br>';
                    }else if(dwmj=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积能耗<br>';
                    }else if(dwmj=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积能耗<br>';
                    }
                     //-3
                   if(dwmjd!=null && dwmjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积电耗<br>';
                    }else if(dwmjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积电耗<br>';
                    }else if(dwmjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积电耗<br>';
                    }
                      //-4
                   if(dwmjs!=null && dwmjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积用水<br>';
                    }else if(dwmjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积用水<br>';
                    }else if(dwmjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积用水<br>';
                    }
                   //-5
                   if(dwkt!=null && dwkt=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位空调用电<br>';
                    }else if(dwkt=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位空调用电<br>';
                    }else if(dwkt=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位空调用电<br>';
                    }
                     //-6
                   if(dwrjd!=null && dwrjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'人均能耗<br>';
                    }else if(dwrjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'人均能耗<br>';
                    }else if(dwrjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'人均能耗<br>';
                    }
                    //-7
                   if(dwrjs!=null && dwrjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均电耗<br>';
                    }else if(dwrjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均电耗<br>';
                    }else if(dwrjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均电耗<br>';
                    }
                     //-8
                   if(rjnh!=null && rjnh=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均用水<br>';
                    }else if(rjnh=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均用水<br>';
                    }else if(rjnh=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均用水<br>';
                    }
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                   this.rightHeader=[
                       
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                    
                        "4月": this.performanceLevel1VO.totalForecastMonth4,
                        "5月": this.performanceLevel1VO.totalForecastMonth5,
                         "6月": this.performanceLevel1VO.totalForecastMonth6,
                          "7月": this.performanceLevel1VO.totalForecastMonth7,
                          "8月": this.performanceLevel1VO.totalForecastMonth8,
                          "9月": this.performanceLevel1VO.totalForecastMonth9,
                          "10月": this.performanceLevel1VO.totalForecastMonth10,
                          "11月": this.performanceLevel1VO.totalForecastMonth11,
                          "12月": this.performanceLevel1VO.totalForecastMonth12,
                     }
                  ];  this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.totalForecastMonth1,
                       "2月": this.performanceLevel1VO.totalForecastMonth2,
                        "3月": this.performanceLevel1VO.totalForecastMonth3,
                        // "4月": this.performanceLevel1VO.totalForecastMonth4,
                        // "5月": this.performanceLevel1VO.totalForecastMonth5,
                        //  "6月": this.performanceLevel1VO.totalForecastMonth6,
                        //   "7月": this.performanceLevel1VO.totalForecastMonth7,
                        //   "8月": this.performanceLevel1VO.totalForecastMonth8,
                        //   "9月": this.performanceLevel1VO.totalForecastMonth9,
                        //   "10月": this.performanceLevel1VO.totalForecastMonth10,
                        //   "11月": this.performanceLevel1VO.totalForecastMonth11,
                        //   "12月": this.performanceLevel1VO.totalForecastMonth12,
                     }
                  ];
                     this.dataarr=[
                             this.performanceLevel1VO.totalMonth3];//目标值
              
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.totalEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.totalEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.totalEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                       this.totalmonth=this.performanceLevel1VO.totalMonth3;
                       //------统计分类--------
                   dwcz=this.performanceLevel1VO.outputEvaluateMonth3;
                   dwmj=this.performanceLevel1VO.areaenergyEvaluateMonth3;
                   dwmjd=this.performanceLevel1VO.areapowerEvaluateMonth3;
                   dwmjs=this.performanceLevel1VO.areawaterEvaluateMonth3;
                   dwkt=this.performanceLevel1VO.areaairEvaluateMonth3;
                   dwrjd=this.performanceLevel1VO.perpowerEvaluateMonth3;
                   dwrjs=this.performanceLevel1VO.perwaterEvaluateMonth3;
                   rjnh=this.performanceLevel1VO.perEvaluateMonth3;
                   dwkt=this.performanceLevel1VO.areaairEvaluateMonth3;
                  // alert(dwcz+'-'+dwmj+'-'+dwmjd+'-'+dwmjs+'-'+dwrjd);
                   //-1
                    if(dwcz!=null && dwcz=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位产值能耗<br>';
                    }else if(dwcz=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位产值能耗<br>';
                    }else if(dwcz=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位产值能耗<br>';
                    }
                   //-2
                   if(dwmj!=null && dwmj=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积能耗<br>';
                    }else if(dwmj=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积能耗<br>';
                    }else if(dwmj=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积能耗<br>';
                    }
                     //-3
                   if(dwmjd!=null && dwmjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积电耗<br>';
                    }else if(dwmjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积电耗<br>';
                    }else if(dwmjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积电耗<br>';
                    }
                      //-4
                   if(dwmjs!=null && dwmjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积用水<br>';
                    }else if(dwmjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积用水<br>';
                    }else if(dwmjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积用水<br>';
                    }
                   //-5
                   if(dwkt!=null && dwkt=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位空调用电<br>';
                    }else if(dwkt=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位空调用电<br>';
                    }else if(dwkt=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位空调用电<br>';
                    }
                     //-6
                   if(dwrjd!=null && dwrjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'人均能耗<br>';
                    }else if(dwrjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'人均能耗<br>';
                    }else if(dwrjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'人均能耗<br>';
                    }
                    //-7
                   if(dwrjs!=null && dwrjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均电耗<br>';
                    }else if(dwrjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均电耗<br>';
                    }else if(dwrjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均电耗<br>';
                    }
                     //-8
                   if(rjnh!=null && rjnh=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均用水<br>';
                    }else if(rjnh=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均用水<br>';
                    }else if(rjnh=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均用水<br>';
                    }
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.totalForecastMonth1,
                       "2月": this.performanceLevel1VO.totalForecastMonth2,
                        "3月": this.performanceLevel1VO.totalForecastMonth3,
                        "4月": this.performanceLevel1VO.totalForecastMonth4,
                        // "5月": this.performanceLevel1VO.totalForecastMonth5,
                        //  "6月": this.performanceLevel1VO.totalForecastMonth6,
                        //   "7月": this.performanceLevel1VO.totalForecastMonth7,
                        //   "8月": this.performanceLevel1VO.totalForecastMonth8,
                        //   "9月": this.performanceLevel1VO.totalForecastMonth9,
                        //   "10月": this.performanceLevel1VO.totalForecastMonth10,
                        //   "11月": this.performanceLevel1VO.totalForecastMonth11,
                        //   "12月": this.performanceLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              this.performanceLevel1VO.totalMonth4];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.totalEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.totalEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.totalEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.totalEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                       this.totalmonth=this.performanceLevel1VO.totalMonth4;
                    //------统计分类--------
                   dwcz=this.performanceLevel1VO.outputEvaluateMonth4;
                   dwmj=this.performanceLevel1VO.areaenergyEvaluateMonth4;
                   dwmjd=this.performanceLevel1VO.areapowerEvaluateMonth4;
                   dwmjs=this.performanceLevel1VO.areawaterEvaluateMonth4;
                   dwkt=this.performanceLevel1VO.areaairEvaluateMonth4;
                   dwrjd=this.performanceLevel1VO.perpowerEvaluateMonth4;
                   dwrjs=this.performanceLevel1VO.perwaterEvaluateMonth4;
                   rjnh=this.performanceLevel1VO.perEvaluateMonth4;
                   //-1
                    if(dwcz!=null && dwcz=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位产值能耗<br>';
                    }else if(dwcz=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位产值能耗<br>';
                    }else if(dwcz=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位产值能耗<br>';
                    }
                   //-2
                   if(dwmj!=null && dwmj=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积能耗<br>';
                    }else if(dwmj=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积能耗<br>';
                    }else if(dwmj=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积能耗<br>';
                    }
                     //-3
                   if(dwmjd!=null && dwmjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积电耗<br>';
                    }else if(dwmjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积电耗<br>';
                    }else if(dwmjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积电耗<br>';
                    }
                      //-4
                   if(dwmjs!=null && dwmjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积用水<br>';
                    }else if(dwmjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积用水<br>';
                    }else if(dwmjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积用水<br>';
                    }
                   //-5
                   if(dwkt!=null && dwkt=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位空调用电<br>';
                    }else if(dwkt=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位空调用电<br>';
                    }else if(dwkt=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位空调用电<br>';
                    }
                     //-6
                   if(dwrjd!=null && dwrjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'人均能耗<br>';
                    }else if(dwrjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'人均能耗<br>';
                    }else if(dwrjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'人均能耗<br>';
                    }
                    //-7
                   if(dwrjs!=null && dwrjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均电耗<br>';
                    }else if(dwrjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均电耗<br>';
                    }else if(dwrjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均电耗<br>';
                    }
                     //-8
                   if(rjnh!=null && rjnh=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均用水<br>';
                    }else if(rjnh=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均用水<br>';
                    }else if(rjnh=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均用水<br>';
                    }
                   
                    
                             break;
                case 4:  
                 this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.totalForecastMonth1,
                       "2月": this.performanceLevel1VO.totalForecastMonth2,
                        "3月": this.performanceLevel1VO.totalForecastMonth3,
                        "4月": this.performanceLevel1VO.totalForecastMonth4,
                         "5月": this.performanceLevel1VO.totalForecastMonth5,
                        //  "6月": this.performanceLevel1VO.totalForecastMonth6,
                        //   "7月": this.performanceLevel1VO.totalForecastMonth7,
                        //   "8月": this.performanceLevel1VO.totalForecastMonth8,
                        //   "9月": this.performanceLevel1VO.totalForecastMonth9,
                        //   "10月": this.performanceLevel1VO.totalForecastMonth10,
                        //   "11月": this.performanceLevel1VO.totalForecastMonth11,
                        //   "12月": this.performanceLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              this.performanceLevel1VO.totalMonth5];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.totalEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.totalEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.totalEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.totalEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.totalEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                       this.totalmonth=this.performanceLevel1VO.totalMonth5;
                    //------统计分类--------
                   dwcz=this.performanceLevel1VO.outputEvaluateMonth5;
                   dwmj=this.performanceLevel1VO.areaenergyEvaluateMonth5;
                   dwmjd=this.performanceLevel1VO.areapowerEvaluateMonth5;
                   dwmjs=this.performanceLevel1VO.areawaterEvaluateMonth5;
                   dwkt=this.performanceLevel1VO.areaairEvaluateMonth5;
                   dwrjd=this.performanceLevel1VO.perpowerEvaluateMonth5;
                   dwrjs=this.performanceLevel1VO.perwaterEvaluateMonth5;
                   rjnh=this.performanceLevel1VO.perEvaluateMonth5;
                   //-1
                    if(dwcz!=null && dwcz=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位产值能耗<br>';
                    }else if(dwcz=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位产值能耗<br>';
                    }else if(dwcz=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位产值能耗<br>';
                    }
                   //-2
                   if(dwmj!=null && dwmj=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积能耗<br>';
                    }else if(dwmj=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积能耗<br>';
                    }else if(dwmj=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积能耗<br>';
                    }
                     //-3
                   if(dwmjd!=null && dwmjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积电耗<br>';
                    }else if(dwmjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积电耗<br>';
                    }else if(dwmjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积电耗<br>';
                    }
                      //-4
                   if(dwmjs!=null && dwmjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积用水<br>';
                    }else if(dwmjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积用水<br>';
                    }else if(dwmjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积用水<br>';
                    }
                   //-5
                   if(dwkt!=null && dwkt=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位空调用电<br>';
                    }else if(dwkt=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位空调用电<br>';
                    }else if(dwkt=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位空调用电<br>';
                    }
                     //-6
                   if(dwrjd!=null && dwrjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'人均能耗<br>';
                    }else if(dwrjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'人均能耗<br>';
                    }else if(dwrjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'人均能耗<br>';
                    }
                    //-7
                   if(dwrjs!=null && dwrjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均电耗<br>';
                    }else if(dwrjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均电耗<br>';
                    }else if(dwrjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均电耗<br>';
                    }
                     //-8
                   if(rjnh!=null && rjnh=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均用水<br>';
                    }else if(rjnh=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均用水<br>';
                    }else if(rjnh=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均用水<br>';
                    }
                   
                    
                             break;                
                case 5:
                   this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.totalForecastMonth1,
                       "2月": this.performanceLevel1VO.totalForecastMonth2,
                        "3月": this.performanceLevel1VO.totalForecastMonth3,
                        "4月": this.performanceLevel1VO.totalForecastMonth4,
                         "5月": this.performanceLevel1VO.totalForecastMonth5,
                         "6月": this.performanceLevel1VO.totalForecastMonth6,
                        //   "7月": this.performanceLevel1VO.totalForecastMonth7,
                        //   "8月": this.performanceLevel1VO.totalForecastMonth8,
                        //   "9月": this.performanceLevel1VO.totalForecastMonth9,
                        //   "10月": this.performanceLevel1VO.totalForecastMonth10,
                        //   "11月": this.performanceLevel1VO.totalForecastMonth11,
                        //   "12月": this.performanceLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              this.performanceLevel1VO.totalMonth6];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.totalEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.totalEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.totalEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.totalEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.totalEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.totalEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                       this.totalmonth=this.performanceLevel1VO.totalMonth6;
                    //------统计分类--------
                   dwcz=this.performanceLevel1VO.outputEvaluateMonth6;
                   dwmj=this.performanceLevel1VO.areaenergyEvaluateMonth6;
                   dwmjd=this.performanceLevel1VO.areapowerEvaluateMonth6;
                   dwmjs=this.performanceLevel1VO.areawaterEvaluateMonth6;
                   dwkt=this.performanceLevel1VO.areaairEvaluateMonth6;
                   dwrjd=this.performanceLevel1VO.perpowerEvaluateMonth6;
                   dwrjs=this.performanceLevel1VO.perwaterEvaluateMonth6;
                   rjnh=this.performanceLevel1VO.perEvaluateMonth6;
                   //-1
                    if(dwcz!=null && dwcz=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位产值能耗<br>';
                    }else if(dwcz=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位产值能耗<br>';
                    }else if(dwcz=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位产值能耗<br>';
                    }
                   //-2
                   if(dwmj!=null && dwmj=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积能耗<br>';
                    }else if(dwmj=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积能耗<br>';
                    }else if(dwmj=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积能耗<br>';
                    }
                     //-3
                   if(dwmjd!=null && dwmjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积电耗<br>';
                    }else if(dwmjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积电耗<br>';
                    }else if(dwmjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积电耗<br>';
                    }
                      //-4
                   if(dwmjs!=null && dwmjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积用水<br>';
                    }else if(dwmjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积用水<br>';
                    }else if(dwmjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积用水<br>';
                    }
                   //-5
                   if(dwkt!=null && dwkt=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位空调用电<br>';
                    }else if(dwkt=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位空调用电<br>';
                    }else if(dwkt=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位空调用电<br>';
                    }
                     //-6
                   if(dwrjd!=null && dwrjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'人均能耗<br>';
                    }else if(dwrjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'人均能耗<br>';
                    }else if(dwrjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'人均能耗<br>';
                    }
                    //-7
                   if(dwrjs!=null && dwrjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均电耗<br>';
                    }else if(dwrjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均电耗<br>';
                    }else if(dwrjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均电耗<br>';
                    }
                     //-8
                   if(rjnh!=null && rjnh=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均用水<br>';
                    }else if(rjnh=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均用水<br>';
                    }else if(rjnh=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均用水<br>';
                    }
                   
                    
                             break;   
                case 6:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.totalForecastMonth1,
                       "2月": this.performanceLevel1VO.totalForecastMonth2,
                        "3月": this.performanceLevel1VO.totalForecastMonth3,
                        "4月": this.performanceLevel1VO.totalForecastMonth4,
                         "5月": this.performanceLevel1VO.totalForecastMonth5,
                         "6月": this.performanceLevel1VO.totalForecastMonth6,
                          "7月": this.performanceLevel1VO.totalForecastMonth7,
                        //   "8月": this.performanceLevel1VO.totalForecastMonth8,
                        //   "9月": this.performanceLevel1VO.totalForecastMonth9,
                        //   "10月": this.performanceLevel1VO.totalForecastMonth10,
                        //   "11月": this.performanceLevel1VO.totalForecastMonth11,
                        //   "12月": this.performanceLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              this.performanceLevel1VO.totalMonth7];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.totalEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.totalEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.totalEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.totalEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.totalEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.totalEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                            ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.totalEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                       this.totalmonth=this.performanceLevel1VO.totalMonth7;
                    //------统计分类--------
                   dwcz=this.performanceLevel1VO.outputEvaluateMonth7;
                   dwmj=this.performanceLevel1VO.areaenergyEvaluateMonth7;
                   dwmjd=this.performanceLevel1VO.areapowerEvaluateMonth7;
                   dwmjs=this.performanceLevel1VO.areawaterEvaluateMonth7;
                   dwkt=this.performanceLevel1VO.areaairEvaluateMonth7;
                   dwrjd=this.performanceLevel1VO.perpowerEvaluateMonth7;
                   dwrjs=this.performanceLevel1VO.perwaterEvaluateMonth7;
                   rjnh=this.performanceLevel1VO.perEvaluateMonth7;
                   //-1
                    if(dwcz!=null && dwcz=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位产值能耗<br>';
                    }else if(dwcz=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位产值能耗<br>';
                    }else if(dwcz=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位产值能耗<br>';
                    }
                   //-2
                   if(dwmj!=null && dwmj=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积能耗<br>';
                    }else if(dwmj=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积能耗<br>';
                    }else if(dwmj=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积能耗<br>';
                    }
                     //-3
                   if(dwmjd!=null && dwmjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积电耗<br>';
                    }else if(dwmjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积电耗<br>';
                    }else if(dwmjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积电耗<br>';
                    }
                      //-4
                   if(dwmjs!=null && dwmjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积用水<br>';
                    }else if(dwmjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积用水<br>';
                    }else if(dwmjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积用水<br>';
                    }
                   //-5
                   if(dwkt!=null && dwkt=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位空调用电<br>';
                    }else if(dwkt=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位空调用电<br>';
                    }else if(dwkt=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位空调用电<br>';
                    }
                     //-6
                   if(dwrjd!=null && dwrjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'人均能耗<br>';
                    }else if(dwrjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'人均能耗<br>';
                    }else if(dwrjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'人均能耗<br>';
                    }
                    //-7
                   if(dwrjs!=null && dwrjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均电耗<br>';
                    }else if(dwrjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均电耗<br>';
                    }else if(dwrjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均电耗<br>';
                    }
                     //-8
                   if(rjnh!=null && rjnh=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均用水<br>';
                    }else if(rjnh=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均用水<br>';
                    }else if(rjnh=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均用水<br>';
                    }
                   
                    
                             break;   
                case 7: 
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.totalForecastMonth1,
                       "2月": this.performanceLevel1VO.totalForecastMonth2,
                        "3月": this.performanceLevel1VO.totalForecastMonth3,
                        "4月": this.performanceLevel1VO.totalForecastMonth4,
                         "5月": this.performanceLevel1VO.totalForecastMonth5,
                         "6月": this.performanceLevel1VO.totalForecastMonth6,
                          "7月": this.performanceLevel1VO.totalForecastMonth7,
                           "8月": this.performanceLevel1VO.totalForecastMonth8,
                        //   "9月": this.performanceLevel1VO.totalForecastMonth9,
                        //   "10月": this.performanceLevel1VO.totalForecastMonth10,
                        //   "11月": this.performanceLevel1VO.totalForecastMonth11,
                        //   "12月": this.performanceLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              this.performanceLevel1VO.totalMonth8];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.totalEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.totalEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.totalEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.totalEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.totalEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.totalEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                            ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.totalEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.totalEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                       this.totalmonth=this.performanceLevel1VO.totalMonth8;
                    //------统计分类--------
                   dwcz=this.performanceLevel1VO.outputEvaluateMonth8;
                   dwmj=this.performanceLevel1VO.areaenergyEvaluateMonth8;
                   dwmjd=this.performanceLevel1VO.areapowerEvaluateMonth8;
                   dwmjs=this.performanceLevel1VO.areawaterEvaluateMonth8;
                   dwkt=this.performanceLevel1VO.areaairEvaluateMonth8;
                   dwrjd=this.performanceLevel1VO.perpowerEvaluateMonth8;
                   dwrjs=this.performanceLevel1VO.perwaterEvaluateMonth8;
                   rjnh=this.performanceLevel1VO.perEvaluateMonth8;
                   //-1
                    if(dwcz!=null && dwcz=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位产值能耗<br>';
                    }else if(dwcz=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位产值能耗<br>';
                    }else if(dwcz=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位产值能耗<br>';
                    }
                   //-2
                   if(dwmj!=null && dwmj=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积能耗<br>';
                    }else if(dwmj=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积能耗<br>';
                    }else if(dwmj=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积能耗<br>';
                    }
                     //-3
                   if(dwmjd!=null && dwmjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积电耗<br>';
                    }else if(dwmjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积电耗<br>';
                    }else if(dwmjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积电耗<br>';
                    }
                      //-4
                   if(dwmjs!=null && dwmjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积用水<br>';
                    }else if(dwmjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积用水<br>';
                    }else if(dwmjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积用水<br>';
                    }
                   //-5
                   if(dwkt!=null && dwkt=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位空调用电<br>';
                    }else if(dwkt=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位空调用电<br>';
                    }else if(dwkt=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位空调用电<br>';
                    }
                     //-6
                   if(dwrjd!=null && dwrjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'人均能耗<br>';
                    }else if(dwrjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'人均能耗<br>';
                    }else if(dwrjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'人均能耗<br>';
                    }
                    //-7
                   if(dwrjs!=null && dwrjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均电耗<br>';
                    }else if(dwrjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均电耗<br>';
                    }else if(dwrjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均电耗<br>';
                    }
                     //-8
                   if(rjnh!=null && rjnh=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均用水<br>';
                    }else if(rjnh=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均用水<br>';
                    }else if(rjnh=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均用水<br>';
                    }
                   
                    
                             break;   
                case 8:
                   this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.totalForecastMonth1,
                       "2月": this.performanceLevel1VO.totalForecastMonth2,
                        "3月": this.performanceLevel1VO.totalForecastMonth3,
                        "4月": this.performanceLevel1VO.totalForecastMonth4,
                         "5月": this.performanceLevel1VO.totalForecastMonth5,
                         "6月": this.performanceLevel1VO.totalForecastMonth6,
                          "7月": this.performanceLevel1VO.totalForecastMonth7,
                           "8月": this.performanceLevel1VO.totalForecastMonth8,
                           "9月": this.performanceLevel1VO.totalForecastMonth9,
                        //   "10月": this.performanceLevel1VO.totalForecastMonth10,
                        //   "11月": this.performanceLevel1VO.totalForecastMonth11,
                        //   "12月": this.performanceLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              this.performanceLevel1VO.totalMonth9];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.totalEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.totalEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.totalEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.totalEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.totalEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.totalEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                            ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.totalEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.totalEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.totalEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                       this.totalmonth=this.performanceLevel1VO.totalMonth9;
                    //------统计分类--------
                   dwcz=this.performanceLevel1VO.outputEvaluateMonth9;
                   dwmj=this.performanceLevel1VO.areaenergyEvaluateMonth9;
                   dwmjd=this.performanceLevel1VO.areapowerEvaluateMonth9;
                   dwmjs=this.performanceLevel1VO.areawaterEvaluateMonth9;
                   dwkt=this.performanceLevel1VO.areaairEvaluateMonth9;
                   dwrjd=this.performanceLevel1VO.perpowerEvaluateMonth9;
                   dwrjs=this.performanceLevel1VO.perwaterEvaluateMonth9;
                   rjnh=this.performanceLevel1VO.perEvaluateMonth9;
                   //-1
                    if(dwcz!=null && dwcz=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位产值能耗<br>';
                    }else if(dwcz=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位产值能耗<br>';
                    }else if(dwcz=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位产值能耗<br>';
                    }
                   //-2
                   if(dwmj!=null && dwmj=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积能耗<br>';
                    }else if(dwmj=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积能耗<br>';
                    }else if(dwmj=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积能耗<br>';
                    }
                     //-3
                   if(dwmjd!=null && dwmjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积电耗<br>';
                    }else if(dwmjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积电耗<br>';
                    }else if(dwmjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积电耗<br>';
                    }
                      //-4
                   if(dwmjs!=null && dwmjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积用水<br>';
                    }else if(dwmjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积用水<br>';
                    }else if(dwmjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积用水<br>';
                    }
                   //-5
                   if(dwkt!=null && dwkt=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位空调用电<br>';
                    }else if(dwkt=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位空调用电<br>';
                    }else if(dwkt=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位空调用电<br>';
                    }
                     //-6
                   if(dwrjd!=null && dwrjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'人均能耗<br>';
                    }else if(dwrjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'人均能耗<br>';
                    }else if(dwrjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'人均能耗<br>';
                    }
                    //-7
                   if(dwrjs!=null && dwrjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均电耗<br>';
                    }else if(dwrjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均电耗<br>';
                    }else if(dwrjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均电耗<br>';
                    }
                     //-8
                   if(rjnh!=null && rjnh=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均用水<br>';
                    }else if(rjnh=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均用水<br>';
                    }else if(rjnh=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均用水<br>';
                    }
                   
                    
                             break;   
                case 9:
                   this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.totalForecastMonth1,
                       "2月": this.performanceLevel1VO.totalForecastMonth2,
                        "3月": this.performanceLevel1VO.totalForecastMonth3,
                        "4月": this.performanceLevel1VO.totalForecastMonth4,
                         "5月": this.performanceLevel1VO.totalForecastMonth5,
                         "6月": this.performanceLevel1VO.totalForecastMonth6,
                          "7月": this.performanceLevel1VO.totalForecastMonth7,
                           "8月": this.performanceLevel1VO.totalForecastMonth8,
                           "9月": this.performanceLevel1VO.totalForecastMonth9,
                           "10月": this.performanceLevel1VO.totalForecastMonth10,
                        //   "11月": this.performanceLevel1VO.totalForecastMonth11,
                        //   "12月": this.performanceLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              this.performanceLevel1VO.totalMonth10];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.totalEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.totalEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.totalEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.totalEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.totalEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.totalEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                            ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.totalEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.totalEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.totalEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.totalEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                       this.totalmonth=this.performanceLevel1VO.totalMonth10;
                    //------统计分类--------
                   dwcz=this.performanceLevel1VO.outputEvaluateMonth10;
                   dwmj=this.performanceLevel1VO.areaenergyEvaluateMonth10;
                   dwmjd=this.performanceLevel1VO.areapowerEvaluateMonth10;
                   dwmjs=this.performanceLevel1VO.areawaterEvaluateMonth10;
                   dwkt=this.performanceLevel1VO.areaairEvaluateMonth10;
                   dwrjd=this.performanceLevel1VO.perpowerEvaluateMonth10;
                   dwrjs=this.performanceLevel1VO.perwaterEvaluateMonth10;
                   rjnh=this.performanceLevel1VO.perEvaluateMonth10;
                   //-1
                    if(dwcz!=null && dwcz=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位产值能耗<br>';
                    }else if(dwcz=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位产值能耗<br>';
                    }else if(dwcz=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位产值能耗<br>';
                    }
                   //-2
                   if(dwmj!=null && dwmj=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积能耗<br>';
                    }else if(dwmj=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积能耗<br>';
                    }else if(dwmj=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积能耗<br>';
                    }
                     //-3
                   if(dwmjd!=null && dwmjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积电耗<br>';
                    }else if(dwmjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积电耗<br>';
                    }else if(dwmjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积电耗<br>';
                    }
                      //-4
                   if(dwmjs!=null && dwmjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积用水<br>';
                    }else if(dwmjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积用水<br>';
                    }else if(dwmjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积用水<br>';
                    }
                   //-5
                   if(dwkt!=null && dwkt=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位空调用电<br>';
                    }else if(dwkt=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位空调用电<br>';
                    }else if(dwkt=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位空调用电<br>';
                    }
                     //-6
                   if(dwrjd!=null && dwrjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'人均能耗<br>';
                    }else if(dwrjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'人均能耗<br>';
                    }else if(dwrjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'人均能耗<br>';
                    }
                    //-7
                   if(dwrjs!=null && dwrjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均电耗<br>';
                    }else if(dwrjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均电耗<br>';
                    }else if(dwrjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均电耗<br>';
                    }
                     //-8
                   if(rjnh!=null && rjnh=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均用水<br>';
                    }else if(rjnh=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均用水<br>';
                    }else if(rjnh=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均用水<br>';
                    }
                   
                    
                             break;   
                case 10:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.totalForecastMonth1,
                       "2月": this.performanceLevel1VO.totalForecastMonth2,
                        "3月": this.performanceLevel1VO.totalForecastMonth3,
                        "4月": this.performanceLevel1VO.totalForecastMonth4,
                         "5月": this.performanceLevel1VO.totalForecastMonth5,
                         "6月": this.performanceLevel1VO.totalForecastMonth6,
                          "7月": this.performanceLevel1VO.totalForecastMonth7,
                           "8月": this.performanceLevel1VO.totalForecastMonth8,
                           "9月": this.performanceLevel1VO.totalForecastMonth9,
                           "10月": this.performanceLevel1VO.totalForecastMonth10,
                          "11月": this.performanceLevel1VO.totalForecastMonth11,
                        //   "12月": this.performanceLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              this.performanceLevel1VO.totalMonth11];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.totalEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.totalEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.totalEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.totalEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.totalEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.totalEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                            ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.totalEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.totalEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.totalEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.totalEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.totalEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                       this.totalmonth=this.performanceLevel1VO.totalMonth11;
                    //------统计分类--------
                   dwcz=this.performanceLevel1VO.outputEvaluateMonth11;
                   dwmj=this.performanceLevel1VO.areaenergyEvaluateMonth11;
                   dwmjd=this.performanceLevel1VO.areapowerEvaluateMonth11;
                   dwmjs=this.performanceLevel1VO.areawaterEvaluateMonth11;
                   dwkt=this.performanceLevel1VO.areaairEvaluateMonth11;
                   dwrjd=this.performanceLevel1VO.perpowerEvaluateMonth11;
                   dwrjs=this.performanceLevel1VO.perwaterEvaluateMonth11;
                   rjnh=this.performanceLevel1VO.perEvaluateMonth11;
                   //-1
                    if(dwcz!=null && dwcz=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位产值能耗<br>';
                    }else if(dwcz=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位产值能耗<br>';
                    }else if(dwcz=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位产值能耗<br>';
                    }
                   //-2
                   if(dwmj!=null && dwmj=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积能耗<br>';
                    }else if(dwmj=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积能耗<br>';
                    }else if(dwmj=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积能耗<br>';
                    }
                     //-3
                   if(dwmjd!=null && dwmjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积电耗<br>';
                    }else if(dwmjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积电耗<br>';
                    }else if(dwmjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积电耗<br>';
                    }
                      //-4
                   if(dwmjs!=null && dwmjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积用水<br>';
                    }else if(dwmjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积用水<br>';
                    }else if(dwmjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积用水<br>';
                    }
                   //-5
                   if(dwkt!=null && dwkt=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位空调用电<br>';
                    }else if(dwkt=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位空调用电<br>';
                    }else if(dwkt=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位空调用电<br>';
                    }
                     //-6
                   if(dwrjd!=null && dwrjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'人均能耗<br>';
                    }else if(dwrjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'人均能耗<br>';
                    }else if(dwrjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'人均能耗<br>';
                    }
                    //-7
                   if(dwrjs!=null && dwrjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均电耗<br>';
                    }else if(dwrjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均电耗<br>';
                    }else if(dwrjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均电耗<br>';
                    }
                     //-8
                   if(rjnh!=null && rjnh=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均用水<br>';
                    }else if(rjnh=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均用水<br>';
                    }else if(rjnh=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均用水<br>';
                    }
                   
                    
                             break;   
                case 11:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.totalForecastMonth1,
                       "2月": this.performanceLevel1VO.totalForecastMonth2,
                        "3月": this.performanceLevel1VO.totalForecastMonth3,
                        "4月": this.performanceLevel1VO.totalForecastMonth4,
                         "5月": this.performanceLevel1VO.totalForecastMonth5,
                         "6月": this.performanceLevel1VO.totalForecastMonth6,
                          "7月": this.performanceLevel1VO.totalForecastMonth7,
                           "8月": this.performanceLevel1VO.totalForecastMonth8,
                           "9月": this.performanceLevel1VO.totalForecastMonth9,
                           "10月": this.performanceLevel1VO.totalForecastMonth10,
                          "11月": this.performanceLevel1VO.totalForecastMonth11,
                          "12月": this.performanceLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              this.performanceLevel1VO.totalMonth12];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.totalEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.totalEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.totalEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.totalEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.totalEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.totalEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                            ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.totalEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.totalEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.totalEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.totalEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.totalEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '12月',
                            name: this.performanceLevel1VO.totalEvaluateMonth12,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                       this.totalmonth=this.performanceLevel1VO.totalMonth12;
                    //------统计分类--------
                   dwcz=this.performanceLevel1VO.outputEvaluateMonth12;
                   dwmj=this.performanceLevel1VO.areaenergyEvaluateMonth12;
                   dwmjd=this.performanceLevel1VO.areapowerEvaluateMonth12;
                   dwmjs=this.performanceLevel1VO.areawaterEvaluateMonth12;
                   dwkt=this.performanceLevel1VO.areaairEvaluateMonth12;
                   dwrjd=this.performanceLevel1VO.perpowerEvaluateMonth12;
                   dwrjs=this.performanceLevel1VO.perwaterEvaluateMonth12;
                   rjnh=this.performanceLevel1VO.perEvaluateMonth12;
                   //-1
                    if(dwcz!=null && dwcz=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位产值能耗<br>';
                    }else if(dwcz=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位产值能耗<br>';
                    }else if(dwcz=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位产值能耗<br>';
                    }
                   //-2
                   if(dwmj!=null && dwmj=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积能耗<br>';
                    }else if(dwmj=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积能耗<br>';
                    }else if(dwmj=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积能耗<br>';
                    }
                     //-3
                   if(dwmjd!=null && dwmjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积电耗<br>';
                    }else if(dwmjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积电耗<br>';
                    }else if(dwmjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积电耗<br>';
                    }
                      //-4
                   if(dwmjs!=null && dwmjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位面积用水<br>';
                    }else if(dwmjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位面积用水<br>';
                    }else if(dwmjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位面积用水<br>';
                    }
                   //-5
                   if(dwkt!=null && dwkt=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位空调用电<br>';
                    }else if(dwkt=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位空调用电<br>';
                    }else if(dwkt=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位空调用电<br>';
                    }
                     //-6
                   if(dwrjd!=null && dwrjd=="加油"){
                      jyn=jyn+1;
                      jy=jy+'人均能耗<br>';
                    }else if(dwrjd=="良好"){
                      lhn=lhn+1;
                      lh=lh+'人均能耗<br>';
                    }else if(dwrjd=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'人均能耗<br>';
                    }
                    //-7
                   if(dwrjs!=null && dwrjs=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均电耗<br>';
                    }else if(dwrjs=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均电耗<br>';
                    }else if(dwrjs=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均电耗<br>';
                    }
                     //-8
                   if(rjnh!=null && rjnh=="加油"){
                      jyn=jyn+1;
                      jy=jy+'单位人均用水<br>';
                    }else if(rjnh=="良好"){
                      lhn=lhn+1;
                      lh=lh+'单位人均用水<br>';
                    }else if(rjnh=="优秀"){
                      yxn=yxn+1;
                      yx=yx+'单位人均用水<br>';
                    }
                   
                    
                             break;   

             }
            // dataarr=
          };
  

   
      return {
                  
          title: {
              text: "",
        
                textStyle: {
                  fontSize: 16,
                  color: "#000",
                  fontWeight: "bolder",
                },
             },
             
           tooltip: {
             trigger: 'item',
        //formatter: '{a} <br/>{b} : {c} ({d}%)'
          //         trigger: 'axis',
                show: true,
                  formatter: function (params) {
                        //console.log(params);
                              // const item = params[0];
                              // var color = params.color;//图例颜色
                              var value = params.data.tip;
                            return value; 
                      }
                    },

 
    series: [
        {
            name: '',
            type: 'pie',
            radius: '90%',
            data: [
                {value: 3, name: '加油('+jyn+')',tip: jy},
                {value: 2, name: '优秀('+yxn+')',tip: yx},
                {value: 1, name: '良好('+lhn+')',tip: lh},
            
            ],
                label: {
                normal: {
                    show: true,
                    position: 'inner',
                    textStyle: {
                            color: '#fff',
                            fontSize: 15,
                        }
                }
            },
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
      };
    },
      monthlyProportionRate3(flag) {
 if(flag==null || flag=="undefined")
             flag=0;
            //change=this.consumptionLevel1VO.powerChangeMonth1;
           // changerate=this.consumptionLevel1VO.powerChangeRateMonth1;
           var value="";
           var change="";
           var changerate="";
           var l1=0,l2=0,l3=0,l4=0;
           var date = new Date();
           var curmonth=date .getMonth(); 
          // alert(flag);
            if(flag==1){
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                          //   {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.outputForecastMonth1,
                        // "2月": this.performanceLevel1VO.outputForecastMonth2,
                        // "3月": this.performanceLevel1VO.outputForecastMonth3,
                        // "4月": this.performanceLevel1VO.outputForecastMonth4,
                        // "5月": this.performanceLevel1VO.outputForecastMonth5,
                        //  "6月": this.performanceLevel1VO.outputForecastMonth6,
                        //   "7月": this.performanceLevel1VO.outputForecastMonth7,
                        //   "8月": this.performanceLevel1VO.outputForecastMonth8,
                        //   "9月": this.performanceLevel1VO.outputForecastMonth9,
                        //   "10月": this.performanceLevel1VO.outputForecastMonth10,
                        //   "11月": this.performanceLevel1VO.outputForecastMonth11,
                        //   "12月": this.performanceLevel1VO.outputForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performanceLevel1VO.outputEvaluateMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=
                   [{ value: this.performanceLevel1VO.outputMonth1,month:1, change: this.performanceLevel1VO.outputChangeMonth1,changerate:this.performanceLevel1VO.outputChangeRateMonth1 }];
                         
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.outputForecastMonth1,
                        "2月": this.performanceLevel1VO.outputForecastMonth2,
                        // "3月": this.performanceLevel1VO.outputForecastMonth3,
                        // "4月": this.performanceLevel1VO.outputForecastMonth4,
                        // "5月": this.performanceLevel1VO.outputForecastMonth5,
                        //  "6月": this.performanceLevel1VO.outputForecastMonth6,
                        //   "7月": this.performanceLevel1VO.outputForecastMonth7,
                        //   "8月": this.performanceLevel1VO.outputForecastMonth8,
                        //   "9月": this.performanceLevel1VO.outputForecastMonth9,
                        //   "10月": this.performanceLevel1VO.outputForecastMonth10,
                        //   "11月": this.performanceLevel1VO.outputForecastMonth11,
                        //   "12月": this.performanceLevel1VO.outputForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                             { value: this.performanceLevel1VO.outputMonth1,month:1, change: this.performanceLevel1VO.outputChangeMonth1,changerate:this.performanceLevel1VO.outputChangeRateMonth1 },
                             { value: this.performanceLevel1VO.outputMonth2,month:2, change: this.performanceLevel1VO.outputChangeMonth2,changerate:this.performanceLevel1VO.outputChangeRateMonth2 },
                   
                   ];//目标值
            
                     this.tableData=[{
                        date: '1月',
                        name: this.performanceLevel1VO.outputEvaluateMonth1,
                        //image: require(besturl)
                        }, 
                      {
                        date: '2月',
                        name: this.performanceLevel1VO.outputEvaluateMonth2,
                      // image: require(besturl)
                        }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.outputForecastMonth1,
                        "2月": this.performanceLevel1VO.outputForecastMonth2,
                        "3月": this.performanceLevel1VO.outputForecastMonth3,
                        // "4月": this.performanceLevel1VO.outputForecastMonth4,
                        // "5月": this.performanceLevel1VO.outputForecastMonth5,
                        //  "6月": this.performanceLevel1VO.outputForecastMonth6,
                        //   "7月": this.performanceLevel1VO.outputForecastMonth7,
                        //   "8月": this.performanceLevel1VO.outputForecastMonth8,
                        //   "9月": this.performanceLevel1VO.outputForecastMonth9,
                        //   "10月": this.performanceLevel1VO.outputForecastMonth10,
                        //   "11月": this.performanceLevel1VO.outputForecastMonth11,
                        //   "12月": this.performanceLevel1VO.outputForecastMonth12,
                     }
                  ];
                     this.dataarr=[
                             { value: this.performanceLevel1VO.outputMonth1,month:1, change: this.performanceLevel1VO.outputChangeMonth1,changerate:this.performanceLevel1VO.outputChangeRateMonth1 },
                             { value: this.performanceLevel1VO.outputMonth2,month:2, change: this.performanceLevel1VO.outputChangeMonth2,changerate:this.performanceLevel1VO.outputChangeRateMonth2 },
                             { value: this.performanceLevel1VO.outputMonth3,month:3, change: this.performanceLevel1VO.outputChangeMonth3,changerate:this.performanceLevel1VO.outputChangeRateMonth3 },
                   
                             
                             ];//目标值
              
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.outputEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.outputEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.outputEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.outputForecastMonth1,
                        "2月": this.performanceLevel1VO.outputForecastMonth2,
                        "3月": this.performanceLevel1VO.outputForecastMonth3,
                        "4月": this.performanceLevel1VO.outputForecastMonth4,
                        // "5月": this.performanceLevel1VO.outputForecastMonth5,
                        //  "6月": this.performanceLevel1VO.outputForecastMonth6,
                        //   "7月": this.performanceLevel1VO.outputForecastMonth7,
                        //   "8月": this.performanceLevel1VO.outputForecastMonth8,
                        //   "9月": this.performanceLevel1VO.outputForecastMonth9,
                        //   "10月": this.performanceLevel1VO.outputForecastMonth10,
                        //   "11月": this.performanceLevel1VO.outputForecastMonth11,
                        //   "12月": this.performanceLevel1VO.outputForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.outputMonth1,month:1, change: this.performanceLevel1VO.outputChangeMonth1,changerate:this.performanceLevel1VO.outputChangeRateMonth1 },
                             { value: this.performanceLevel1VO.outputMonth2,month:2, change: this.performanceLevel1VO.outputChangeMonth2,changerate:this.performanceLevel1VO.outputChangeRateMonth2 },
                             { value: this.performanceLevel1VO.outputMonth3,month:3, change: this.performanceLevel1VO.outputChangeMonth3,changerate:this.performanceLevel1VO.outputChangeRateMonth3 },
                             { value: this.performanceLevel1VO.outputMonth4,month:4, change: this.performanceLevel1VO.outputChangeMonth4,changerate:this.performanceLevel1VO.outputChangeRateMonth4 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.outputEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.outputEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.outputEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.outputEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
                case 4:   
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.outputForecastMonth1,
                        "2月": this.performanceLevel1VO.outputForecastMonth2,
                        "3月": this.performanceLevel1VO.outputForecastMonth3,
                        "4月": this.performanceLevel1VO.outputForecastMonth4,
                        "5月": this.performanceLevel1VO.outputForecastMonth5,
                        //  "6月": this.performanceLevel1VO.outputForecastMonth6,
                        //   "7月": this.performanceLevel1VO.outputForecastMonth7,
                        //   "8月": this.performanceLevel1VO.outputForecastMonth8,
                        //   "9月": this.performanceLevel1VO.outputForecastMonth9,
                        //   "10月": this.performanceLevel1VO.outputForecastMonth10,
                        //   "11月": this.performanceLevel1VO.outputForecastMonth11,
                        //   "12月": this.performanceLevel1VO.outputForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.outputMonth1,month:1, change: this.performanceLevel1VO.outputChangeMonth1,changerate:this.performanceLevel1VO.outputChangeRateMonth1 },
                             { value: this.performanceLevel1VO.outputMonth2,month:2, change: this.performanceLevel1VO.outputChangeMonth2,changerate:this.performanceLevel1VO.outputChangeRateMonth2 },
                             { value: this.performanceLevel1VO.outputMonth3,month:3, change: this.performanceLevel1VO.outputChangeMonth3,changerate:this.performanceLevel1VO.outputChangeRateMonth3 },
                             { value: this.performanceLevel1VO.outputMonth4,month:4, change: this.performanceLevel1VO.outputChangeMonth4,changerate:this.performanceLevel1VO.outputChangeRateMonth4 },
                             { value: this.performanceLevel1VO.outputMonth5,month:5, change: this.performanceLevel1VO.outputChangeMonth5,changerate:this.performanceLevel1VO.outputChangeRateMonth5 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.outputEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.outputEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.outputEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.outputEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.outputEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;               
                case 5:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.outputForecastMonth1,
                        "2月": this.performanceLevel1VO.outputForecastMonth2,
                        "3月": this.performanceLevel1VO.outputForecastMonth3,
                        "4月": this.performanceLevel1VO.outputForecastMonth4,
                        "5月": this.performanceLevel1VO.outputForecastMonth5,
                         "6月": this.performanceLevel1VO.outputForecastMonth6,
                          // "7月": this.performanceLevel1VO.outputForecastMonth7,
                          // "8月": this.performanceLevel1VO.outputForecastMonth8,
                          // "9月": this.performanceLevel1VO.outputForecastMonth9,
                          // "10月": this.performanceLevel1VO.outputForecastMonth10,
                          // "11月": this.performanceLevel1VO.outputForecastMonth11,
                          // "12月": this.performanceLevel1VO.outputForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.outputMonth1,month:1, change: this.performanceLevel1VO.outputChangeMonth1,changerate:this.performanceLevel1VO.outputChangeRateMonth1 },
                             { value: this.performanceLevel1VO.outputMonth2,month:2, change: this.performanceLevel1VO.outputChangeMonth2,changerate:this.performanceLevel1VO.outputChangeRateMonth2 },
                             { value: this.performanceLevel1VO.outputMonth3,month:3, change: this.performanceLevel1VO.outputChangeMonth3,changerate:this.performanceLevel1VO.outputChangeRateMonth3 },
                             { value: this.performanceLevel1VO.outputMonth4,month:4, change: this.performanceLevel1VO.outputChangeMonth4,changerate:this.performanceLevel1VO.outputChangeRateMonth4 },
                             { value: this.performanceLevel1VO.outputMonth5,month:5, change: this.performanceLevel1VO.outputChangeMonth5,changerate:this.performanceLevel1VO.outputChangeRateMonth5 },
                      { value: this.performanceLevel1VO.outputMonth6,month:6, change: this.performanceLevel1VO.outputChangeMonth6,changerate:this.performanceLevel1VO.outputChangeRateMonth6 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.outputEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.outputEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.outputEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.outputEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.outputEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.outputEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 6:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.outputForecastMonth1,
                        "2月": this.performanceLevel1VO.outputForecastMonth2,
                        "3月": this.performanceLevel1VO.outputForecastMonth3,
                        "4月": this.performanceLevel1VO.outputForecastMonth4,
                        "5月": this.performanceLevel1VO.outputForecastMonth5,
                         "6月": this.performanceLevel1VO.outputForecastMonth6,
                          "7月": this.performanceLevel1VO.outputForecastMonth7,
                          // "8月": this.performanceLevel1VO.outputForecastMonth8,
                          // "9月": this.performanceLevel1VO.outputForecastMonth9,
                          // "10月": this.performanceLevel1VO.outputForecastMonth10,
                          // "11月": this.performanceLevel1VO.outputForecastMonth11,
                          // "12月": this.performanceLevel1VO.outputForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.outputMonth1,month:1, change: this.performanceLevel1VO.outputChangeMonth1,changerate:this.performanceLevel1VO.outputChangeRateMonth1 },
                             { value: this.performanceLevel1VO.outputMonth2,month:2, change: this.performanceLevel1VO.outputChangeMonth2,changerate:this.performanceLevel1VO.outputChangeRateMonth2 },
                             { value: this.performanceLevel1VO.outputMonth3,month:3, change: this.performanceLevel1VO.outputChangeMonth3,changerate:this.performanceLevel1VO.outputChangeRateMonth3 },
                             { value: this.performanceLevel1VO.outputMonth4,month:4, change: this.performanceLevel1VO.outputChangeMonth4,changerate:this.performanceLevel1VO.outputChangeRateMonth4 },
                             { value: this.performanceLevel1VO.outputMonth5,month:5, change: this.performanceLevel1VO.outputChangeMonth5,changerate:this.performanceLevel1VO.outputChangeRateMonth5 },
                      { value: this.performanceLevel1VO.outputMonth6,month:6, change: this.performanceLevel1VO.outputChangeMonth6,changerate:this.performanceLevel1VO.outputChangeRateMonth6 },
                     { value: this.performanceLevel1VO.outputMonth7,month:7, change: this.performanceLevel1VO.outputChangeMonth7,changerate:this.performanceLevel1VO.outputChangeRateMonth7 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.outputEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.outputEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.outputEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.outputEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.outputEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.outputEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.outputEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 7: 
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.outputForecastMonth1,
                        "2月": this.performanceLevel1VO.outputForecastMonth2,
                        "3月": this.performanceLevel1VO.outputForecastMonth3,
                        "4月": this.performanceLevel1VO.outputForecastMonth4,
                        "5月": this.performanceLevel1VO.outputForecastMonth5,
                         "6月": this.performanceLevel1VO.outputForecastMonth6,
                          "7月": this.performanceLevel1VO.outputForecastMonth7,
                          "8月": this.performanceLevel1VO.outputForecastMonth8,
                          // "9月": this.performanceLevel1VO.outputForecastMonth9,
                          // "10月": this.performanceLevel1VO.outputForecastMonth10,
                          // "11月": this.performanceLevel1VO.outputForecastMonth11,
                          // "12月": this.performanceLevel1VO.outputForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.outputMonth1,month:1, change: this.performanceLevel1VO.outputChangeMonth1,changerate:this.performanceLevel1VO.outputChangeRateMonth1 },
                             { value: this.performanceLevel1VO.outputMonth2,month:2, change: this.performanceLevel1VO.outputChangeMonth2,changerate:this.performanceLevel1VO.outputChangeRateMonth2 },
                             { value: this.performanceLevel1VO.outputMonth3,month:3, change: this.performanceLevel1VO.outputChangeMonth3,changerate:this.performanceLevel1VO.outputChangeRateMonth3 },
                             { value: this.performanceLevel1VO.outputMonth4,month:4, change: this.performanceLevel1VO.outputChangeMonth4,changerate:this.performanceLevel1VO.outputChangeRateMonth4 },
                             { value: this.performanceLevel1VO.outputMonth5,month:5, change: this.performanceLevel1VO.outputChangeMonth5,changerate:this.performanceLevel1VO.outputChangeRateMonth5 },
                      { value: this.performanceLevel1VO.outputMonth6,month:6, change: this.performanceLevel1VO.outputChangeMonth6,changerate:this.performanceLevel1VO.outputChangeRateMonth6 },
                     { value: this.performanceLevel1VO.outputMonth7,month:7, change: this.performanceLevel1VO.outputChangeMonth7,changerate:this.performanceLevel1VO.outputChangeRateMonth7 },
                   { value: this.performanceLevel1VO.outputMonth8,month:8, change: this.performanceLevel1VO.outputChangeMonth8,changerate:this.performanceLevel1VO.outputChangeRateMonth8 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.outputEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.outputEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.outputEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.outputEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.outputEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.outputEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.outputEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.outputEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 8:
                        // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.outputForecastMonth1,
                        "2月": this.performanceLevel1VO.outputForecastMonth2,
                        "3月": this.performanceLevel1VO.outputForecastMonth3,
                        "4月": this.performanceLevel1VO.outputForecastMonth4,
                        "5月": this.performanceLevel1VO.outputForecastMonth5,
                         "6月": this.performanceLevel1VO.outputForecastMonth6,
                          "7月": this.performanceLevel1VO.outputForecastMonth7,
                          "8月": this.performanceLevel1VO.outputForecastMonth8,
                          "9月": this.performanceLevel1VO.outputForecastMonth9,
                          // "10月": this.performanceLevel1VO.outputForecastMonth10,
                          // "11月": this.performanceLevel1VO.outputForecastMonth11,
                          // "12月": this.performanceLevel1VO.outputForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.outputMonth1,month:1, change: this.performanceLevel1VO.outputChangeMonth1,changerate:this.performanceLevel1VO.outputChangeRateMonth1 },
                             { value: this.performanceLevel1VO.outputMonth2,month:2, change: this.performanceLevel1VO.outputChangeMonth2,changerate:this.performanceLevel1VO.outputChangeRateMonth2 },
                             { value: this.performanceLevel1VO.outputMonth3,month:3, change: this.performanceLevel1VO.outputChangeMonth3,changerate:this.performanceLevel1VO.outputChangeRateMonth3 },
                             { value: this.performanceLevel1VO.outputMonth4,month:4, change: this.performanceLevel1VO.outputChangeMonth4,changerate:this.performanceLevel1VO.outputChangeRateMonth4 },
                             { value: this.performanceLevel1VO.outputMonth5,month:5, change: this.performanceLevel1VO.outputChangeMonth5,changerate:this.performanceLevel1VO.outputChangeRateMonth5 },
                      { value: this.performanceLevel1VO.outputMonth6,month:6, change: this.performanceLevel1VO.outputChangeMonth6,changerate:this.performanceLevel1VO.outputChangeRateMonth6 },
                     { value: this.performanceLevel1VO.outputMonth7,month:7, change: this.performanceLevel1VO.outputChangeMonth7,changerate:this.performanceLevel1VO.outputChangeRateMonth7 },
                   { value: this.performanceLevel1VO.outputMonth8,month:8, change: this.performanceLevel1VO.outputChangeMonth8,changerate:this.performanceLevel1VO.outputChangeRateMonth8 },
                     { value: this.performanceLevel1VO.outputMonth9,month:9, change: this.performanceLevel1VO.outputChangeMonth9,changerate:this.performanceLevel1VO.outputChangeRateMonth9 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.outputEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.outputEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.outputEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.outputEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.outputEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.outputEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.outputEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.outputEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.outputEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 9:
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.outputForecastMonth1,
                        "2月": this.performanceLevel1VO.outputForecastMonth2,
                        "3月": this.performanceLevel1VO.outputForecastMonth3,
                        "4月": this.performanceLevel1VO.outputForecastMonth4,
                        "5月": this.performanceLevel1VO.outputForecastMonth5,
                         "6月": this.performanceLevel1VO.outputForecastMonth6,
                          "7月": this.performanceLevel1VO.outputForecastMonth7,
                          "8月": this.performanceLevel1VO.outputForecastMonth8,
                          "9月": this.performanceLevel1VO.outputForecastMonth9,
                          "10月": this.performanceLevel1VO.outputForecastMonth10,
                          // "11月": this.performanceLevel1VO.outputForecastMonth11,
                          // "12月": this.performanceLevel1VO.outputForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.outputMonth1,month:1, change: this.performanceLevel1VO.outputChangeMonth1,changerate:this.performanceLevel1VO.outputChangeRateMonth1 },
                             { value: this.performanceLevel1VO.outputMonth2,month:2, change: this.performanceLevel1VO.outputChangeMonth2,changerate:this.performanceLevel1VO.outputChangeRateMonth2 },
                             { value: this.performanceLevel1VO.outputMonth3,month:3, change: this.performanceLevel1VO.outputChangeMonth3,changerate:this.performanceLevel1VO.outputChangeRateMonth3 },
                             { value: this.performanceLevel1VO.outputMonth4,month:4, change: this.performanceLevel1VO.outputChangeMonth4,changerate:this.performanceLevel1VO.outputChangeRateMonth4 },
                             { value: this.performanceLevel1VO.outputMonth5,month:5, change: this.performanceLevel1VO.outputChangeMonth5,changerate:this.performanceLevel1VO.outputChangeRateMonth5 },
                      { value: this.performanceLevel1VO.outputMonth6,month:6, change: this.performanceLevel1VO.outputChangeMonth6,changerate:this.performanceLevel1VO.outputChangeRateMonth6 },
                     { value: this.performanceLevel1VO.outputMonth7,month:7, change: this.performanceLevel1VO.outputChangeMonth7,changerate:this.performanceLevel1VO.outputChangeRateMonth7 },
                   { value: this.performanceLevel1VO.outputMonth8,month:8, change: this.performanceLevel1VO.outputChangeMonth8,changerate:this.performanceLevel1VO.outputChangeRateMonth8 },
                     { value: this.performanceLevel1VO.outputMonth9,month:9, change: this.performanceLevel1VO.outputChangeMonth9,changerate:this.performanceLevel1VO.outputChangeRateMonth9 },
                    { value: this.performanceLevel1VO.outputMonth10,month:10, change: this.performanceLevel1VO.outputChangeMonth10,changerate:this.performanceLevel1VO.outputChangeRateMonth10 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.outputEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.outputEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.outputEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.outputEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.outputEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.outputEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.outputEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.outputEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.outputEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.outputEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 10:
                          // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.outputForecastMonth1,
                        "2月": this.performanceLevel1VO.outputForecastMonth2,
                        "3月": this.performanceLevel1VO.outputForecastMonth3,
                        "4月": this.performanceLevel1VO.outputForecastMonth4,
                        "5月": this.performanceLevel1VO.outputForecastMonth5,
                         "6月": this.performanceLevel1VO.outputForecastMonth6,
                          "7月": this.performanceLevel1VO.outputForecastMonth7,
                          "8月": this.performanceLevel1VO.outputForecastMonth8,
                          "9月": this.performanceLevel1VO.outputForecastMonth9,
                          "10月": this.performanceLevel1VO.outputForecastMonth10,
                          "11月": this.performanceLevel1VO.outputForecastMonth11,
                        //  "12月": this.performanceLevel1VO.outputForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.outputMonth1,month:1, change: this.performanceLevel1VO.outputChangeMonth1,changerate:this.performanceLevel1VO.outputChangeRateMonth1 },
                             { value: this.performanceLevel1VO.outputMonth2,month:2, change: this.performanceLevel1VO.outputChangeMonth2,changerate:this.performanceLevel1VO.outputChangeRateMonth2 },
                             { value: this.performanceLevel1VO.outputMonth3,month:3, change: this.performanceLevel1VO.outputChangeMonth3,changerate:this.performanceLevel1VO.outputChangeRateMonth3 },
                             { value: this.performanceLevel1VO.outputMonth4,month:4, change: this.performanceLevel1VO.outputChangeMonth4,changerate:this.performanceLevel1VO.outputChangeRateMonth4 },
                             { value: this.performanceLevel1VO.outputMonth5,month:5, change: this.performanceLevel1VO.outputChangeMonth5,changerate:this.performanceLevel1VO.outputChangeRateMonth5 },
                      { value: this.performanceLevel1VO.outputMonth6,month:6, change: this.performanceLevel1VO.outputChangeMonth6,changerate:this.performanceLevel1VO.outputChangeRateMonth6 },
                     { value: this.performanceLevel1VO.outputMonth7,month:7, change: this.performanceLevel1VO.outputChangeMonth7,changerate:this.performanceLevel1VO.outputChangeRateMonth7 },
                   { value: this.performanceLevel1VO.outputMonth8,month:8, change: this.performanceLevel1VO.outputChangeMonth8,changerate:this.performanceLevel1VO.outputChangeRateMonth8 },
                     { value: this.performanceLevel1VO.outputMonth9,month:9, change: this.performanceLevel1VO.outputChangeMonth9,changerate:this.performanceLevel1VO.outputChangeRateMonth9 },
                    { value: this.performanceLevel1VO.outputMonth10,month:10, change: this.performanceLevel1VO.outputChangeMonth10,changerate:this.performanceLevel1VO.outputChangeRateMonth10 },
                   { value: this.performanceLevel1VO.outputMonth11,month:11, change: this.performanceLevel1VO.outputChangeMonth11,changerate:this.performanceLevel1VO.outputChangeRateMonth11 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.outputEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.outputEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.outputEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.outputEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.outputEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.outputEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.outputEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.outputEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.outputEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.outputEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.outputEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 11: 
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.outputForecastMonth1,
                        "2月": this.performanceLevel1VO.outputForecastMonth2,
                        "3月": this.performanceLevel1VO.outputForecastMonth3,
                        "4月": this.performanceLevel1VO.outputForecastMonth4,
                        "5月": this.performanceLevel1VO.outputForecastMonth5,
                         "6月": this.performanceLevel1VO.outputForecastMonth6,
                          "7月": this.performanceLevel1VO.outputForecastMonth7,
                          "8月": this.performanceLevel1VO.outputForecastMonth8,
                          "9月": this.performanceLevel1VO.outputForecastMonth9,
                          "10月": this.performanceLevel1VO.outputForecastMonth10,
                          "11月": this.performanceLevel1VO.outputForecastMonth11,
                          "12月": this.performanceLevel1VO.outputForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.outputMonth1,month:1, change: this.performanceLevel1VO.outputChangeMonth1,changerate:this.performanceLevel1VO.outputChangeRateMonth1 },
                             { value: this.performanceLevel1VO.outputMonth2,month:2, change: this.performanceLevel1VO.outputChangeMonth2,changerate:this.performanceLevel1VO.outputChangeRateMonth2 },
                             { value: this.performanceLevel1VO.outputMonth3,month:3, change: this.performanceLevel1VO.outputChangeMonth3,changerate:this.performanceLevel1VO.outputChangeRateMonth3 },
                             { value: this.performanceLevel1VO.outputMonth4,month:4, change: this.performanceLevel1VO.outputChangeMonth4,changerate:this.performanceLevel1VO.outputChangeRateMonth4 },
                             { value: this.performanceLevel1VO.outputMonth5,month:5, change: this.performanceLevel1VO.outputChangeMonth5,changerate:this.performanceLevel1VO.outputChangeRateMonth5 },
                      { value: this.performanceLevel1VO.outputMonth6,month:6, change: this.performanceLevel1VO.outputChangeMonth6,changerate:this.performanceLevel1VO.outputChangeRateMonth6 },
                     { value: this.performanceLevel1VO.outputMonth7,month:7, change: this.performanceLevel1VO.outputChangeMonth7,changerate:this.performanceLevel1VO.outputChangeRateMonth7 },
                   { value: this.performanceLevel1VO.outputMonth8,month:8, change: this.performanceLevel1VO.outputChangeMonth8,changerate:this.performanceLevel1VO.outputChangeRateMonth8 },
                     { value: this.performanceLevel1VO.outputMonth9,month:9, change: this.performanceLevel1VO.outputChangeMonth9,changerate:this.performanceLevel1VO.outputChangeRateMonth9 },
                    { value: this.performanceLevel1VO.outputMonth10,month:10, change: this.performanceLevel1VO.outputChangeMonth10,changerate:this.performanceLevel1VO.outputChangeRateMonth10 },
                   { value: this.performanceLevel1VO.outputMonth11,month:11, change: this.performanceLevel1VO.outputChangeMonth11,changerate:this.performanceLevel1VO.outputChangeRateMonth11 },
                   { value: this.performanceLevel1VO.outputMonth11,month:12, change: this.performanceLevel1VO.outputChangeMonth12,changerate:this.performanceLevel1VO.outputChangeRateMonth12 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.outputEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.outputEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.outputEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.outputEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.outputEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.outputEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.outputEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.outputEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.outputEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.outputEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.outputEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '12月',
                            name: this.performanceLevel1VO.outputEvaluateMonth12,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   

             }
            // dataarr=
          }
            if(flag==2){
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                          //   {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaenergyForecastMonth1,
                        // "2月": this.performanceLevel1VO.areaenergyForecastMonth2,
                        // "3月": this.performanceLevel1VO.areaenergyForecastMonth3,
                        // "4月": this.performanceLevel1VO.areaenergyForecastMonth4,
                        // "5月": this.performanceLevel1VO.areaenergyForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areaenergyForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areaenergyForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areaenergyForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areaenergyForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areaenergyForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaenergyForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaenergyForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performanceLevel1VO.areaenergyEvaluateMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[this.performanceLevel1VO.areaenergyMonth1];//目标值
                  
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaenergyForecastMonth1,
                        "2月": this.performanceLevel1VO.areaenergyForecastMonth2,
                        // "3月": this.performanceLevel1VO.areaenergyForecastMonth3,
                        // "4月": this.performanceLevel1VO.areaenergyForecastMonth4,
                        // "5月": this.performanceLevel1VO.areaenergyForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areaenergyForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areaenergyForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areaenergyForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areaenergyForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areaenergyForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaenergyForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaenergyForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performanceLevel1VO.areaenergyMonth1,
                             this.performanceLevel1VO.areaenergyMonth2];//目标值
            
                     this.tableData=[{
                        date: '1月',
                        name: this.performanceLevel1VO.areaenergyEvaluateMonth1,
                        //image: require(besturl)
                        }, 
                      {
                        date: '2月',
                        name: this.performanceLevel1VO.areaenergyEvaluateMonth2,
                      // image: require(besturl)
                        }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                         key: '3月'
                           },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaenergyForecastMonth1,
                        "2月": this.performanceLevel1VO.areaenergyForecastMonth2,
                         "3月": this.performanceLevel1VO.areaenergyForecastMonth3,
                        // "4月": this.performanceLevel1VO.areaenergyForecastMonth4,
                        // "5月": this.performanceLevel1VO.areaenergyForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areaenergyForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areaenergyForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areaenergyForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areaenergyForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areaenergyForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaenergyForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaenergyForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                             this.performanceLevel1VO.areaenergyMonth3];//目标值
            
                     this.tableData=[{
                        date: '1月',
                        name: this.performanceLevel1VO.areaenergyEvaluateMonth1,
                        //image: require(besturl)
                        }, 
                      {
                        date: '2月',
                        name: this.performanceLevel1VO.areaenergyEvaluateMonth2,
                      // image: require(besturl)
                        }, 
                        
                      {
                        date: '3月',
                        name: this.performanceLevel1VO.areaenergyEvaluateMonth3,
                      // image: require(besturl)
                        }, 
                  ];         
                   
                             break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                         key: '3月'
                           },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaenergyForecastMonth1,
                        "2月": this.performanceLevel1VO.areaenergyForecastMonth2,
                         "3月": this.performanceLevel1VO.areaenergyForecastMonth3,
                        "4月": this.performanceLevel1VO.areaenergyForecastMonth4,
                        // "5月": this.performanceLevel1VO.areaenergyForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areaenergyForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areaenergyForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areaenergyForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areaenergyForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areaenergyForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaenergyForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaenergyForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                            
                             { value: this.performanceLevel1VO.areaenergyMonth1,month:1, change: this.performanceLevel1VO.areaenergyChangeMonth1,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth1 },
                          { value: this.performanceLevel1VO.areaenergyMonth2,month:2, change: this.performanceLevel1VO.areaenergyChangeMonth2,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth2 },
                   
                              { value: this.performanceLevel1VO.areaenergyMonth3,month:3, change: this.performanceLevel1VO.areaenergyChangeMonth3,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth3 },
                      
                              ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaenergyEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
                case 4:   
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                         key: '3月'
                           },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaenergyForecastMonth1,
                        "2月": this.performanceLevel1VO.areaenergyForecastMonth2,
                         "3月": this.performanceLevel1VO.areaenergyForecastMonth3,
                        "4月": this.performanceLevel1VO.areaenergyForecastMonth4,
                         "5月": this.performanceLevel1VO.areaenergyForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areaenergyForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areaenergyForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areaenergyForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areaenergyForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areaenergyForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaenergyForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaenergyForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaenergyMonth1,month:1, change: this.performanceLevel1VO.areaenergyChangeMonth1,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaenergyMonth2,month:2, change: this.performanceLevel1VO.areaenergyChangeMonth2,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaenergyMonth3,month:3, change: this.performanceLevel1VO.areaenergyChangeMonth3,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaenergyMonth4,month:4, change: this.performanceLevel1VO.areaenergyChangeMonth4,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaenergyMonth5,month:5, change: this.performanceLevel1VO.areaenergyChangeMonth5,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth5 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaenergyEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;               
                case 5:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                         key: '3月'
                           },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaenergyForecastMonth1,
                        "2月": this.performanceLevel1VO.areaenergyForecastMonth2,
                         "3月": this.performanceLevel1VO.areaenergyForecastMonth3,
                        "4月": this.performanceLevel1VO.areaenergyForecastMonth4,
                         "5月": this.performanceLevel1VO.areaenergyForecastMonth5,
                          "6月": this.performanceLevel1VO.areaenergyForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areaenergyForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areaenergyForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areaenergyForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areaenergyForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaenergyForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaenergyForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaenergyMonth1,month:1, change: this.performanceLevel1VO.areaenergyChangeMonth1,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaenergyMonth2,month:2, change: this.performanceLevel1VO.areaenergyChangeMonth2,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaenergyMonth3,month:3, change: this.performanceLevel1VO.areaenergyChangeMonth3,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaenergyMonth4,month:4, change: this.performanceLevel1VO.areaenergyChangeMonth4,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaenergyMonth5,month:5, change: this.performanceLevel1VO.areaenergyChangeMonth5,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaenergyMonth6,month:6, change: this.performanceLevel1VO.areaenergyChangeMonth6,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth6 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaenergyEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 6:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                         key: '3月'
                           },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaenergyForecastMonth1,
                        "2月": this.performanceLevel1VO.areaenergyForecastMonth2,
                         "3月": this.performanceLevel1VO.areaenergyForecastMonth3,
                        "4月": this.performanceLevel1VO.areaenergyForecastMonth4,
                         "5月": this.performanceLevel1VO.areaenergyForecastMonth5,
                          "6月": this.performanceLevel1VO.areaenergyForecastMonth6,
                           "7月": this.performanceLevel1VO.areaenergyForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areaenergyForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areaenergyForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areaenergyForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaenergyForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaenergyForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaenergyMonth1,month:1, change: this.performanceLevel1VO.areaenergyChangeMonth1,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaenergyMonth2,month:2, change: this.performanceLevel1VO.areaenergyChangeMonth2,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaenergyMonth3,month:3, change: this.performanceLevel1VO.areaenergyChangeMonth3,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaenergyMonth4,month:4, change: this.performanceLevel1VO.areaenergyChangeMonth4,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaenergyMonth5,month:5, change: this.performanceLevel1VO.areaenergyChangeMonth5,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaenergyMonth6,month:6, change: this.performanceLevel1VO.areaenergyChangeMonth6,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areaenergyMonth7,month:7, change: this.performanceLevel1VO.areaenergyChangeMonth7,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth7 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaenergyEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                           
                       ];  
                    
                    
                             break;    
                case 7: 
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                         key: '3月'
                           },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaenergyForecastMonth1,
                        "2月": this.performanceLevel1VO.areaenergyForecastMonth2,
                         "3月": this.performanceLevel1VO.areaenergyForecastMonth3,
                        "4月": this.performanceLevel1VO.areaenergyForecastMonth4,
                         "5月": this.performanceLevel1VO.areaenergyForecastMonth5,
                          "6月": this.performanceLevel1VO.areaenergyForecastMonth6,
                           "7月": this.performanceLevel1VO.areaenergyForecastMonth7,
                           "8月": this.performanceLevel1VO.areaenergyForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areaenergyForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areaenergyForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaenergyForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaenergyForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaenergyMonth1,month:1, change: this.performanceLevel1VO.areaenergyChangeMonth1,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaenergyMonth2,month:2, change: this.performanceLevel1VO.areaenergyChangeMonth2,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaenergyMonth3,month:3, change: this.performanceLevel1VO.areaenergyChangeMonth3,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaenergyMonth4,month:4, change: this.performanceLevel1VO.areaenergyChangeMonth4,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaenergyMonth5,month:5, change: this.performanceLevel1VO.areaenergyChangeMonth5,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaenergyMonth6,month:6, change: this.performanceLevel1VO.areaenergyChangeMonth6,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areaenergyMonth7,month:7, change: this.performanceLevel1VO.areaenergyChangeMonth7,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areaenergyMonth8,month:8, change: this.performanceLevel1VO.areaenergyChangeMonth8,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth8 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaenergyEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 8:
                        // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                         key: '3月'
                           },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaenergyForecastMonth1,
                        "2月": this.performanceLevel1VO.areaenergyForecastMonth2,
                         "3月": this.performanceLevel1VO.areaenergyForecastMonth3,
                        "4月": this.performanceLevel1VO.areaenergyForecastMonth4,
                         "5月": this.performanceLevel1VO.areaenergyForecastMonth5,
                          "6月": this.performanceLevel1VO.areaenergyForecastMonth6,
                           "7月": this.performanceLevel1VO.areaenergyForecastMonth7,
                           "8月": this.performanceLevel1VO.areaenergyForecastMonth8,
                          "9月": this.performanceLevel1VO.areaenergyForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areaenergyForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaenergyForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaenergyForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaenergyMonth1,month:1, change: this.performanceLevel1VO.areaenergyChangeMonth1,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaenergyMonth2,month:2, change: this.performanceLevel1VO.areaenergyChangeMonth2,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaenergyMonth3,month:3, change: this.performanceLevel1VO.areaenergyChangeMonth3,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaenergyMonth4,month:4, change: this.performanceLevel1VO.areaenergyChangeMonth4,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaenergyMonth5,month:5, change: this.performanceLevel1VO.areaenergyChangeMonth5,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaenergyMonth6,month:6, change: this.performanceLevel1VO.areaenergyChangeMonth6,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areaenergyMonth7,month:7, change: this.performanceLevel1VO.areaenergyChangeMonth7,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areaenergyMonth8,month:8, change: this.performanceLevel1VO.areaenergyChangeMonth8,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areaenergyMonth9,month:9, change: this.performanceLevel1VO.areaenergyChangeMonth9,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth9 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaenergyEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 9:
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                         key: '3月'
                           },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaenergyForecastMonth1,
                        "2月": this.performanceLevel1VO.areaenergyForecastMonth2,
                         "3月": this.performanceLevel1VO.areaenergyForecastMonth3,
                        "4月": this.performanceLevel1VO.areaenergyForecastMonth4,
                         "5月": this.performanceLevel1VO.areaenergyForecastMonth5,
                          "6月": this.performanceLevel1VO.areaenergyForecastMonth6,
                           "7月": this.performanceLevel1VO.areaenergyForecastMonth7,
                          "8月": this.performanceLevel1VO.areaenergyForecastMonth8,
                          "9月": this.performanceLevel1VO.areaenergyForecastMonth9,
                          "10月": this.performanceLevel1VO.areaenergyForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaenergyForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaenergyForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaenergyMonth1,month:1, change: this.performanceLevel1VO.areaenergyChangeMonth1,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaenergyMonth2,month:2, change: this.performanceLevel1VO.areaenergyChangeMonth2,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaenergyMonth3,month:3, change: this.performanceLevel1VO.areaenergyChangeMonth3,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaenergyMonth4,month:4, change: this.performanceLevel1VO.areaenergyChangeMonth4,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaenergyMonth5,month:5, change: this.performanceLevel1VO.areaenergyChangeMonth5,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaenergyMonth6,month:6, change: this.performanceLevel1VO.areaenergyChangeMonth6,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areaenergyMonth7,month:7, change: this.performanceLevel1VO.areaenergyChangeMonth7,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areaenergyMonth8,month:8, change: this.performanceLevel1VO.areaenergyChangeMonth8,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areaenergyMonth9,month:9, change: this.performanceLevel1VO.areaenergyChangeMonth9,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth9 },
                    { value: this.performanceLevel1VO.areaenergyMonth10,month:10, change: this.performanceLevel1VO.areaenergyChangeMonth10,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth10 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaenergyEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 10:
                          // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                         key: '3月'
                           },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaenergyForecastMonth1,
                        "2月": this.performanceLevel1VO.areaenergyForecastMonth2,
                         "3月": this.performanceLevel1VO.areaenergyForecastMonth3,
                        "4月": this.performanceLevel1VO.areaenergyForecastMonth4,
                         "5月": this.performanceLevel1VO.areaenergyForecastMonth5,
                          "6月": this.performanceLevel1VO.areaenergyForecastMonth6,
                           "7月": this.performanceLevel1VO.areaenergyForecastMonth7,
                          "8月": this.performanceLevel1VO.areaenergyForecastMonth8,
                          "9月": this.performanceLevel1VO.areaenergyForecastMonth9,
                          "10月": this.performanceLevel1VO.areaenergyForecastMonth10,
                          "11月": this.performanceLevel1VO.areaenergyForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaenergyForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaenergyMonth1,month:1, change: this.performanceLevel1VO.areaenergyChangeMonth1,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaenergyMonth2,month:2, change: this.performanceLevel1VO.areaenergyChangeMonth2,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaenergyMonth3,month:3, change: this.performanceLevel1VO.areaenergyChangeMonth3,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaenergyMonth4,month:4, change: this.performanceLevel1VO.areaenergyChangeMonth4,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaenergyMonth5,month:5, change: this.performanceLevel1VO.areaenergyChangeMonth5,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaenergyMonth6,month:6, change: this.performanceLevel1VO.areaenergyChangeMonth6,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areaenergyMonth7,month:7, change: this.performanceLevel1VO.areaenergyChangeMonth7,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areaenergyMonth8,month:8, change: this.performanceLevel1VO.areaenergyChangeMonth8,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areaenergyMonth9,month:9, change: this.performanceLevel1VO.areaenergyChangeMonth9,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth9 },
                    { value: this.performanceLevel1VO.areaenergyMonth10,month:10, change: this.performanceLevel1VO.areaenergyChangeMonth10,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth10 },
                   { value: this.performanceLevel1VO.areaenergyMonth11,month:11, change: this.performanceLevel1VO.areaenergyChangeMonth11,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth11 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaenergyEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 11: 
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                         key: '3月'
                           },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaenergyForecastMonth1,
                        "2月": this.performanceLevel1VO.areaenergyForecastMonth2,
                         "3月": this.performanceLevel1VO.areaenergyForecastMonth3,
                        "4月": this.performanceLevel1VO.areaenergyForecastMonth4,
                         "5月": this.performanceLevel1VO.areaenergyForecastMonth5,
                          "6月": this.performanceLevel1VO.areaenergyForecastMonth6,
                           "7月": this.performanceLevel1VO.areaenergyForecastMonth7,
                          "8月": this.performanceLevel1VO.areaenergyForecastMonth8,
                          "9月": this.performanceLevel1VO.areaenergyForecastMonth9,
                          "10月": this.performanceLevel1VO.areaenergyForecastMonth10,
                          "11月": this.performanceLevel1VO.areaenergyForecastMonth11,
                          "12月": this.performanceLevel1VO.areaenergyForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaenergyMonth1,month:1, change: this.performanceLevel1VO.areaenergyChangeMonth1,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaenergyMonth2,month:2, change: this.performanceLevel1VO.areaenergyChangeMonth2,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaenergyMonth3,month:3, change: this.performanceLevel1VO.areaenergyChangeMonth3,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaenergyMonth4,month:4, change: this.performanceLevel1VO.areaenergyChangeMonth4,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaenergyMonth5,month:5, change: this.performanceLevel1VO.areaenergyChangeMonth5,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaenergyMonth6,month:6, change: this.performanceLevel1VO.areaenergyChangeMonth6,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areaenergyMonth7,month:7, change: this.performanceLevel1VO.areaenergyChangeMonth7,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areaenergyMonth8,month:8, change: this.performanceLevel1VO.areaenergyChangeMonth8,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areaenergyMonth9,month:9, change: this.performanceLevel1VO.areaenergyChangeMonth9,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth9 },
                    { value: this.performanceLevel1VO.areaenergyMonth10,month:10, change: this.performanceLevel1VO.areaenergyChangeMonth10,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth10 },
                   { value: this.performanceLevel1VO.areaenergyMonth11,month:11, change: this.performanceLevel1VO.areaenergyChangeMonth11,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth11 },
                   { value: this.performanceLevel1VO.areaenergyMonth11,month:12, change: this.performanceLevel1VO.areaenergyChangeMonth12,changerate:this.performanceLevel1VO.areaenergyChangeRateMonth12 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaenergyEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '12月',
                            name: this.performanceLevel1VO.areaenergyEvaluateMonth12,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   

            

             }
            // dataarr=
          }
            if(flag==3){
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                          //   {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areapowerForecastMonth1,
                        // "2月": this.performanceLevel1VO.areapowerForecastMonth2,
                        // "3月": this.performanceLevel1VO.areapowerForecastMonth3,
                        // "4月": this.performanceLevel1VO.areapowerForecastMonth4,
                        // "5月": this.performanceLevel1VO.areapowerForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areapowerForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areapowerForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areapowerForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areapowerForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areapowerForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areapowerForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areapowerForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performanceLevel1VO.areapowerEvaluateMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[
                    
                       { value: this.performanceLevel1VO.areapowerMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                        
                    ];//目标值
                  
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                      this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areapowerForecastMonth1,
                        "2月": this.performanceLevel1VO.areapowerForecastMonth2,
                        // "3月": this.performanceLevel1VO.areapowerForecastMonth3,
                        // "4月": this.performanceLevel1VO.areapowerForecastMonth4,
                        // "5月": this.performanceLevel1VO.areapowerForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areapowerForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areapowerForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areapowerForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areapowerForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areapowerForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areapowerForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areapowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                               { value: this.performanceLevel1VO.areapowerMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                          { value: this.performanceLevel1VO.areapowerMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                   
                             
                             ];//目标值
            
                     this.tableData=[{
                        date: '1月',
                        name: this.performanceLevel1VO.areapowerEvaluateMonth1,
                        //image: require(besturl)
                        }, 
                      {
                        date: '2月',
                        name: this.performanceLevel1VO.areapowerEvaluateMonth2,
                      // image: require(besturl)
                        }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areapowerForecastMonth1,
                        "2月": this.performanceLevel1VO.areapowerForecastMonth2,
                        "3月": this.performanceLevel1VO.areapowerForecastMonth3,
                        // "4月": this.performanceLevel1VO.areapowerForecastMonth4,
                        // "5月": this.performanceLevel1VO.areapowerForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areapowerForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areapowerForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areapowerForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areapowerForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areapowerForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areapowerForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areapowerForecastMonth12,
                     }
                  ];
                     this.dataarr=[
                               { value: this.performanceLevel1VO.areapowerMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                          { value: this.performanceLevel1VO.areapowerMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                   
                              { value: this.performanceLevel1VO.areapowerMonth3,month:3, change: this.performanceLevel1VO.areapowerChangeMonth3,changerate:this.performanceLevel1VO.areapowerChangeRateMonth3 },
                 
                           ];//目标值
              
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areapowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areapowerForecastMonth1,
                        "2月": this.performanceLevel1VO.areapowerForecastMonth2,
                        "3月": this.performanceLevel1VO.areapowerForecastMonth3,
                        "4月": this.performanceLevel1VO.areapowerForecastMonth4,
                        // "5月": this.performanceLevel1VO.areapowerForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areapowerForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areapowerForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areapowerForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areapowerForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areapowerForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areapowerForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areapowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                                  { value: this.performanceLevel1VO.areapowerMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                          { value: this.performanceLevel1VO.areapowerMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                   
                              { value: this.performanceLevel1VO.areapowerMonth3,month:3, change: this.performanceLevel1VO.areapowerChangeMonth3,changerate:this.performanceLevel1VO.areapowerChangeRateMonth3 },
                     { value: this.performanceLevel1VO.areapowerMonth4,month:4, change: this.performanceLevel1VO.areapowerChangeMonth4,changerate:this.performanceLevel1VO.areapowerChangeRateMonth4},
                 
                              
                              ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areapowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
                case 4:   
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areapowerForecastMonth1,
                        "2月": this.performanceLevel1VO.areapowerForecastMonth2,
                        "3月": this.performanceLevel1VO.areapowerForecastMonth3,
                        "4月": this.performanceLevel1VO.areapowerForecastMonth4,
                        "5月": this.performanceLevel1VO.areapowerForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areapowerForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areapowerForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areapowerForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areapowerForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areapowerForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areapowerForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areapowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areapowerMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areapowerMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areapowerMonth3,month:3, change: this.performanceLevel1VO.areapowerChangeMonth3,changerate:this.performanceLevel1VO.areapowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areapowerMonth4,month:4, change: this.performanceLevel1VO.areapowerChangeMonth4,changerate:this.performanceLevel1VO.areapowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areapowerMonth5,month:5, change: this.performanceLevel1VO.areapowerChangeMonth5,changerate:this.performanceLevel1VO.areapowerChangeRateMonth5 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areapowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;               
                case 5:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areapowerForecastMonth1,
                        "2月": this.performanceLevel1VO.areapowerForecastMonth2,
                        "3月": this.performanceLevel1VO.areapowerForecastMonth3,
                        "4月": this.performanceLevel1VO.areapowerForecastMonth4,
                        "5月": this.performanceLevel1VO.areapowerForecastMonth5,
                         "6月": this.performanceLevel1VO.areapowerForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areapowerForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areapowerForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areapowerForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areapowerForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areapowerForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areapowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areapowerMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areapowerMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areapowerMonth3,month:3, change: this.performanceLevel1VO.areapowerChangeMonth3,changerate:this.performanceLevel1VO.areapowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areapowerMonth4,month:4, change: this.performanceLevel1VO.areapowerChangeMonth4,changerate:this.performanceLevel1VO.areapowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areapowerMonth5,month:5, change: this.performanceLevel1VO.areapowerChangeMonth5,changerate:this.performanceLevel1VO.areapowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areapowerMonth6,month:6, change: this.performanceLevel1VO.areapowerChangeMonth6,changerate:this.performanceLevel1VO.areapowerChangeRateMonth6 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areapowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 6:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areapowerForecastMonth1,
                        "2月": this.performanceLevel1VO.areapowerForecastMonth2,
                        "3月": this.performanceLevel1VO.areapowerForecastMonth3,
                        "4月": this.performanceLevel1VO.areapowerForecastMonth4,
                        "5月": this.performanceLevel1VO.areapowerForecastMonth5,
                         "6月": this.performanceLevel1VO.areapowerForecastMonth6,
                          "7月": this.performanceLevel1VO.areapowerForecastMonth7,
                          // "8月": this.performanceLevel1VO.areapowerForecastMonth8,
                          // "9月": this.performanceLevel1VO.areapowerForecastMonth9,
                          // "10月": this.performanceLevel1VO.areapowerForecastMonth10,
                          // "11月": this.performanceLevel1VO.areapowerForecastMonth11,
                          // "12月": this.performanceLevel1VO.areapowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areapowerMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areapowerMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areapowerMonth3,month:3, change: this.performanceLevel1VO.areapowerChangeMonth3,changerate:this.performanceLevel1VO.areapowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areapowerMonth4,month:4, change: this.performanceLevel1VO.areapowerChangeMonth4,changerate:this.performanceLevel1VO.areapowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areapowerMonth5,month:5, change: this.performanceLevel1VO.areapowerChangeMonth5,changerate:this.performanceLevel1VO.areapowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areapowerMonth6,month:6, change: this.performanceLevel1VO.areapowerChangeMonth6,changerate:this.performanceLevel1VO.areapowerChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areapowerMonth7,month:7, change: this.performanceLevel1VO.areapowerChangeMonth7,changerate:this.performanceLevel1VO.areapowerChangeRateMonth7 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areapowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 7: 
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areapowerForecastMonth1,
                        "2月": this.performanceLevel1VO.areapowerForecastMonth2,
                        "3月": this.performanceLevel1VO.areapowerForecastMonth3,
                        "4月": this.performanceLevel1VO.areapowerForecastMonth4,
                        "5月": this.performanceLevel1VO.areapowerForecastMonth5,
                         "6月": this.performanceLevel1VO.areapowerForecastMonth6,
                          "7月": this.performanceLevel1VO.areapowerForecastMonth7,
                          "8月": this.performanceLevel1VO.areapowerForecastMonth8,
                          // "9月": this.performanceLevel1VO.areapowerForecastMonth9,
                          // "10月": this.performanceLevel1VO.areapowerForecastMonth10,
                          // "11月": this.performanceLevel1VO.areapowerForecastMonth11,
                          // "12月": this.performanceLevel1VO.areapowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areapowerMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areapowerMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areapowerMonth3,month:3, change: this.performanceLevel1VO.areapowerChangeMonth3,changerate:this.performanceLevel1VO.areapowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areapowerMonth4,month:4, change: this.performanceLevel1VO.areapowerChangeMonth4,changerate:this.performanceLevel1VO.areapowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areapowerMonth5,month:5, change: this.performanceLevel1VO.areapowerChangeMonth5,changerate:this.performanceLevel1VO.areapowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areapowerMonth6,month:6, change: this.performanceLevel1VO.areapowerChangeMonth6,changerate:this.performanceLevel1VO.areapowerChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areapowerMonth7,month:7, change: this.performanceLevel1VO.areapowerChangeMonth7,changerate:this.performanceLevel1VO.areapowerChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areapowerMonth8,month:8, change: this.performanceLevel1VO.areapowerChangeMonth8,changerate:this.performanceLevel1VO.areapowerChangeRateMonth8 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areapowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 8:
                        // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areapowerForecastMonth1,
                        "2月": this.performanceLevel1VO.areapowerForecastMonth2,
                        "3月": this.performanceLevel1VO.areapowerForecastMonth3,
                        "4月": this.performanceLevel1VO.areapowerForecastMonth4,
                        "5月": this.performanceLevel1VO.areapowerForecastMonth5,
                         "6月": this.performanceLevel1VO.areapowerForecastMonth6,
                          "7月": this.performanceLevel1VO.areapowerForecastMonth7,
                          "8月": this.performanceLevel1VO.areapowerForecastMonth8,
                           "9月": this.performanceLevel1VO.areapowerForecastMonth9,
                          // "10月": this.performanceLevel1VO.areapowerForecastMonth10,
                          // "11月": this.performanceLevel1VO.areapowerForecastMonth11,
                          // "12月": this.performanceLevel1VO.areapowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areapowerMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areapowerMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areapowerMonth3,month:3, change: this.performanceLevel1VO.areapowerChangeMonth3,changerate:this.performanceLevel1VO.areapowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areapowerMonth4,month:4, change: this.performanceLevel1VO.areapowerChangeMonth4,changerate:this.performanceLevel1VO.areapowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areapowerMonth5,month:5, change: this.performanceLevel1VO.areapowerChangeMonth5,changerate:this.performanceLevel1VO.areapowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areapowerMonth6,month:6, change: this.performanceLevel1VO.areapowerChangeMonth6,changerate:this.performanceLevel1VO.areapowerChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areapowerMonth7,month:7, change: this.performanceLevel1VO.areapowerChangeMonth7,changerate:this.performanceLevel1VO.areapowerChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areapowerMonth8,month:8, change: this.performanceLevel1VO.areapowerChangeMonth8,changerate:this.performanceLevel1VO.areapowerChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areapowerMonth9,month:9, change: this.performanceLevel1VO.areapowerChangeMonth9,changerate:this.performanceLevel1VO.areapowerChangeRateMonth9 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areapowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 9:
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areapowerForecastMonth1,
                        "2月": this.performanceLevel1VO.areapowerForecastMonth2,
                        "3月": this.performanceLevel1VO.areapowerForecastMonth3,
                        "4月": this.performanceLevel1VO.areapowerForecastMonth4,
                        "5月": this.performanceLevel1VO.areapowerForecastMonth5,
                         "6月": this.performanceLevel1VO.areapowerForecastMonth6,
                          "7月": this.performanceLevel1VO.areapowerForecastMonth7,
                          "8月": this.performanceLevel1VO.areapowerForecastMonth8,
                          "9月": this.performanceLevel1VO.areapowerForecastMonth9,
                          "10月": this.performanceLevel1VO.areapowerForecastMonth10,
                          // "11月": this.performanceLevel1VO.areapowerForecastMonth11,
                          // "12月": this.performanceLevel1VO.areapowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areapowerMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areapowerMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areapowerMonth3,month:3, change: this.performanceLevel1VO.areapowerChangeMonth3,changerate:this.performanceLevel1VO.areapowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areapowerMonth4,month:4, change: this.performanceLevel1VO.areapowerChangeMonth4,changerate:this.performanceLevel1VO.areapowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areapowerMonth5,month:5, change: this.performanceLevel1VO.areapowerChangeMonth5,changerate:this.performanceLevel1VO.areapowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areapowerMonth6,month:6, change: this.performanceLevel1VO.areapowerChangeMonth6,changerate:this.performanceLevel1VO.areapowerChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areapowerMonth7,month:7, change: this.performanceLevel1VO.areapowerChangeMonth7,changerate:this.performanceLevel1VO.areapowerChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areapowerMonth8,month:8, change: this.performanceLevel1VO.areapowerChangeMonth8,changerate:this.performanceLevel1VO.areapowerChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areapowerMonth9,month:9, change: this.performanceLevel1VO.areapowerChangeMonth9,changerate:this.performanceLevel1VO.areapowerChangeRateMonth9 },
                    { value: this.performanceLevel1VO.areapowerMonth10,month:10, change: this.performanceLevel1VO.areapowerChangeMonth10,changerate:this.performanceLevel1VO.areapowerChangeRateMonth10 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areapowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 10:
                          // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areapowerForecastMonth1,
                        "2月": this.performanceLevel1VO.areapowerForecastMonth2,
                        "3月": this.performanceLevel1VO.areapowerForecastMonth3,
                        "4月": this.performanceLevel1VO.areapowerForecastMonth4,
                        "5月": this.performanceLevel1VO.areapowerForecastMonth5,
                         "6月": this.performanceLevel1VO.areapowerForecastMonth6,
                          "7月": this.performanceLevel1VO.areapowerForecastMonth7,
                          "8月": this.performanceLevel1VO.areapowerForecastMonth8,
                          "9月": this.performanceLevel1VO.areapowerForecastMonth9,
                          "10月": this.performanceLevel1VO.areapowerForecastMonth10,
                          "11月": this.performanceLevel1VO.areapowerForecastMonth11,
                          // "12月": this.performanceLevel1VO.areapowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areapowerMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areapowerMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areapowerMonth3,month:3, change: this.performanceLevel1VO.areapowerChangeMonth3,changerate:this.performanceLevel1VO.areapowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areapowerMonth4,month:4, change: this.performanceLevel1VO.areapowerChangeMonth4,changerate:this.performanceLevel1VO.areapowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areapowerMonth5,month:5, change: this.performanceLevel1VO.areapowerChangeMonth5,changerate:this.performanceLevel1VO.areapowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areapowerMonth6,month:6, change: this.performanceLevel1VO.areapowerChangeMonth6,changerate:this.performanceLevel1VO.areapowerChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areapowerMonth7,month:7, change: this.performanceLevel1VO.areapowerChangeMonth7,changerate:this.performanceLevel1VO.areapowerChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areapowerMonth8,month:8, change: this.performanceLevel1VO.areapowerChangeMonth8,changerate:this.performanceLevel1VO.areapowerChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areapowerMonth9,month:9, change: this.performanceLevel1VO.areapowerChangeMonth9,changerate:this.performanceLevel1VO.areapowerChangeRateMonth9 },
                    { value: this.performanceLevel1VO.areapowerMonth10,month:10, change: this.performanceLevel1VO.areapowerChangeMonth10,changerate:this.performanceLevel1VO.areapowerChangeRateMonth10 },
                   { value: this.performanceLevel1VO.areapowerMonth11,month:11, change: this.performanceLevel1VO.areapowerChangeMonth11,changerate:this.performanceLevel1VO.areapowerChangeRateMonth11 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areapowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 11: 
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areapowerForecastMonth1,
                        "2月": this.performanceLevel1VO.areapowerForecastMonth2,
                        "3月": this.performanceLevel1VO.areapowerForecastMonth3,
                        "4月": this.performanceLevel1VO.areapowerForecastMonth4,
                        "5月": this.performanceLevel1VO.areapowerForecastMonth5,
                         "6月": this.performanceLevel1VO.areapowerForecastMonth6,
                          "7月": this.performanceLevel1VO.areapowerForecastMonth7,
                          "8月": this.performanceLevel1VO.areapowerForecastMonth8,
                          "9月": this.performanceLevel1VO.areapowerForecastMonth9,
                          "10月": this.performanceLevel1VO.areapowerForecastMonth10,
                          "11月": this.performanceLevel1VO.areapowerForecastMonth11,
                          "12月": this.performanceLevel1VO.areapowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areapowerMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areapowerMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areapowerMonth3,month:3, change: this.performanceLevel1VO.areapowerChangeMonth3,changerate:this.performanceLevel1VO.areapowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areapowerMonth4,month:4, change: this.performanceLevel1VO.areapowerChangeMonth4,changerate:this.performanceLevel1VO.areapowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areapowerMonth5,month:5, change: this.performanceLevel1VO.areapowerChangeMonth5,changerate:this.performanceLevel1VO.areapowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areapowerMonth6,month:6, change: this.performanceLevel1VO.areapowerChangeMonth6,changerate:this.performanceLevel1VO.areapowerChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areapowerMonth7,month:7, change: this.performanceLevel1VO.areapowerChangeMonth7,changerate:this.performanceLevel1VO.areapowerChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areapowerMonth8,month:8, change: this.performanceLevel1VO.areapowerChangeMonth8,changerate:this.performanceLevel1VO.areapowerChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areapowerMonth9,month:9, change: this.performanceLevel1VO.areapowerChangeMonth9,changerate:this.performanceLevel1VO.areapowerChangeRateMonth9 },
                    { value: this.performanceLevel1VO.areapowerMonth10,month:10, change: this.performanceLevel1VO.areapowerChangeMonth10,changerate:this.performanceLevel1VO.areapowerChangeRateMonth10 },
                   { value: this.performanceLevel1VO.areapowerMonth11,month:11, change: this.performanceLevel1VO.areapowerChangeMonth11,changerate:this.performanceLevel1VO.areapowerChangeRateMonth11 },
                   { value: this.performanceLevel1VO.areapowerMonth11,month:12, change: this.performanceLevel1VO.areapowerChangeMonth12,changerate:this.performanceLevel1VO.areapowerChangeRateMonth12 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areapowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '12月',
                            name: this.performanceLevel1VO.areapowerEvaluateMonth12,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   

            

             }
            // dataarr=
          }
            if(flag==4){
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                          //  {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areawaterForecastMonth1,
                      //  "2月": this.performanceLevel1VO.areawaterForecastMonth2,
                      //   "3月": this.performanceLevel1VO.areawaterForecastMonth3,
                      //   "4月": this.performanceLevel1VO.areawaterForecastMonth4,
                      //   "5月": this.performanceLevel1VO.areawaterForecastMonth5,
                      //    "6月": this.performanceLevel1VO.areawaterForecastMonth6,
                      //     "7月": this.performanceLevel1VO.areawaterForecastMonth7,
                      //     "8月": this.performanceLevel1VO.areawaterForecastMonth8,
                      //     "9月": this.performanceLevel1VO.areawaterForecastMonth9,
                      //     "10月": this.performanceLevel1VO.areawaterForecastMonth10,
                      //     "11月": this.performanceLevel1VO.areawaterForecastMonth11,
                      //     "12月": this.performanceLevel1VO.areawaterForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performanceLevel1VO.areawaterEvaluateMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[
                   
                   { value: this.performanceLevel1VO.areawaterMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                 
                    ];//目标值
                  
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areawaterForecastMonth1,
                       "2月": this.performanceLevel1VO.areawaterForecastMonth2,
                        // "3月": this.performanceLevel1VO.areawaterForecastMonth3,
                        // "4月": this.performanceLevel1VO.areawaterForecastMonth4,
                        // "5月": this.performanceLevel1VO.areawaterForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areawaterForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areawaterForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areawaterForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areawaterForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areawaterForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areawaterForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areawaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                             { value: this.performanceLevel1VO.areawaterMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areawaterMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                 
                             ];//目标值
            
                     this.tableData=[{
                        date: '1月',
                        name: this.performanceLevel1VO.areawaterEvaluateMonth1,
                        //image: require(besturl)
                        }, 
                      {
                        date: '2月',
                        name: this.performanceLevel1VO.areawaterEvaluateMonth2,
                      // image: require(besturl)
                        }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areawaterForecastMonth1,
                       "2月": this.performanceLevel1VO.areawaterForecastMonth2,
                        "3月": this.performanceLevel1VO.areawaterForecastMonth3,
                        // "4月": this.performanceLevel1VO.areawaterForecastMonth4,
                        // "5月": this.performanceLevel1VO.areawaterForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areawaterForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areawaterForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areawaterForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areawaterForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areawaterForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areawaterForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areawaterForecastMonth12,
                     }
                  ];
                     this.dataarr=[
                               { value: this.performanceLevel1VO.areawaterMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areawaterMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                            { value: this.performanceLevel1VO.areawaterMonth3,month:3, change: this.performanceLevel1VO.areapowerChangeMonth3,changerate:this.performanceLevel1VO.areapowerChangeRateMonth3 },
                  
                             ];//目标值
              
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areawaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areawaterForecastMonth1,
                       "2月": this.performanceLevel1VO.areawaterForecastMonth2,
                        "3月": this.performanceLevel1VO.areawaterForecastMonth3,
                        "4月": this.performanceLevel1VO.areawaterForecastMonth4,
                        // "5月": this.performanceLevel1VO.areawaterForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areawaterForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areawaterForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areawaterForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areawaterForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areawaterForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areawaterForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areawaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                                { value: this.performanceLevel1VO.areawaterMonth1,month:1, change: this.performanceLevel1VO.areapowerChangeMonth1,changerate:this.performanceLevel1VO.areapowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areawaterMonth2,month:2, change: this.performanceLevel1VO.areapowerChangeMonth2,changerate:this.performanceLevel1VO.areapowerChangeRateMonth2 },
                            { value: this.performanceLevel1VO.areawaterMonth3,month:3, change: this.performanceLevel1VO.areapowerChangeMonth3,changerate:this.performanceLevel1VO.areapowerChangeRateMonth3 },
                           { value: this.performanceLevel1VO.areawaterMonth4,month:4, change: this.performanceLevel1VO.areapowerChangeMonth4,changerate:this.performanceLevel1VO.areapowerChangeRateMonth4 },
                  
                              ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areawaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
                 case 4:   
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areawaterForecastMonth1,
                       "2月": this.performanceLevel1VO.areawaterForecastMonth2,
                        "3月": this.performanceLevel1VO.areawaterForecastMonth3,
                        "4月": this.performanceLevel1VO.areawaterForecastMonth4,
                        "5月": this.performanceLevel1VO.areawaterForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areawaterForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areawaterForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areawaterForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areawaterForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areawaterForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areawaterForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areawaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areawaterMonth1,month:1, change: this.performanceLevel1VO.areawaterChangeMonth1,changerate:this.performanceLevel1VO.areawaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areawaterMonth2,month:2, change: this.performanceLevel1VO.areawaterChangeMonth2,changerate:this.performanceLevel1VO.areawaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areawaterMonth3,month:3, change: this.performanceLevel1VO.areawaterChangeMonth3,changerate:this.performanceLevel1VO.areawaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areawaterMonth4,month:4, change: this.performanceLevel1VO.areawaterChangeMonth4,changerate:this.performanceLevel1VO.areawaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areawaterMonth5,month:5, change: this.performanceLevel1VO.areawaterChangeMonth5,changerate:this.performanceLevel1VO.areawaterChangeRateMonth5 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areawaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;               
                case 5:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areawaterForecastMonth1,
                       "2月": this.performanceLevel1VO.areawaterForecastMonth2,
                        "3月": this.performanceLevel1VO.areawaterForecastMonth3,
                        "4月": this.performanceLevel1VO.areawaterForecastMonth4,
                        "5月": this.performanceLevel1VO.areawaterForecastMonth5,
                         "6月": this.performanceLevel1VO.areawaterForecastMonth6,
                          // "7月": this.performanceLevel1VO.areawaterForecastMonth7,
                          // "8月": this.performanceLevel1VO.areawaterForecastMonth8,
                          // "9月": this.performanceLevel1VO.areawaterForecastMonth9,
                          // "10月": this.performanceLevel1VO.areawaterForecastMonth10,
                          // "11月": this.performanceLevel1VO.areawaterForecastMonth11,
                          // "12月": this.performanceLevel1VO.areawaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areawaterMonth1,month:1, change: this.performanceLevel1VO.areawaterChangeMonth1,changerate:this.performanceLevel1VO.areawaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areawaterMonth2,month:2, change: this.performanceLevel1VO.areawaterChangeMonth2,changerate:this.performanceLevel1VO.areawaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areawaterMonth3,month:3, change: this.performanceLevel1VO.areawaterChangeMonth3,changerate:this.performanceLevel1VO.areawaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areawaterMonth4,month:4, change: this.performanceLevel1VO.areawaterChangeMonth4,changerate:this.performanceLevel1VO.areawaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areawaterMonth5,month:5, change: this.performanceLevel1VO.areawaterChangeMonth5,changerate:this.performanceLevel1VO.areawaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areawaterMonth6,month:6, change: this.performanceLevel1VO.areawaterChangeMonth6,changerate:this.performanceLevel1VO.areawaterChangeRateMonth6 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areawaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 6:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areawaterForecastMonth1,
                       "2月": this.performanceLevel1VO.areawaterForecastMonth2,
                        "3月": this.performanceLevel1VO.areawaterForecastMonth3,
                        "4月": this.performanceLevel1VO.areawaterForecastMonth4,
                        "5月": this.performanceLevel1VO.areawaterForecastMonth5,
                         "6月": this.performanceLevel1VO.areawaterForecastMonth6,
                          "7月": this.performanceLevel1VO.areawaterForecastMonth7,
                          // "8月": this.performanceLevel1VO.areawaterForecastMonth8,
                          // "9月": this.performanceLevel1VO.areawaterForecastMonth9,
                          // "10月": this.performanceLevel1VO.areawaterForecastMonth10,
                          // "11月": this.performanceLevel1VO.areawaterForecastMonth11,
                          // "12月": this.performanceLevel1VO.areawaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areawaterMonth1,month:1, change: this.performanceLevel1VO.areawaterChangeMonth1,changerate:this.performanceLevel1VO.areawaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areawaterMonth2,month:2, change: this.performanceLevel1VO.areawaterChangeMonth2,changerate:this.performanceLevel1VO.areawaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areawaterMonth3,month:3, change: this.performanceLevel1VO.areawaterChangeMonth3,changerate:this.performanceLevel1VO.areawaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areawaterMonth4,month:4, change: this.performanceLevel1VO.areawaterChangeMonth4,changerate:this.performanceLevel1VO.areawaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areawaterMonth5,month:5, change: this.performanceLevel1VO.areawaterChangeMonth5,changerate:this.performanceLevel1VO.areawaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areawaterMonth6,month:6, change: this.performanceLevel1VO.areawaterChangeMonth6,changerate:this.performanceLevel1VO.areawaterChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areawaterMonth7,month:7, change: this.performanceLevel1VO.areawaterChangeMonth7,changerate:this.performanceLevel1VO.areawaterChangeRateMonth7 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areawaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 7: 
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areawaterForecastMonth1,
                       "2月": this.performanceLevel1VO.areawaterForecastMonth2,
                        "3月": this.performanceLevel1VO.areawaterForecastMonth3,
                        "4月": this.performanceLevel1VO.areawaterForecastMonth4,
                        "5月": this.performanceLevel1VO.areawaterForecastMonth5,
                         "6月": this.performanceLevel1VO.areawaterForecastMonth6,
                          "7月": this.performanceLevel1VO.areawaterForecastMonth7,
                          "8月": this.performanceLevel1VO.areawaterForecastMonth8,
                          // "9月": this.performanceLevel1VO.areawaterForecastMonth9,
                          // "10月": this.performanceLevel1VO.areawaterForecastMonth10,
                          // "11月": this.performanceLevel1VO.areawaterForecastMonth11,
                          // "12月": this.performanceLevel1VO.areawaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areawaterMonth1,month:1, change: this.performanceLevel1VO.areawaterChangeMonth1,changerate:this.performanceLevel1VO.areawaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areawaterMonth2,month:2, change: this.performanceLevel1VO.areawaterChangeMonth2,changerate:this.performanceLevel1VO.areawaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areawaterMonth3,month:3, change: this.performanceLevel1VO.areawaterChangeMonth3,changerate:this.performanceLevel1VO.areawaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areawaterMonth4,month:4, change: this.performanceLevel1VO.areawaterChangeMonth4,changerate:this.performanceLevel1VO.areawaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areawaterMonth5,month:5, change: this.performanceLevel1VO.areawaterChangeMonth5,changerate:this.performanceLevel1VO.areawaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areawaterMonth6,month:6, change: this.performanceLevel1VO.areawaterChangeMonth6,changerate:this.performanceLevel1VO.areawaterChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areawaterMonth7,month:7, change: this.performanceLevel1VO.areawaterChangeMonth7,changerate:this.performanceLevel1VO.areawaterChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areawaterMonth8,month:8, change: this.performanceLevel1VO.areawaterChangeMonth8,changerate:this.performanceLevel1VO.areawaterChangeRateMonth8 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areawaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 8:
                        // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areawaterForecastMonth1,
                       "2月": this.performanceLevel1VO.areawaterForecastMonth2,
                        "3月": this.performanceLevel1VO.areawaterForecastMonth3,
                        "4月": this.performanceLevel1VO.areawaterForecastMonth4,
                        "5月": this.performanceLevel1VO.areawaterForecastMonth5,
                         "6月": this.performanceLevel1VO.areawaterForecastMonth6,
                          "7月": this.performanceLevel1VO.areawaterForecastMonth7,
                          "8月": this.performanceLevel1VO.areawaterForecastMonth8,
                          "9月": this.performanceLevel1VO.areawaterForecastMonth9,
                          // "10月": this.performanceLevel1VO.areawaterForecastMonth10,
                          // "11月": this.performanceLevel1VO.areawaterForecastMonth11,
                          // "12月": this.performanceLevel1VO.areawaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areawaterMonth1,month:1, change: this.performanceLevel1VO.areawaterChangeMonth1,changerate:this.performanceLevel1VO.areawaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areawaterMonth2,month:2, change: this.performanceLevel1VO.areawaterChangeMonth2,changerate:this.performanceLevel1VO.areawaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areawaterMonth3,month:3, change: this.performanceLevel1VO.areawaterChangeMonth3,changerate:this.performanceLevel1VO.areawaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areawaterMonth4,month:4, change: this.performanceLevel1VO.areawaterChangeMonth4,changerate:this.performanceLevel1VO.areawaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areawaterMonth5,month:5, change: this.performanceLevel1VO.areawaterChangeMonth5,changerate:this.performanceLevel1VO.areawaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areawaterMonth6,month:6, change: this.performanceLevel1VO.areawaterChangeMonth6,changerate:this.performanceLevel1VO.areawaterChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areawaterMonth7,month:7, change: this.performanceLevel1VO.areawaterChangeMonth7,changerate:this.performanceLevel1VO.areawaterChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areawaterMonth8,month:8, change: this.performanceLevel1VO.areawaterChangeMonth8,changerate:this.performanceLevel1VO.areawaterChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areawaterMonth9,month:9, change: this.performanceLevel1VO.areawaterChangeMonth9,changerate:this.performanceLevel1VO.areawaterChangeRateMonth9 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areawaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 9:
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areawaterForecastMonth1,
                       "2月": this.performanceLevel1VO.areawaterForecastMonth2,
                        "3月": this.performanceLevel1VO.areawaterForecastMonth3,
                        "4月": this.performanceLevel1VO.areawaterForecastMonth4,
                        "5月": this.performanceLevel1VO.areawaterForecastMonth5,
                         "6月": this.performanceLevel1VO.areawaterForecastMonth6,
                          "7月": this.performanceLevel1VO.areawaterForecastMonth7,
                          "8月": this.performanceLevel1VO.areawaterForecastMonth8,
                          "9月": this.performanceLevel1VO.areawaterForecastMonth9,
                          "10月": this.performanceLevel1VO.areawaterForecastMonth10,
                          // "11月": this.performanceLevel1VO.areawaterForecastMonth11,
                          // "12月": this.performanceLevel1VO.areawaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areawaterMonth1,month:1, change: this.performanceLevel1VO.areawaterChangeMonth1,changerate:this.performanceLevel1VO.areawaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areawaterMonth2,month:2, change: this.performanceLevel1VO.areawaterChangeMonth2,changerate:this.performanceLevel1VO.areawaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areawaterMonth3,month:3, change: this.performanceLevel1VO.areawaterChangeMonth3,changerate:this.performanceLevel1VO.areawaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areawaterMonth4,month:4, change: this.performanceLevel1VO.areawaterChangeMonth4,changerate:this.performanceLevel1VO.areawaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areawaterMonth5,month:5, change: this.performanceLevel1VO.areawaterChangeMonth5,changerate:this.performanceLevel1VO.areawaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areawaterMonth6,month:6, change: this.performanceLevel1VO.areawaterChangeMonth6,changerate:this.performanceLevel1VO.areawaterChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areawaterMonth7,month:7, change: this.performanceLevel1VO.areawaterChangeMonth7,changerate:this.performanceLevel1VO.areawaterChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areawaterMonth8,month:8, change: this.performanceLevel1VO.areawaterChangeMonth8,changerate:this.performanceLevel1VO.areawaterChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areawaterMonth9,month:9, change: this.performanceLevel1VO.areawaterChangeMonth9,changerate:this.performanceLevel1VO.areawaterChangeRateMonth9 },
                    { value: this.performanceLevel1VO.areawaterMonth10,month:10, change: this.performanceLevel1VO.areawaterChangeMonth10,changerate:this.performanceLevel1VO.areawaterChangeRateMonth10 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areawaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 10:
                          // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areawaterForecastMonth1,
                       "2月": this.performanceLevel1VO.areawaterForecastMonth2,
                        "3月": this.performanceLevel1VO.areawaterForecastMonth3,
                        "4月": this.performanceLevel1VO.areawaterForecastMonth4,
                        "5月": this.performanceLevel1VO.areawaterForecastMonth5,
                         "6月": this.performanceLevel1VO.areawaterForecastMonth6,
                          "7月": this.performanceLevel1VO.areawaterForecastMonth7,
                          "8月": this.performanceLevel1VO.areawaterForecastMonth8,
                          "9月": this.performanceLevel1VO.areawaterForecastMonth9,
                          "10月": this.performanceLevel1VO.areawaterForecastMonth10,
                          "11月": this.performanceLevel1VO.areawaterForecastMonth11,
                         // "12月": this.performanceLevel1VO.areawaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areawaterMonth1,month:1, change: this.performanceLevel1VO.areawaterChangeMonth1,changerate:this.performanceLevel1VO.areawaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areawaterMonth2,month:2, change: this.performanceLevel1VO.areawaterChangeMonth2,changerate:this.performanceLevel1VO.areawaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areawaterMonth3,month:3, change: this.performanceLevel1VO.areawaterChangeMonth3,changerate:this.performanceLevel1VO.areawaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areawaterMonth4,month:4, change: this.performanceLevel1VO.areawaterChangeMonth4,changerate:this.performanceLevel1VO.areawaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areawaterMonth5,month:5, change: this.performanceLevel1VO.areawaterChangeMonth5,changerate:this.performanceLevel1VO.areawaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areawaterMonth6,month:6, change: this.performanceLevel1VO.areawaterChangeMonth6,changerate:this.performanceLevel1VO.areawaterChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areawaterMonth7,month:7, change: this.performanceLevel1VO.areawaterChangeMonth7,changerate:this.performanceLevel1VO.areawaterChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areawaterMonth8,month:8, change: this.performanceLevel1VO.areawaterChangeMonth8,changerate:this.performanceLevel1VO.areawaterChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areawaterMonth9,month:9, change: this.performanceLevel1VO.areawaterChangeMonth9,changerate:this.performanceLevel1VO.areawaterChangeRateMonth9 },
                    { value: this.performanceLevel1VO.areawaterMonth10,month:10, change: this.performanceLevel1VO.areawaterChangeMonth10,changerate:this.performanceLevel1VO.areawaterChangeRateMonth10 },
                   { value: this.performanceLevel1VO.areawaterMonth11,month:11, change: this.performanceLevel1VO.areawaterChangeMonth11,changerate:this.performanceLevel1VO.areawaterChangeRateMonth11 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areawaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 11: 
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areawaterForecastMonth1,
                       "2月": this.performanceLevel1VO.areawaterForecastMonth2,
                        "3月": this.performanceLevel1VO.areawaterForecastMonth3,
                        "4月": this.performanceLevel1VO.areawaterForecastMonth4,
                        "5月": this.performanceLevel1VO.areawaterForecastMonth5,
                         "6月": this.performanceLevel1VO.areawaterForecastMonth6,
                          "7月": this.performanceLevel1VO.areawaterForecastMonth7,
                          "8月": this.performanceLevel1VO.areawaterForecastMonth8,
                          "9月": this.performanceLevel1VO.areawaterForecastMonth9,
                          "10月": this.performanceLevel1VO.areawaterForecastMonth10,
                          "11月": this.performanceLevel1VO.areawaterForecastMonth11,
                          "12月": this.performanceLevel1VO.areawaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areawaterMonth1,month:1, change: this.performanceLevel1VO.areawaterChangeMonth1,changerate:this.performanceLevel1VO.areawaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areawaterMonth2,month:2, change: this.performanceLevel1VO.areawaterChangeMonth2,changerate:this.performanceLevel1VO.areawaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areawaterMonth3,month:3, change: this.performanceLevel1VO.areawaterChangeMonth3,changerate:this.performanceLevel1VO.areawaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areawaterMonth4,month:4, change: this.performanceLevel1VO.areawaterChangeMonth4,changerate:this.performanceLevel1VO.areawaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areawaterMonth5,month:5, change: this.performanceLevel1VO.areawaterChangeMonth5,changerate:this.performanceLevel1VO.areawaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areawaterMonth6,month:6, change: this.performanceLevel1VO.areawaterChangeMonth6,changerate:this.performanceLevel1VO.areawaterChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areawaterMonth7,month:7, change: this.performanceLevel1VO.areawaterChangeMonth7,changerate:this.performanceLevel1VO.areawaterChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areawaterMonth8,month:8, change: this.performanceLevel1VO.areawaterChangeMonth8,changerate:this.performanceLevel1VO.areawaterChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areawaterMonth9,month:9, change: this.performanceLevel1VO.areawaterChangeMonth9,changerate:this.performanceLevel1VO.areawaterChangeRateMonth9 },
                    { value: this.performanceLevel1VO.areawaterMonth10,month:10, change: this.performanceLevel1VO.areawaterChangeMonth10,changerate:this.performanceLevel1VO.areawaterChangeRateMonth10 },
                   { value: this.performanceLevel1VO.areawaterMonth11,month:11, change: this.performanceLevel1VO.areawaterChangeMonth11,changerate:this.performanceLevel1VO.areawaterChangeRateMonth11 },
                   { value: this.performanceLevel1VO.areawaterMonth11,month:12, change: this.performanceLevel1VO.areawaterChangeMonth12,changerate:this.performanceLevel1VO.areawaterChangeRateMonth12 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areawaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '12月',
                            name: this.performanceLevel1VO.areawaterEvaluateMonth12,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   

            

             }
            // dataarr=
          }
           if(flag==5){
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                          //  {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaairForecastMonth1,
                      //  "2月": this.performanceLevel1VO.areaairForecastMonth2,
                      //   "3月": this.performanceLevel1VO.areaairForecastMonth3,
                      //   "4月": this.performanceLevel1VO.areaairForecastMonth4,
                      //   "5月": this.performanceLevel1VO.areaairForecastMonth5,
                      //    "6月": this.performanceLevel1VO.areaairForecastMonth6,
                      //     "7月": this.performanceLevel1VO.areaairForecastMonth7,
                      //     "8月": this.performanceLevel1VO.areaairForecastMonth8,
                      //     "9月": this.performanceLevel1VO.areaairForecastMonth9,
                      //     "10月": this.performanceLevel1VO.areaairForecastMonth10,
                      //     "11月": this.performanceLevel1VO.areaairForecastMonth11,
                      //     "12月": this.performanceLevel1VO.areaairForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performanceLevel1VO.areaairEvaluateMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[
                     { value: this.performanceLevel1VO.areaairMonth1,month:1, change: this.performanceLevel1VO.areaairChangeMonth1,changerate:this.performanceLevel1VO.areaairChangeRateMonth1 },
                          
                  ];//目标值
                  
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaairForecastMonth1,
                       "2月": this.performanceLevel1VO.areaairForecastMonth2,
                        // "3月": this.performanceLevel1VO.areaairForecastMonth3,
                        // "4月": this.performanceLevel1VO.areaairForecastMonth4,
                        // "5月": this.performanceLevel1VO.areaairForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areaairForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areaairForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areaairForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areaairForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areaairForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaairForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaairForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                             { value: this.performanceLevel1VO.areaairMonth1,month:1, change: this.performanceLevel1VO.areaairChangeMonth1,changerate:this.performanceLevel1VO.areaairChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaairMonth2,month:2, change: this.performanceLevel1VO.areaairChangeMonth2,changerate:this.performanceLevel1VO.areaairChangeRateMonth2 },
                     
                             ];//目标值
            
                     this.tableData=[{
                        date: '1月',
                        name: this.performanceLevel1VO.areaairEvaluateMonth1,
                        //image: require(besturl)
                        }, 
                      {
                        date: '2月',
                        name: this.performanceLevel1VO.areaairEvaluateMonth2,
                      // image: require(besturl)
                        }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaairForecastMonth1,
                       "2月": this.performanceLevel1VO.areaairForecastMonth2,
                        "3月": this.performanceLevel1VO.areaairForecastMonth3,
                        // "4月": this.performanceLevel1VO.areaairForecastMonth4,
                        // "5月": this.performanceLevel1VO.areaairForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areaairForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areaairForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areaairForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areaairForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areaairForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaairForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaairForecastMonth12,
                     }
                  ];
                     this.dataarr=[
                               { value: this.performanceLevel1VO.areaairMonth1,month:1, change: this.performanceLevel1VO.areaairChangeMonth1,changerate:this.performanceLevel1VO.areaairChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaairMonth2,month:2, change: this.performanceLevel1VO.areaairChangeMonth2,changerate:this.performanceLevel1VO.areaairChangeRateMonth2 },
                       { value: this.performanceLevel1VO.areaairMonth3,month:3, change: this.performanceLevel1VO.areaairChangeMonth3,changerate:this.performanceLevel1VO.areaairChangeRateMonth3 },
                     
                             
                             ];//目标值
              
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaairEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaairForecastMonth1,
                       "2月": this.performanceLevel1VO.areaairForecastMonth2,
                        "3月": this.performanceLevel1VO.areaairForecastMonth3,
                        "4月": this.performanceLevel1VO.areaairForecastMonth4,
                        // "5月": this.performanceLevel1VO.areaairForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areaairForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areaairForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areaairForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areaairForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areaairForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaairForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaairForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                                { value: this.performanceLevel1VO.areaairMonth1,month:1, change: this.performanceLevel1VO.areaairChangeMonth1,changerate:this.performanceLevel1VO.areaairChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaairMonth2,month:2, change: this.performanceLevel1VO.areaairChangeMonth2,changerate:this.performanceLevel1VO.areaairChangeRateMonth2 },
                       { value: this.performanceLevel1VO.areaairMonth3,month:3, change: this.performanceLevel1VO.areaairChangeMonth3,changerate:this.performanceLevel1VO.areaairChangeRateMonth3 },
                      { value: this.performanceLevel1VO.areaairMonth4,month:4, change: this.performanceLevel1VO.areaairChangeMonth4,changerate:this.performanceLevel1VO.areaairChangeRateMonth4 },
                     
                              
                              ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaairEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
               case 4:   
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaairForecastMonth1,
                       "2月": this.performanceLevel1VO.areaairForecastMonth2,
                        "3月": this.performanceLevel1VO.areaairForecastMonth3,
                        "4月": this.performanceLevel1VO.areaairForecastMonth4,
                        "5月": this.performanceLevel1VO.areaairForecastMonth5,
                        //  "6月": this.performanceLevel1VO.areaairForecastMonth6,
                        //   "7月": this.performanceLevel1VO.areaairForecastMonth7,
                        //   "8月": this.performanceLevel1VO.areaairForecastMonth8,
                        //   "9月": this.performanceLevel1VO.areaairForecastMonth9,
                        //   "10月": this.performanceLevel1VO.areaairForecastMonth10,
                        //   "11月": this.performanceLevel1VO.areaairForecastMonth11,
                        //   "12月": this.performanceLevel1VO.areaairForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaairMonth1,month:1, change: this.performanceLevel1VO.areaairChangeMonth1,changerate:this.performanceLevel1VO.areaairChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaairMonth2,month:2, change: this.performanceLevel1VO.areaairChangeMonth2,changerate:this.performanceLevel1VO.areaairChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaairMonth3,month:3, change: this.performanceLevel1VO.areaairChangeMonth3,changerate:this.performanceLevel1VO.areaairChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaairMonth4,month:4, change: this.performanceLevel1VO.areaairChangeMonth4,changerate:this.performanceLevel1VO.areaairChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaairMonth5,month:5, change: this.performanceLevel1VO.areaairChangeMonth5,changerate:this.performanceLevel1VO.areaairChangeRateMonth5 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaairEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;               
                case 5:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaairForecastMonth1,
                       "2月": this.performanceLevel1VO.areaairForecastMonth2,
                        "3月": this.performanceLevel1VO.areaairForecastMonth3,
                        "4月": this.performanceLevel1VO.areaairForecastMonth4,
                        "5月": this.performanceLevel1VO.areaairForecastMonth5,
                         "6月": this.performanceLevel1VO.areaairForecastMonth6,
                          // "7月": this.performanceLevel1VO.areaairForecastMonth7,
                          // "8月": this.performanceLevel1VO.areaairForecastMonth8,
                          // "9月": this.performanceLevel1VO.areaairForecastMonth9,
                          // "10月": this.performanceLevel1VO.areaairForecastMonth10,
                          // "11月": this.performanceLevel1VO.areaairForecastMonth11,
                          // "12月": this.performanceLevel1VO.areaairForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaairMonth1,month:1, change: this.performanceLevel1VO.areaairChangeMonth1,changerate:this.performanceLevel1VO.areaairChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaairMonth2,month:2, change: this.performanceLevel1VO.areaairChangeMonth2,changerate:this.performanceLevel1VO.areaairChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaairMonth3,month:3, change: this.performanceLevel1VO.areaairChangeMonth3,changerate:this.performanceLevel1VO.areaairChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaairMonth4,month:4, change: this.performanceLevel1VO.areaairChangeMonth4,changerate:this.performanceLevel1VO.areaairChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaairMonth5,month:5, change: this.performanceLevel1VO.areaairChangeMonth5,changerate:this.performanceLevel1VO.areaairChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaairMonth6,month:6, change: this.performanceLevel1VO.areaairChangeMonth6,changerate:this.performanceLevel1VO.areaairChangeRateMonth6 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaairEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 6:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaairForecastMonth1,
                       "2月": this.performanceLevel1VO.areaairForecastMonth2,
                        "3月": this.performanceLevel1VO.areaairForecastMonth3,
                        "4月": this.performanceLevel1VO.areaairForecastMonth4,
                        "5月": this.performanceLevel1VO.areaairForecastMonth5,
                         "6月": this.performanceLevel1VO.areaairForecastMonth6,
                          "7月": this.performanceLevel1VO.areaairForecastMonth7,
                          // "8月": this.performanceLevel1VO.areaairForecastMonth8,
                          // "9月": this.performanceLevel1VO.areaairForecastMonth9,
                          // "10月": this.performanceLevel1VO.areaairForecastMonth10,
                          // "11月": this.performanceLevel1VO.areaairForecastMonth11,
                          // "12月": this.performanceLevel1VO.areaairForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaairMonth1,month:1, change: this.performanceLevel1VO.areaairChangeMonth1,changerate:this.performanceLevel1VO.areaairChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaairMonth2,month:2, change: this.performanceLevel1VO.areaairChangeMonth2,changerate:this.performanceLevel1VO.areaairChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaairMonth3,month:3, change: this.performanceLevel1VO.areaairChangeMonth3,changerate:this.performanceLevel1VO.areaairChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaairMonth4,month:4, change: this.performanceLevel1VO.areaairChangeMonth4,changerate:this.performanceLevel1VO.areaairChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaairMonth5,month:5, change: this.performanceLevel1VO.areaairChangeMonth5,changerate:this.performanceLevel1VO.areaairChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaairMonth6,month:6, change: this.performanceLevel1VO.areaairChangeMonth6,changerate:this.performanceLevel1VO.areaairChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areaairMonth7,month:7, change: this.performanceLevel1VO.areaairChangeMonth7,changerate:this.performanceLevel1VO.areaairChangeRateMonth7 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaairEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 7: 
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaairForecastMonth1,
                       "2月": this.performanceLevel1VO.areaairForecastMonth2,
                        "3月": this.performanceLevel1VO.areaairForecastMonth3,
                        "4月": this.performanceLevel1VO.areaairForecastMonth4,
                        "5月": this.performanceLevel1VO.areaairForecastMonth5,
                         "6月": this.performanceLevel1VO.areaairForecastMonth6,
                          "7月": this.performanceLevel1VO.areaairForecastMonth7,
                          "8月": this.performanceLevel1VO.areaairForecastMonth8,
                          // "9月": this.performanceLevel1VO.areaairForecastMonth9,
                          // "10月": this.performanceLevel1VO.areaairForecastMonth10,
                          // "11月": this.performanceLevel1VO.areaairForecastMonth11,
                          // "12月": this.performanceLevel1VO.areaairForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaairMonth1,month:1, change: this.performanceLevel1VO.areaairChangeMonth1,changerate:this.performanceLevel1VO.areaairChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaairMonth2,month:2, change: this.performanceLevel1VO.areaairChangeMonth2,changerate:this.performanceLevel1VO.areaairChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaairMonth3,month:3, change: this.performanceLevel1VO.areaairChangeMonth3,changerate:this.performanceLevel1VO.areaairChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaairMonth4,month:4, change: this.performanceLevel1VO.areaairChangeMonth4,changerate:this.performanceLevel1VO.areaairChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaairMonth5,month:5, change: this.performanceLevel1VO.areaairChangeMonth5,changerate:this.performanceLevel1VO.areaairChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaairMonth6,month:6, change: this.performanceLevel1VO.areaairChangeMonth6,changerate:this.performanceLevel1VO.areaairChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areaairMonth7,month:7, change: this.performanceLevel1VO.areaairChangeMonth7,changerate:this.performanceLevel1VO.areaairChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areaairMonth8,month:8, change: this.performanceLevel1VO.areaairChangeMonth8,changerate:this.performanceLevel1VO.areaairChangeRateMonth8 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaairEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 8:
                        // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaairForecastMonth1,
                       "2月": this.performanceLevel1VO.areaairForecastMonth2,
                        "3月": this.performanceLevel1VO.areaairForecastMonth3,
                        "4月": this.performanceLevel1VO.areaairForecastMonth4,
                        "5月": this.performanceLevel1VO.areaairForecastMonth5,
                         "6月": this.performanceLevel1VO.areaairForecastMonth6,
                          "7月": this.performanceLevel1VO.areaairForecastMonth7,
                          "8月": this.performanceLevel1VO.areaairForecastMonth8,
                          "9月": this.performanceLevel1VO.areaairForecastMonth9,
                          // "10月": this.performanceLevel1VO.areaairForecastMonth10,
                          // "11月": this.performanceLevel1VO.areaairForecastMonth11,
                          // "12月": this.performanceLevel1VO.areaairForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaairMonth1,month:1, change: this.performanceLevel1VO.areaairChangeMonth1,changerate:this.performanceLevel1VO.areaairChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaairMonth2,month:2, change: this.performanceLevel1VO.areaairChangeMonth2,changerate:this.performanceLevel1VO.areaairChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaairMonth3,month:3, change: this.performanceLevel1VO.areaairChangeMonth3,changerate:this.performanceLevel1VO.areaairChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaairMonth4,month:4, change: this.performanceLevel1VO.areaairChangeMonth4,changerate:this.performanceLevel1VO.areaairChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaairMonth5,month:5, change: this.performanceLevel1VO.areaairChangeMonth5,changerate:this.performanceLevel1VO.areaairChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaairMonth6,month:6, change: this.performanceLevel1VO.areaairChangeMonth6,changerate:this.performanceLevel1VO.areaairChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areaairMonth7,month:7, change: this.performanceLevel1VO.areaairChangeMonth7,changerate:this.performanceLevel1VO.areaairChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areaairMonth8,month:8, change: this.performanceLevel1VO.areaairChangeMonth8,changerate:this.performanceLevel1VO.areaairChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areaairMonth9,month:9, change: this.performanceLevel1VO.areaairChangeMonth9,changerate:this.performanceLevel1VO.areaairChangeRateMonth9 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaairEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 9:
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaairForecastMonth1,
                       "2月": this.performanceLevel1VO.areaairForecastMonth2,
                        "3月": this.performanceLevel1VO.areaairForecastMonth3,
                        "4月": this.performanceLevel1VO.areaairForecastMonth4,
                        "5月": this.performanceLevel1VO.areaairForecastMonth5,
                         "6月": this.performanceLevel1VO.areaairForecastMonth6,
                          "7月": this.performanceLevel1VO.areaairForecastMonth7,
                          "8月": this.performanceLevel1VO.areaairForecastMonth8,
                          "9月": this.performanceLevel1VO.areaairForecastMonth9,
                          "10月": this.performanceLevel1VO.areaairForecastMonth10,
                          // "11月": this.performanceLevel1VO.areaairForecastMonth11,
                          // "12月": this.performanceLevel1VO.areaairForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaairMonth1,month:1, change: this.performanceLevel1VO.areaairChangeMonth1,changerate:this.performanceLevel1VO.areaairChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaairMonth2,month:2, change: this.performanceLevel1VO.areaairChangeMonth2,changerate:this.performanceLevel1VO.areaairChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaairMonth3,month:3, change: this.performanceLevel1VO.areaairChangeMonth3,changerate:this.performanceLevel1VO.areaairChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaairMonth4,month:4, change: this.performanceLevel1VO.areaairChangeMonth4,changerate:this.performanceLevel1VO.areaairChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaairMonth5,month:5, change: this.performanceLevel1VO.areaairChangeMonth5,changerate:this.performanceLevel1VO.areaairChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaairMonth6,month:6, change: this.performanceLevel1VO.areaairChangeMonth6,changerate:this.performanceLevel1VO.areaairChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areaairMonth7,month:7, change: this.performanceLevel1VO.areaairChangeMonth7,changerate:this.performanceLevel1VO.areaairChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areaairMonth8,month:8, change: this.performanceLevel1VO.areaairChangeMonth8,changerate:this.performanceLevel1VO.areaairChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areaairMonth9,month:9, change: this.performanceLevel1VO.areaairChangeMonth9,changerate:this.performanceLevel1VO.areaairChangeRateMonth9 },
                    { value: this.performanceLevel1VO.areaairMonth10,month:10, change: this.performanceLevel1VO.areaairChangeMonth10,changerate:this.performanceLevel1VO.areaairChangeRateMonth10 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaairEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 10:
                          // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaairForecastMonth1,
                       "2月": this.performanceLevel1VO.areaairForecastMonth2,
                        "3月": this.performanceLevel1VO.areaairForecastMonth3,
                        "4月": this.performanceLevel1VO.areaairForecastMonth4,
                        "5月": this.performanceLevel1VO.areaairForecastMonth5,
                         "6月": this.performanceLevel1VO.areaairForecastMonth6,
                          "7月": this.performanceLevel1VO.areaairForecastMonth7,
                          "8月": this.performanceLevel1VO.areaairForecastMonth8,
                          "9月": this.performanceLevel1VO.areaairForecastMonth9,
                          "10月": this.performanceLevel1VO.areaairForecastMonth10,
                          "11月": this.performanceLevel1VO.areaairForecastMonth11,
                         // "12月": this.performanceLevel1VO.areaairForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaairMonth1,month:1, change: this.performanceLevel1VO.areaairChangeMonth1,changerate:this.performanceLevel1VO.areaairChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaairMonth2,month:2, change: this.performanceLevel1VO.areaairChangeMonth2,changerate:this.performanceLevel1VO.areaairChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaairMonth3,month:3, change: this.performanceLevel1VO.areaairChangeMonth3,changerate:this.performanceLevel1VO.areaairChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaairMonth4,month:4, change: this.performanceLevel1VO.areaairChangeMonth4,changerate:this.performanceLevel1VO.areaairChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaairMonth5,month:5, change: this.performanceLevel1VO.areaairChangeMonth5,changerate:this.performanceLevel1VO.areaairChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaairMonth6,month:6, change: this.performanceLevel1VO.areaairChangeMonth6,changerate:this.performanceLevel1VO.areaairChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areaairMonth7,month:7, change: this.performanceLevel1VO.areaairChangeMonth7,changerate:this.performanceLevel1VO.areaairChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areaairMonth8,month:8, change: this.performanceLevel1VO.areaairChangeMonth8,changerate:this.performanceLevel1VO.areaairChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areaairMonth9,month:9, change: this.performanceLevel1VO.areaairChangeMonth9,changerate:this.performanceLevel1VO.areaairChangeRateMonth9 },
                    { value: this.performanceLevel1VO.areaairMonth10,month:10, change: this.performanceLevel1VO.areaairChangeMonth10,changerate:this.performanceLevel1VO.areaairChangeRateMonth10 },
                   { value: this.performanceLevel1VO.areaairMonth11,month:11, change: this.performanceLevel1VO.areaairChangeMonth11,changerate:this.performanceLevel1VO.areaairChangeRateMonth11 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaairEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 11: 
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.areaairForecastMonth1,
                       "2月": this.performanceLevel1VO.areaairForecastMonth2,
                        "3月": this.performanceLevel1VO.areaairForecastMonth3,
                        "4月": this.performanceLevel1VO.areaairForecastMonth4,
                        "5月": this.performanceLevel1VO.areaairForecastMonth5,
                         "6月": this.performanceLevel1VO.areaairForecastMonth6,
                          "7月": this.performanceLevel1VO.areaairForecastMonth7,
                          "8月": this.performanceLevel1VO.areaairForecastMonth8,
                          "9月": this.performanceLevel1VO.areaairForecastMonth9,
                          "10月": this.performanceLevel1VO.areaairForecastMonth10,
                          "11月": this.performanceLevel1VO.areaairForecastMonth11,
                          "12月": this.performanceLevel1VO.areaairForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.areaairMonth1,month:1, change: this.performanceLevel1VO.areaairChangeMonth1,changerate:this.performanceLevel1VO.areaairChangeRateMonth1 },
                             { value: this.performanceLevel1VO.areaairMonth2,month:2, change: this.performanceLevel1VO.areaairChangeMonth2,changerate:this.performanceLevel1VO.areaairChangeRateMonth2 },
                             { value: this.performanceLevel1VO.areaairMonth3,month:3, change: this.performanceLevel1VO.areaairChangeMonth3,changerate:this.performanceLevel1VO.areaairChangeRateMonth3 },
                             { value: this.performanceLevel1VO.areaairMonth4,month:4, change: this.performanceLevel1VO.areaairChangeMonth4,changerate:this.performanceLevel1VO.areaairChangeRateMonth4 },
                             { value: this.performanceLevel1VO.areaairMonth5,month:5, change: this.performanceLevel1VO.areaairChangeMonth5,changerate:this.performanceLevel1VO.areaairChangeRateMonth5 },
                      { value: this.performanceLevel1VO.areaairMonth6,month:6, change: this.performanceLevel1VO.areaairChangeMonth6,changerate:this.performanceLevel1VO.areaairChangeRateMonth6 },
                     { value: this.performanceLevel1VO.areaairMonth7,month:7, change: this.performanceLevel1VO.areaairChangeMonth7,changerate:this.performanceLevel1VO.areaairChangeRateMonth7 },
                   { value: this.performanceLevel1VO.areaairMonth8,month:8, change: this.performanceLevel1VO.areaairChangeMonth8,changerate:this.performanceLevel1VO.areaairChangeRateMonth8 },
                     { value: this.performanceLevel1VO.areaairMonth9,month:9, change: this.performanceLevel1VO.areaairChangeMonth9,changerate:this.performanceLevel1VO.areaairChangeRateMonth9 },
                    { value: this.performanceLevel1VO.areaairMonth10,month:10, change: this.performanceLevel1VO.areaairChangeMonth10,changerate:this.performanceLevel1VO.areaairChangeRateMonth10 },
                   { value: this.performanceLevel1VO.areaairMonth11,month:11, change: this.performanceLevel1VO.areaairChangeMonth11,changerate:this.performanceLevel1VO.areaairChangeRateMonth11 },
                   { value: this.performanceLevel1VO.areaairMonth11,month:12, change: this.performanceLevel1VO.areaairChangeMonth12,changerate:this.performanceLevel1VO.areaairChangeRateMonth12 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.areaairEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '12月',
                            name: this.performanceLevel1VO.areaairEvaluateMonth12,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   

            

             }
            // dataarr=
          }
           if(flag==6){
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                          //  {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perForecastMonth1,
                        // "2月": this.performanceLevel1VO.perForecastMonth2,
                        // "3月": this.performanceLevel1VO.perForecastMonth3,
                        // "4月": this.performanceLevel1VO.perForecastMonth4,
                        // "5月": this.performanceLevel1VO.perForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performanceLevel1VO.perEvaluateMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[
                    { value: this.performanceLevel1VO.perMonth1,month:1, change: this.performanceLevel1VO.perChangeMonth1,changerate:this.performanceLevel1VO.perChangeRateMonth1 },
                      
                  ];//目标值
                  
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perForecastMonth1,
                        "2月": this.performanceLevel1VO.perForecastMonth2,
                        // "3月": this.performanceLevel1VO.perForecastMonth3,
                        // "4月": this.performanceLevel1VO.perForecastMonth4,
                        // "5月": this.performanceLevel1VO.perForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perMonth1,month:1, change: this.performanceLevel1VO.perChangeMonth1,changerate:this.performanceLevel1VO.perChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perMonth2,month:2, change: this.performanceLevel1VO.perChangeMonth2,changerate:this.performanceLevel1VO.perChangeRateMonth2 },
                      
                             ];//目标值
            
                     this.tableData=[{
                        date: '1月',
                        name: this.performanceLevel1VO.perEvaluateMonth1,
                        //image: require(besturl)
                        }, 
                      {
                        date: '2月',
                        name: this.performanceLevel1VO.perEvaluateMonth2,
                      // image: require(besturl)
                        }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perForecastMonth1,
                        "2月": this.performanceLevel1VO.perForecastMonth2,
                        "3月": this.performanceLevel1VO.perForecastMonth3,
                        // "4月": this.performanceLevel1VO.perForecastMonth4,
                        // "5月": this.performanceLevel1VO.perForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perForecastMonth12,
                     }
                  ];
                     this.dataarr=[
                               { value: this.performanceLevel1VO.perMonth1,month:1, change: this.performanceLevel1VO.perChangeMonth1,changerate:this.performanceLevel1VO.perChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perMonth2,month:2, change: this.performanceLevel1VO.perChangeMonth2,changerate:this.performanceLevel1VO.perChangeRateMonth2 },
                       { value: this.performanceLevel1VO.perMonth3,month:3, change: this.performanceLevel1VO.perChangeMonth3,changerate:this.performanceLevel1VO.perChangeRateMonth3 },
                      
                             ];//目标值
              
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perForecastMonth1,
                        "2月": this.performanceLevel1VO.perForecastMonth2,
                        "3月": this.performanceLevel1VO.perForecastMonth3,
                        "4月": this.performanceLevel1VO.perForecastMonth4,
                        // "5月": this.performanceLevel1VO.perForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                                { value: this.performanceLevel1VO.perMonth1,month:1, change: this.performanceLevel1VO.perChangeMonth1,changerate:this.performanceLevel1VO.perChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perMonth2,month:2, change: this.performanceLevel1VO.perChangeMonth2,changerate:this.performanceLevel1VO.perChangeRateMonth2 },
                       { value: this.performanceLevel1VO.perMonth3,month:3, change: this.performanceLevel1VO.perChangeMonth3,changerate:this.performanceLevel1VO.perChangeRateMonth3 },
                      { value: this.performanceLevel1VO.perMonth4,month:4, change: this.performanceLevel1VO.perChangeMonth4,changerate:this.performanceLevel1VO.perChangeRateMonth4 },
                  
                              ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
                case 4:   
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perForecastMonth1,
                        "2月": this.performanceLevel1VO.perForecastMonth2,
                        "3月": this.performanceLevel1VO.perForecastMonth3,
                        "4月": this.performanceLevel1VO.perForecastMonth4,
                        "5月": this.performanceLevel1VO.perForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perMonth1,month:1, change: this.performanceLevel1VO.perChangeMonth1,changerate:this.performanceLevel1VO.perChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perMonth2,month:2, change: this.performanceLevel1VO.perChangeMonth2,changerate:this.performanceLevel1VO.perChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perMonth3,month:3, change: this.performanceLevel1VO.perChangeMonth3,changerate:this.performanceLevel1VO.perChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perMonth4,month:4, change: this.performanceLevel1VO.perChangeMonth4,changerate:this.performanceLevel1VO.perChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perMonth5,month:5, change: this.performanceLevel1VO.perChangeMonth5,changerate:this.performanceLevel1VO.perChangeRateMonth5 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;               
                case 5:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perForecastMonth1,
                        "2月": this.performanceLevel1VO.perForecastMonth2,
                        "3月": this.performanceLevel1VO.perForecastMonth3,
                        "4月": this.performanceLevel1VO.perForecastMonth4,
                        "5月": this.performanceLevel1VO.perForecastMonth5,
                         "6月": this.performanceLevel1VO.perForecastMonth6,
                          // "7月": this.performanceLevel1VO.perForecastMonth7,
                          // "8月": this.performanceLevel1VO.perForecastMonth8,
                          // "9月": this.performanceLevel1VO.perForecastMonth9,
                          // "10月": this.performanceLevel1VO.perForecastMonth10,
                          // "11月": this.performanceLevel1VO.perForecastMonth11,
                          // "12月": this.performanceLevel1VO.perForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perMonth1,month:1, change: this.performanceLevel1VO.perChangeMonth1,changerate:this.performanceLevel1VO.perChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perMonth2,month:2, change: this.performanceLevel1VO.perChangeMonth2,changerate:this.performanceLevel1VO.perChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perMonth3,month:3, change: this.performanceLevel1VO.perChangeMonth3,changerate:this.performanceLevel1VO.perChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perMonth4,month:4, change: this.performanceLevel1VO.perChangeMonth4,changerate:this.performanceLevel1VO.perChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perMonth5,month:5, change: this.performanceLevel1VO.perChangeMonth5,changerate:this.performanceLevel1VO.perChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perMonth6,month:6, change: this.performanceLevel1VO.perChangeMonth6,changerate:this.performanceLevel1VO.perChangeRateMonth6 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 6:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perForecastMonth1,
                        "2月": this.performanceLevel1VO.perForecastMonth2,
                        "3月": this.performanceLevel1VO.perForecastMonth3,
                        "4月": this.performanceLevel1VO.perForecastMonth4,
                        "5月": this.performanceLevel1VO.perForecastMonth5,
                         "6月": this.performanceLevel1VO.perForecastMonth6,
                          "7月": this.performanceLevel1VO.perForecastMonth7,
                          // "8月": this.performanceLevel1VO.perForecastMonth8,
                          // "9月": this.performanceLevel1VO.perForecastMonth9,
                          // "10月": this.performanceLevel1VO.perForecastMonth10,
                          // "11月": this.performanceLevel1VO.perForecastMonth11,
                          // "12月": this.performanceLevel1VO.perForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perMonth1,month:1, change: this.performanceLevel1VO.perChangeMonth1,changerate:this.performanceLevel1VO.perChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perMonth2,month:2, change: this.performanceLevel1VO.perChangeMonth2,changerate:this.performanceLevel1VO.perChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perMonth3,month:3, change: this.performanceLevel1VO.perChangeMonth3,changerate:this.performanceLevel1VO.perChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perMonth4,month:4, change: this.performanceLevel1VO.perChangeMonth4,changerate:this.performanceLevel1VO.perChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perMonth5,month:5, change: this.performanceLevel1VO.perChangeMonth5,changerate:this.performanceLevel1VO.perChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perMonth6,month:6, change: this.performanceLevel1VO.perChangeMonth6,changerate:this.performanceLevel1VO.perChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perMonth7,month:7, change: this.performanceLevel1VO.perChangeMonth7,changerate:this.performanceLevel1VO.perChangeRateMonth7 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 7: 
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perForecastMonth1,
                        "2月": this.performanceLevel1VO.perForecastMonth2,
                        "3月": this.performanceLevel1VO.perForecastMonth3,
                        "4月": this.performanceLevel1VO.perForecastMonth4,
                        "5月": this.performanceLevel1VO.perForecastMonth5,
                         "6月": this.performanceLevel1VO.perForecastMonth6,
                          "7月": this.performanceLevel1VO.perForecastMonth7,
                          "8月": this.performanceLevel1VO.perForecastMonth8,
                          // "9月": this.performanceLevel1VO.perForecastMonth9,
                          // "10月": this.performanceLevel1VO.perForecastMonth10,
                          // "11月": this.performanceLevel1VO.perForecastMonth11,
                          // "12月": this.performanceLevel1VO.perForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perMonth1,month:1, change: this.performanceLevel1VO.perChangeMonth1,changerate:this.performanceLevel1VO.perChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perMonth2,month:2, change: this.performanceLevel1VO.perChangeMonth2,changerate:this.performanceLevel1VO.perChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perMonth3,month:3, change: this.performanceLevel1VO.perChangeMonth3,changerate:this.performanceLevel1VO.perChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perMonth4,month:4, change: this.performanceLevel1VO.perChangeMonth4,changerate:this.performanceLevel1VO.perChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perMonth5,month:5, change: this.performanceLevel1VO.perChangeMonth5,changerate:this.performanceLevel1VO.perChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perMonth6,month:6, change: this.performanceLevel1VO.perChangeMonth6,changerate:this.performanceLevel1VO.perChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perMonth7,month:7, change: this.performanceLevel1VO.perChangeMonth7,changerate:this.performanceLevel1VO.perChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perMonth8,month:8, change: this.performanceLevel1VO.perChangeMonth8,changerate:this.performanceLevel1VO.perChangeRateMonth8 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 8:
                        // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perForecastMonth1,
                        "2月": this.performanceLevel1VO.perForecastMonth2,
                        "3月": this.performanceLevel1VO.perForecastMonth3,
                        "4月": this.performanceLevel1VO.perForecastMonth4,
                        "5月": this.performanceLevel1VO.perForecastMonth5,
                         "6月": this.performanceLevel1VO.perForecastMonth6,
                          "7月": this.performanceLevel1VO.perForecastMonth7,
                          "8月": this.performanceLevel1VO.perForecastMonth8,
                          "9月": this.performanceLevel1VO.perForecastMonth9,
                          // "10月": this.performanceLevel1VO.perForecastMonth10,
                          // "11月": this.performanceLevel1VO.perForecastMonth11,
                          // "12月": this.performanceLevel1VO.perForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perMonth1,month:1, change: this.performanceLevel1VO.perChangeMonth1,changerate:this.performanceLevel1VO.perChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perMonth2,month:2, change: this.performanceLevel1VO.perChangeMonth2,changerate:this.performanceLevel1VO.perChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perMonth3,month:3, change: this.performanceLevel1VO.perChangeMonth3,changerate:this.performanceLevel1VO.perChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perMonth4,month:4, change: this.performanceLevel1VO.perChangeMonth4,changerate:this.performanceLevel1VO.perChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perMonth5,month:5, change: this.performanceLevel1VO.perChangeMonth5,changerate:this.performanceLevel1VO.perChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perMonth6,month:6, change: this.performanceLevel1VO.perChangeMonth6,changerate:this.performanceLevel1VO.perChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perMonth7,month:7, change: this.performanceLevel1VO.perChangeMonth7,changerate:this.performanceLevel1VO.perChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perMonth8,month:8, change: this.performanceLevel1VO.perChangeMonth8,changerate:this.performanceLevel1VO.perChangeRateMonth8 },
                     { value: this.performanceLevel1VO.perMonth9,month:9, change: this.performanceLevel1VO.perChangeMonth9,changerate:this.performanceLevel1VO.perChangeRateMonth9 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.perEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 9:
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perForecastMonth1,
                        "2月": this.performanceLevel1VO.perForecastMonth2,
                        "3月": this.performanceLevel1VO.perForecastMonth3,
                        "4月": this.performanceLevel1VO.perForecastMonth4,
                        "5月": this.performanceLevel1VO.perForecastMonth5,
                         "6月": this.performanceLevel1VO.perForecastMonth6,
                          "7月": this.performanceLevel1VO.perForecastMonth7,
                          "8月": this.performanceLevel1VO.perForecastMonth8,
                          "9月": this.performanceLevel1VO.perForecastMonth9,
                          "10月": this.performanceLevel1VO.perForecastMonth10,
                          // "11月": this.performanceLevel1VO.perForecastMonth11,
                          // "12月": this.performanceLevel1VO.perForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perMonth1,month:1, change: this.performanceLevel1VO.perChangeMonth1,changerate:this.performanceLevel1VO.perChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perMonth2,month:2, change: this.performanceLevel1VO.perChangeMonth2,changerate:this.performanceLevel1VO.perChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perMonth3,month:3, change: this.performanceLevel1VO.perChangeMonth3,changerate:this.performanceLevel1VO.perChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perMonth4,month:4, change: this.performanceLevel1VO.perChangeMonth4,changerate:this.performanceLevel1VO.perChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perMonth5,month:5, change: this.performanceLevel1VO.perChangeMonth5,changerate:this.performanceLevel1VO.perChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perMonth6,month:6, change: this.performanceLevel1VO.perChangeMonth6,changerate:this.performanceLevel1VO.perChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perMonth7,month:7, change: this.performanceLevel1VO.perChangeMonth7,changerate:this.performanceLevel1VO.perChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perMonth8,month:8, change: this.performanceLevel1VO.perChangeMonth8,changerate:this.performanceLevel1VO.perChangeRateMonth8 },
                     { value: this.performanceLevel1VO.perMonth9,month:9, change: this.performanceLevel1VO.perChangeMonth9,changerate:this.performanceLevel1VO.perChangeRateMonth9 },
                    { value: this.performanceLevel1VO.perMonth10,month:10, change: this.performanceLevel1VO.perChangeMonth10,changerate:this.performanceLevel1VO.perChangeRateMonth10 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.perEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.perEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 10:
                          // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perForecastMonth1,
                        "2月": this.performanceLevel1VO.perForecastMonth2,
                        "3月": this.performanceLevel1VO.perForecastMonth3,
                        "4月": this.performanceLevel1VO.perForecastMonth4,
                        "5月": this.performanceLevel1VO.perForecastMonth5,
                         "6月": this.performanceLevel1VO.perForecastMonth6,
                          "7月": this.performanceLevel1VO.perForecastMonth7,
                          "8月": this.performanceLevel1VO.perForecastMonth8,
                          "9月": this.performanceLevel1VO.perForecastMonth9,
                          "10月": this.performanceLevel1VO.perForecastMonth10,
                          "11月": this.performanceLevel1VO.perForecastMonth11,
                         // "12月": this.performanceLevel1VO.perForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perMonth1,month:1, change: this.performanceLevel1VO.perChangeMonth1,changerate:this.performanceLevel1VO.perChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perMonth2,month:2, change: this.performanceLevel1VO.perChangeMonth2,changerate:this.performanceLevel1VO.perChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perMonth3,month:3, change: this.performanceLevel1VO.perChangeMonth3,changerate:this.performanceLevel1VO.perChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perMonth4,month:4, change: this.performanceLevel1VO.perChangeMonth4,changerate:this.performanceLevel1VO.perChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perMonth5,month:5, change: this.performanceLevel1VO.perChangeMonth5,changerate:this.performanceLevel1VO.perChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perMonth6,month:6, change: this.performanceLevel1VO.perChangeMonth6,changerate:this.performanceLevel1VO.perChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perMonth7,month:7, change: this.performanceLevel1VO.perChangeMonth7,changerate:this.performanceLevel1VO.perChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perMonth8,month:8, change: this.performanceLevel1VO.perChangeMonth8,changerate:this.performanceLevel1VO.perChangeRateMonth8 },
                     { value: this.performanceLevel1VO.perMonth9,month:9, change: this.performanceLevel1VO.perChangeMonth9,changerate:this.performanceLevel1VO.perChangeRateMonth9 },
                    { value: this.performanceLevel1VO.perMonth10,month:10, change: this.performanceLevel1VO.perChangeMonth10,changerate:this.performanceLevel1VO.perChangeRateMonth10 },
                   { value: this.performanceLevel1VO.perMonth11,month:11, change: this.performanceLevel1VO.perChangeMonth11,changerate:this.performanceLevel1VO.perChangeRateMonth11 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.perEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.perEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.perEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 11: 
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perForecastMonth1,
                        "2月": this.performanceLevel1VO.perForecastMonth2,
                        "3月": this.performanceLevel1VO.perForecastMonth3,
                        "4月": this.performanceLevel1VO.perForecastMonth4,
                        "5月": this.performanceLevel1VO.perForecastMonth5,
                         "6月": this.performanceLevel1VO.perForecastMonth6,
                          "7月": this.performanceLevel1VO.perForecastMonth7,
                          "8月": this.performanceLevel1VO.perForecastMonth8,
                          "9月": this.performanceLevel1VO.perForecastMonth9,
                          "10月": this.performanceLevel1VO.perForecastMonth10,
                          "11月": this.performanceLevel1VO.perForecastMonth11,
                          "12月": this.performanceLevel1VO.perForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perMonth1,month:1, change: this.performanceLevel1VO.perChangeMonth1,changerate:this.performanceLevel1VO.perChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perMonth2,month:2, change: this.performanceLevel1VO.perChangeMonth2,changerate:this.performanceLevel1VO.perChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perMonth3,month:3, change: this.performanceLevel1VO.perChangeMonth3,changerate:this.performanceLevel1VO.perChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perMonth4,month:4, change: this.performanceLevel1VO.perChangeMonth4,changerate:this.performanceLevel1VO.perChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perMonth5,month:5, change: this.performanceLevel1VO.perChangeMonth5,changerate:this.performanceLevel1VO.perChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perMonth6,month:6, change: this.performanceLevel1VO.perChangeMonth6,changerate:this.performanceLevel1VO.perChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perMonth7,month:7, change: this.performanceLevel1VO.perChangeMonth7,changerate:this.performanceLevel1VO.perChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perMonth8,month:8, change: this.performanceLevel1VO.perChangeMonth8,changerate:this.performanceLevel1VO.perChangeRateMonth8 },
                     { value: this.performanceLevel1VO.perMonth9,month:9, change: this.performanceLevel1VO.perChangeMonth9,changerate:this.performanceLevel1VO.perChangeRateMonth9 },
                    { value: this.performanceLevel1VO.perMonth10,month:10, change: this.performanceLevel1VO.perChangeMonth10,changerate:this.performanceLevel1VO.perChangeRateMonth10 },
                   { value: this.performanceLevel1VO.perMonth11,month:11, change: this.performanceLevel1VO.perChangeMonth11,changerate:this.performanceLevel1VO.perChangeRateMonth11 },
                   { value: this.performanceLevel1VO.perMonth11,month:12, change: this.performanceLevel1VO.perChangeMonth12,changerate:this.performanceLevel1VO.perChangeRateMonth12 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.perEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.perEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.perEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '12月',
                            name: this.performanceLevel1VO.perEvaluateMonth12,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   

            

             }
            // dataarr=
          }
          if(flag==7){
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                          //   {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perpowerForecastMonth1,
                      //  "2月": this.performanceLevel1VO.perpowerForecastMonth2,
                      //   "3月": this.performanceLevel1VO.perpowerForecastMonth3,
                      //   "4月": this.performanceLevel1VO.perpowerForecastMonth4,
                      //   "5月": this.performanceLevel1VO.perpowerForecastMonth5,
                      //    "6月": this.performanceLevel1VO.perpowerForecastMonth6,
                      //     "7月": this.performanceLevel1VO.perpowerForecastMonth7,
                      //     "8月": this.performanceLevel1VO.perpowerForecastMonth8,
                      //     "9月": this.performanceLevel1VO.perpowerForecastMonth9,
                      //     "10月": this.performanceLevel1VO.perpowerForecastMonth10,
                      //     "11月": this.performanceLevel1VO.perpowerForecastMonth11,
                      //     "12月": this.performanceLevel1VO.perpowerForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performanceLevel1VO.perpowerEvaluateMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[
                    { value: this.performanceLevel1VO.perpowerMonth1,month:1, change: this.performanceLevel1VO.perpowerChangeMonth1,changerate:this.performanceLevel1VO.perpowerChangeRateMonth1 },
                      
                  ];//目标值
                  
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perpowerForecastMonth1,
                       "2月": this.performanceLevel1VO.perpowerForecastMonth2,
                        // "3月": this.performanceLevel1VO.perpowerForecastMonth3,
                        // "4月": this.performanceLevel1VO.perpowerForecastMonth4,
                        // "5月": this.performanceLevel1VO.perpowerForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perpowerForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perpowerForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perpowerForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perpowerForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perpowerForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perpowerForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perpowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                             { value: this.performanceLevel1VO.perpowerMonth1,month:1, change: this.performanceLevel1VO.perpowerChangeMonth1,changerate:this.performanceLevel1VO.perpowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perpowerMonth2,month:2, change: this.performanceLevel1VO.perpowerChangeMonth2,changerate:this.performanceLevel1VO.perpowerChangeRateMonth2 },
                     
                             ];//目标值
            
                     this.tableData=[{
                        date: '1月',
                        name: this.performanceLevel1VO.perpowerEvaluateMonth1,
                        //image: require(besturl)
                        }, 
                      {
                        date: '2月',
                        name: this.performanceLevel1VO.perpowerEvaluateMonth2,
                      // image: require(besturl)
                        }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perpowerForecastMonth1,
                       "2月": this.performanceLevel1VO.perpowerForecastMonth2,
                        "3月": this.performanceLevel1VO.perpowerForecastMonth3,
                        // "4月": this.performanceLevel1VO.perpowerForecastMonth4,
                        // "5月": this.performanceLevel1VO.perpowerForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perpowerForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perpowerForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perpowerForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perpowerForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perpowerForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perpowerForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perpowerForecastMonth12,
                     }
                  ];
                     this.dataarr=[
                            { value: this.performanceLevel1VO.perpowerMonth1,month:1, change: this.performanceLevel1VO.perpowerChangeMonth1,changerate:this.performanceLevel1VO.perpowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perpowerMonth2,month:2, change: this.performanceLevel1VO.perpowerChangeMonth2,changerate:this.performanceLevel1VO.perpowerChangeRateMonth2 },
                       { value: this.performanceLevel1VO.perpowerMonth3,month:3, change: this.performanceLevel1VO.perpowerChangeMonth3,changerate:this.performanceLevel1VO.perpowerChangeRateMonth3 },
                   
                             ];//目标值
              
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perpowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perpowerForecastMonth1,
                       "2月": this.performanceLevel1VO.perpowerForecastMonth2,
                        "3月": this.performanceLevel1VO.perpowerForecastMonth3,
                        "4月": this.performanceLevel1VO.perpowerForecastMonth4,
                        // "5月": this.performanceLevel1VO.perpowerForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perpowerForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perpowerForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perpowerForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perpowerForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perpowerForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perpowerForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perpowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                             { value: this.performanceLevel1VO.perpowerMonth1,month:1, change: this.performanceLevel1VO.perpowerChangeMonth1,changerate:this.performanceLevel1VO.perpowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perpowerMonth2,month:2, change: this.performanceLevel1VO.perpowerChangeMonth2,changerate:this.performanceLevel1VO.perpowerChangeRateMonth2 },
                       { value: this.performanceLevel1VO.perpowerMonth3,month:3, change: this.performanceLevel1VO.perpowerChangeMonth3,changerate:this.performanceLevel1VO.perpowerChangeRateMonth3 },
                      { value: this.performanceLevel1VO.perpowerMonth4,month:4, change: this.performanceLevel1VO.perpowerChangeMonth4,changerate:this.performanceLevel1VO.perpowerChangeRateMonth4 },
                   
                              ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perpowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
                case 4:   
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                 this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perpowerForecastMonth1,
                       "2月": this.performanceLevel1VO.perpowerForecastMonth2,
                        "3月": this.performanceLevel1VO.perpowerForecastMonth3,
                        "4月": this.performanceLevel1VO.perpowerForecastMonth4,
                        "5月": this.performanceLevel1VO.perpowerForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perpowerForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perpowerForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perpowerForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perpowerForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perpowerForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perpowerForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perpowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perpowerMonth1,month:1, change: this.performanceLevel1VO.perpowerChangeMonth1,changerate:this.performanceLevel1VO.perpowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perpowerMonth2,month:2, change: this.performanceLevel1VO.perpowerChangeMonth2,changerate:this.performanceLevel1VO.perpowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perpowerMonth3,month:3, change: this.performanceLevel1VO.perpowerChangeMonth3,changerate:this.performanceLevel1VO.perpowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perpowerMonth4,month:4, change: this.performanceLevel1VO.perpowerChangeMonth4,changerate:this.performanceLevel1VO.perpowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perpowerMonth5,month:5, change: this.performanceLevel1VO.perpowerChangeMonth5,changerate:this.performanceLevel1VO.perpowerChangeRateMonth5 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perpowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;               
                case 5:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perpowerForecastMonth1,
                       "2月": this.performanceLevel1VO.perpowerForecastMonth2,
                        "3月": this.performanceLevel1VO.perpowerForecastMonth3,
                        "4月": this.performanceLevel1VO.perpowerForecastMonth4,
                        "5月": this.performanceLevel1VO.perpowerForecastMonth5,
                         "6月": this.performanceLevel1VO.perpowerForecastMonth6,
                          // "7月": this.performanceLevel1VO.perpowerForecastMonth7,
                          // "8月": this.performanceLevel1VO.perpowerForecastMonth8,
                          // "9月": this.performanceLevel1VO.perpowerForecastMonth9,
                          // "10月": this.performanceLevel1VO.perpowerForecastMonth10,
                          // "11月": this.performanceLevel1VO.perpowerForecastMonth11,
                          // "12月": this.performanceLevel1VO.perpowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perpowerMonth1,month:1, change: this.performanceLevel1VO.perpowerChangeMonth1,changerate:this.performanceLevel1VO.perpowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perpowerMonth2,month:2, change: this.performanceLevel1VO.perpowerChangeMonth2,changerate:this.performanceLevel1VO.perpowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perpowerMonth3,month:3, change: this.performanceLevel1VO.perpowerChangeMonth3,changerate:this.performanceLevel1VO.perpowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perpowerMonth4,month:4, change: this.performanceLevel1VO.perpowerChangeMonth4,changerate:this.performanceLevel1VO.perpowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perpowerMonth5,month:5, change: this.performanceLevel1VO.perpowerChangeMonth5,changerate:this.performanceLevel1VO.perpowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perpowerMonth6,month:6, change: this.performanceLevel1VO.perpowerChangeMonth6,changerate:this.performanceLevel1VO.perpowerChangeRateMonth6 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perpowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 6:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perpowerForecastMonth1,
                       "2月": this.performanceLevel1VO.perpowerForecastMonth2,
                        "3月": this.performanceLevel1VO.perpowerForecastMonth3,
                        "4月": this.performanceLevel1VO.perpowerForecastMonth4,
                        "5月": this.performanceLevel1VO.perpowerForecastMonth5,
                         "6月": this.performanceLevel1VO.perpowerForecastMonth6,
                          "7月": this.performanceLevel1VO.perpowerForecastMonth7,
                          // "8月": this.performanceLevel1VO.perpowerForecastMonth8,
                          // "9月": this.performanceLevel1VO.perpowerForecastMonth9,
                          // "10月": this.performanceLevel1VO.perpowerForecastMonth10,
                          // "11月": this.performanceLevel1VO.perpowerForecastMonth11,
                          // "12月": this.performanceLevel1VO.perpowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perpowerMonth1,month:1, change: this.performanceLevel1VO.perpowerChangeMonth1,changerate:this.performanceLevel1VO.perpowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perpowerMonth2,month:2, change: this.performanceLevel1VO.perpowerChangeMonth2,changerate:this.performanceLevel1VO.perpowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perpowerMonth3,month:3, change: this.performanceLevel1VO.perpowerChangeMonth3,changerate:this.performanceLevel1VO.perpowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perpowerMonth4,month:4, change: this.performanceLevel1VO.perpowerChangeMonth4,changerate:this.performanceLevel1VO.perpowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perpowerMonth5,month:5, change: this.performanceLevel1VO.perpowerChangeMonth5,changerate:this.performanceLevel1VO.perpowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perpowerMonth6,month:6, change: this.performanceLevel1VO.perpowerChangeMonth6,changerate:this.performanceLevel1VO.perpowerChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perpowerMonth7,month:7, change: this.performanceLevel1VO.perpowerChangeMonth7,changerate:this.performanceLevel1VO.perpowerChangeRateMonth7 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perpowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 7: 
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perpowerForecastMonth1,
                       "2月": this.performanceLevel1VO.perpowerForecastMonth2,
                        "3月": this.performanceLevel1VO.perpowerForecastMonth3,
                        "4月": this.performanceLevel1VO.perpowerForecastMonth4,
                        "5月": this.performanceLevel1VO.perpowerForecastMonth5,
                         "6月": this.performanceLevel1VO.perpowerForecastMonth6,
                          "7月": this.performanceLevel1VO.perpowerForecastMonth7,
                          "8月": this.performanceLevel1VO.perpowerForecastMonth8,
                          // "9月": this.performanceLevel1VO.perpowerForecastMonth9,
                          // "10月": this.performanceLevel1VO.perpowerForecastMonth10,
                          // "11月": this.performanceLevel1VO.perpowerForecastMonth11,
                          // "12月": this.performanceLevel1VO.perpowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perpowerMonth1,month:1, change: this.performanceLevel1VO.perpowerChangeMonth1,changerate:this.performanceLevel1VO.perpowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perpowerMonth2,month:2, change: this.performanceLevel1VO.perpowerChangeMonth2,changerate:this.performanceLevel1VO.perpowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perpowerMonth3,month:3, change: this.performanceLevel1VO.perpowerChangeMonth3,changerate:this.performanceLevel1VO.perpowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perpowerMonth4,month:4, change: this.performanceLevel1VO.perpowerChangeMonth4,changerate:this.performanceLevel1VO.perpowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perpowerMonth5,month:5, change: this.performanceLevel1VO.perpowerChangeMonth5,changerate:this.performanceLevel1VO.perpowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perpowerMonth6,month:6, change: this.performanceLevel1VO.perpowerChangeMonth6,changerate:this.performanceLevel1VO.perpowerChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perpowerMonth7,month:7, change: this.performanceLevel1VO.perpowerChangeMonth7,changerate:this.performanceLevel1VO.perpowerChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perpowerMonth8,month:8, change: this.performanceLevel1VO.perpowerChangeMonth8,changerate:this.performanceLevel1VO.perpowerChangeRateMonth8 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perpowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 8:
                        // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perpowerForecastMonth1,
                       "2月": this.performanceLevel1VO.perpowerForecastMonth2,
                        "3月": this.performanceLevel1VO.perpowerForecastMonth3,
                        "4月": this.performanceLevel1VO.perpowerForecastMonth4,
                        "5月": this.performanceLevel1VO.perpowerForecastMonth5,
                         "6月": this.performanceLevel1VO.perpowerForecastMonth6,
                          "7月": this.performanceLevel1VO.perpowerForecastMonth7,
                          "8月": this.performanceLevel1VO.perpowerForecastMonth8,
                          "9月": this.performanceLevel1VO.perpowerForecastMonth9,
                          // "10月": this.performanceLevel1VO.perpowerForecastMonth10,
                          // "11月": this.performanceLevel1VO.perpowerForecastMonth11,
                          // "12月": this.performanceLevel1VO.perpowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perpowerMonth1,month:1, change: this.performanceLevel1VO.perpowerChangeMonth1,changerate:this.performanceLevel1VO.perpowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perpowerMonth2,month:2, change: this.performanceLevel1VO.perpowerChangeMonth2,changerate:this.performanceLevel1VO.perpowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perpowerMonth3,month:3, change: this.performanceLevel1VO.perpowerChangeMonth3,changerate:this.performanceLevel1VO.perpowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perpowerMonth4,month:4, change: this.performanceLevel1VO.perpowerChangeMonth4,changerate:this.performanceLevel1VO.perpowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perpowerMonth5,month:5, change: this.performanceLevel1VO.perpowerChangeMonth5,changerate:this.performanceLevel1VO.perpowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perpowerMonth6,month:6, change: this.performanceLevel1VO.perpowerChangeMonth6,changerate:this.performanceLevel1VO.perpowerChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perpowerMonth7,month:7, change: this.performanceLevel1VO.perpowerChangeMonth7,changerate:this.performanceLevel1VO.perpowerChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perpowerMonth8,month:8, change: this.performanceLevel1VO.perpowerChangeMonth8,changerate:this.performanceLevel1VO.perpowerChangeRateMonth8 },
                     { value: this.performanceLevel1VO.perpowerMonth9,month:9, change: this.performanceLevel1VO.perpowerChangeMonth9,changerate:this.performanceLevel1VO.perpowerChangeRateMonth9 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perpowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 9:
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perpowerForecastMonth1,
                       "2月": this.performanceLevel1VO.perpowerForecastMonth2,
                        "3月": this.performanceLevel1VO.perpowerForecastMonth3,
                        "4月": this.performanceLevel1VO.perpowerForecastMonth4,
                        "5月": this.performanceLevel1VO.perpowerForecastMonth5,
                         "6月": this.performanceLevel1VO.perpowerForecastMonth6,
                          "7月": this.performanceLevel1VO.perpowerForecastMonth7,
                          "8月": this.performanceLevel1VO.perpowerForecastMonth8,
                          "9月": this.performanceLevel1VO.perpowerForecastMonth9,
                          "10月": this.performanceLevel1VO.perpowerForecastMonth10,
                          // "11月": this.performanceLevel1VO.perpowerForecastMonth11,
                          // "12月": this.performanceLevel1VO.perpowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perpowerMonth1,month:1, change: this.performanceLevel1VO.perpowerChangeMonth1,changerate:this.performanceLevel1VO.perpowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perpowerMonth2,month:2, change: this.performanceLevel1VO.perpowerChangeMonth2,changerate:this.performanceLevel1VO.perpowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perpowerMonth3,month:3, change: this.performanceLevel1VO.perpowerChangeMonth3,changerate:this.performanceLevel1VO.perpowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perpowerMonth4,month:4, change: this.performanceLevel1VO.perpowerChangeMonth4,changerate:this.performanceLevel1VO.perpowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perpowerMonth5,month:5, change: this.performanceLevel1VO.perpowerChangeMonth5,changerate:this.performanceLevel1VO.perpowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perpowerMonth6,month:6, change: this.performanceLevel1VO.perpowerChangeMonth6,changerate:this.performanceLevel1VO.perpowerChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perpowerMonth7,month:7, change: this.performanceLevel1VO.perpowerChangeMonth7,changerate:this.performanceLevel1VO.perpowerChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perpowerMonth8,month:8, change: this.performanceLevel1VO.perpowerChangeMonth8,changerate:this.performanceLevel1VO.perpowerChangeRateMonth8 },
                     { value: this.performanceLevel1VO.perpowerMonth9,month:9, change: this.performanceLevel1VO.perpowerChangeMonth9,changerate:this.performanceLevel1VO.perpowerChangeRateMonth9 },
                    { value: this.performanceLevel1VO.perpowerMonth10,month:10, change: this.performanceLevel1VO.perpowerChangeMonth10,changerate:this.performanceLevel1VO.perpowerChangeRateMonth10 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perpowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 10:
                          // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perpowerForecastMonth1,
                       "2月": this.performanceLevel1VO.perpowerForecastMonth2,
                        "3月": this.performanceLevel1VO.perpowerForecastMonth3,
                        "4月": this.performanceLevel1VO.perpowerForecastMonth4,
                        "5月": this.performanceLevel1VO.perpowerForecastMonth5,
                         "6月": this.performanceLevel1VO.perpowerForecastMonth6,
                          "7月": this.performanceLevel1VO.perpowerForecastMonth7,
                          "8月": this.performanceLevel1VO.perpowerForecastMonth8,
                          "9月": this.performanceLevel1VO.perpowerForecastMonth9,
                          "10月": this.performanceLevel1VO.perpowerForecastMonth10,
                          "11月": this.performanceLevel1VO.perpowerForecastMonth11,
                        //  "12月": this.performanceLevel1VO.perpowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perpowerMonth1,month:1, change: this.performanceLevel1VO.perpowerChangeMonth1,changerate:this.performanceLevel1VO.perpowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perpowerMonth2,month:2, change: this.performanceLevel1VO.perpowerChangeMonth2,changerate:this.performanceLevel1VO.perpowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perpowerMonth3,month:3, change: this.performanceLevel1VO.perpowerChangeMonth3,changerate:this.performanceLevel1VO.perpowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perpowerMonth4,month:4, change: this.performanceLevel1VO.perpowerChangeMonth4,changerate:this.performanceLevel1VO.perpowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perpowerMonth5,month:5, change: this.performanceLevel1VO.perpowerChangeMonth5,changerate:this.performanceLevel1VO.perpowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perpowerMonth6,month:6, change: this.performanceLevel1VO.perpowerChangeMonth6,changerate:this.performanceLevel1VO.perpowerChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perpowerMonth7,month:7, change: this.performanceLevel1VO.perpowerChangeMonth7,changerate:this.performanceLevel1VO.perpowerChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perpowerMonth8,month:8, change: this.performanceLevel1VO.perpowerChangeMonth8,changerate:this.performanceLevel1VO.perpowerChangeRateMonth8 },
                     { value: this.performanceLevel1VO.perpowerMonth9,month:9, change: this.performanceLevel1VO.perpowerChangeMonth9,changerate:this.performanceLevel1VO.perpowerChangeRateMonth9 },
                    { value: this.performanceLevel1VO.perpowerMonth10,month:10, change: this.performanceLevel1VO.perpowerChangeMonth10,changerate:this.performanceLevel1VO.perpowerChangeRateMonth10 },
                   { value: this.performanceLevel1VO.perpowerMonth11,month:11, change: this.performanceLevel1VO.perpowerChangeMonth11,changerate:this.performanceLevel1VO.perpowerChangeRateMonth11 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perpowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 11: 
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                            {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perpowerForecastMonth1,
                       "2月": this.performanceLevel1VO.perpowerForecastMonth2,
                        "3月": this.performanceLevel1VO.perpowerForecastMonth3,
                        "4月": this.performanceLevel1VO.perpowerForecastMonth4,
                        "5月": this.performanceLevel1VO.perpowerForecastMonth5,
                         "6月": this.performanceLevel1VO.perpowerForecastMonth6,
                          "7月": this.performanceLevel1VO.perpowerForecastMonth7,
                          "8月": this.performanceLevel1VO.perpowerForecastMonth8,
                          "9月": this.performanceLevel1VO.perpowerForecastMonth9,
                          "10月": this.performanceLevel1VO.perpowerForecastMonth10,
                          "11月": this.performanceLevel1VO.perpowerForecastMonth11,
                          "12月": this.performanceLevel1VO.perpowerForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perpowerMonth1,month:1, change: this.performanceLevel1VO.perpowerChangeMonth1,changerate:this.performanceLevel1VO.perpowerChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perpowerMonth2,month:2, change: this.performanceLevel1VO.perpowerChangeMonth2,changerate:this.performanceLevel1VO.perpowerChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perpowerMonth3,month:3, change: this.performanceLevel1VO.perpowerChangeMonth3,changerate:this.performanceLevel1VO.perpowerChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perpowerMonth4,month:4, change: this.performanceLevel1VO.perpowerChangeMonth4,changerate:this.performanceLevel1VO.perpowerChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perpowerMonth5,month:5, change: this.performanceLevel1VO.perpowerChangeMonth5,changerate:this.performanceLevel1VO.perpowerChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perpowerMonth6,month:6, change: this.performanceLevel1VO.perpowerChangeMonth6,changerate:this.performanceLevel1VO.perpowerChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perpowerMonth7,month:7, change: this.performanceLevel1VO.perpowerChangeMonth7,changerate:this.performanceLevel1VO.perpowerChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perpowerMonth8,month:8, change: this.performanceLevel1VO.perpowerChangeMonth8,changerate:this.performanceLevel1VO.perpowerChangeRateMonth8 },
                     { value: this.performanceLevel1VO.perpowerMonth9,month:9, change: this.performanceLevel1VO.perpowerChangeMonth9,changerate:this.performanceLevel1VO.perpowerChangeRateMonth9 },
                    { value: this.performanceLevel1VO.perpowerMonth10,month:10, change: this.performanceLevel1VO.perpowerChangeMonth10,changerate:this.performanceLevel1VO.perpowerChangeRateMonth10 },
                   { value: this.performanceLevel1VO.perpowerMonth11,month:11, change: this.performanceLevel1VO.perpowerChangeMonth11,changerate:this.performanceLevel1VO.perpowerChangeRateMonth11 },
                   { value: this.performanceLevel1VO.perpowerMonth11,month:12, change: this.performanceLevel1VO.perpowerChangeMonth12,changerate:this.performanceLevel1VO.perpowerChangeRateMonth12 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perpowerEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '12月',
                            name: this.performanceLevel1VO.perpowerEvaluateMonth12,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   

            

             }
            // dataarr=
          }
           if(flag==8){
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                          //  {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perwaterForecastMonth1,
                        // "2月": this.performanceLevel1VO.perwaterForecastMonth2,
                        // "3月": this.performanceLevel1VO.perwaterForecastMonth3,
                        // "4月": this.performanceLevel1VO.perwaterForecastMonth4,
                        // "5月": this.performanceLevel1VO.perwaterForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perwaterForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perwaterForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perwaterForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perwaterForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perwaterForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perwaterForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perwaterForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performanceLevel1VO.perwaterEvaluateMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[
                  { value: this.performanceLevel1VO.perwaterMonth1,month:1, change: this.performanceLevel1VO.perwaterChangeMonth1,changerate:this.performanceLevel1VO.perwaterChangeRateMonth1 },
                        
                  ];//目标值
                  
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perwaterForecastMonth1,
                        "2月": this.performanceLevel1VO.perwaterForecastMonth2,
                        // "3月": this.performanceLevel1VO.perwaterForecastMonth3,
                        // "4月": this.performanceLevel1VO.perwaterForecastMonth4,
                        // "5月": this.performanceLevel1VO.perwaterForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perwaterForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perwaterForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perwaterForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perwaterForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perwaterForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perwaterForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perwaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perwaterMonth1,month:1, change: this.performanceLevel1VO.perwaterChangeMonth1,changerate:this.performanceLevel1VO.perwaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perwaterMonth2,month:2, change: this.performanceLevel1VO.perwaterChangeMonth2,changerate:this.performanceLevel1VO.perwaterChangeRateMonth2 },
                      
                             
                             ];//目标值
            
                     this.tableData=[{
                        date: '1月',
                        name: this.performanceLevel1VO.perwaterEvaluateMonth1,
                        //image: require(besturl)
                        }, 
                      {
                        date: '2月',
                        name: this.performanceLevel1VO.perwaterEvaluateMonth2,
                      // image: require(besturl)
                        }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perwaterForecastMonth1,
                        "2月": this.performanceLevel1VO.perwaterForecastMonth2,
                        "3月": this.performanceLevel1VO.perwaterForecastMonth3,
                        // "4月": this.performanceLevel1VO.perwaterForecastMonth4,
                        // "5月": this.performanceLevel1VO.perwaterForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perwaterForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perwaterForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perwaterForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perwaterForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perwaterForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perwaterForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perwaterForecastMonth12,
                     }
                  ];
                     this.dataarr=[
                              { value: this.performanceLevel1VO.perwaterMonth1,month:1, change: this.performanceLevel1VO.perwaterChangeMonth1,changerate:this.performanceLevel1VO.perwaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perwaterMonth2,month:2, change: this.performanceLevel1VO.perwaterChangeMonth2,changerate:this.performanceLevel1VO.perwaterChangeRateMonth2 },
                       { value: this.performanceLevel1VO.perwaterMonth3,month:3, change: this.performanceLevel1VO.perwaterChangeMonth3,changerate:this.performanceLevel1VO.perwaterChangeRateMonth3 },
                     
                             ];//目标值
              
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perwaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perwaterForecastMonth1,
                        "2月": this.performanceLevel1VO.perwaterForecastMonth2,
                        "3月": this.performanceLevel1VO.perwaterForecastMonth3,
                        "4月": this.performanceLevel1VO.perwaterForecastMonth4,
                        // "5月": this.performanceLevel1VO.perwaterForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perwaterForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perwaterForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perwaterForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perwaterForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perwaterForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perwaterForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perwaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perwaterMonth1,month:1, change: this.performanceLevel1VO.perwaterChangeMonth1,changerate:this.performanceLevel1VO.perwaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perwaterMonth2,month:2, change: this.performanceLevel1VO.perwaterChangeMonth2,changerate:this.performanceLevel1VO.perwaterChangeRateMonth2 },
                       { value: this.performanceLevel1VO.perwaterMonth3,month:3, change: this.performanceLevel1VO.perwaterChangeMonth3,changerate:this.performanceLevel1VO.perwaterChangeRateMonth3 },
                      { value: this.performanceLevel1VO.perwaterMonth4,month:4, change: this.performanceLevel1VO.perwaterChangeMonth4,changerate:this.performanceLevel1VO.perwaterChangeRateMonth4 },
                  
                              ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perwaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
                 case 4:   
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perwaterForecastMonth1,
                        "2月": this.performanceLevel1VO.perwaterForecastMonth2,
                        "3月": this.performanceLevel1VO.perwaterForecastMonth3,
                        "4月": this.performanceLevel1VO.perwaterForecastMonth4,
                        "5月": this.performanceLevel1VO.perwaterForecastMonth5,
                        //  "6月": this.performanceLevel1VO.perwaterForecastMonth6,
                        //   "7月": this.performanceLevel1VO.perwaterForecastMonth7,
                        //   "8月": this.performanceLevel1VO.perwaterForecastMonth8,
                        //   "9月": this.performanceLevel1VO.perwaterForecastMonth9,
                        //   "10月": this.performanceLevel1VO.perwaterForecastMonth10,
                        //   "11月": this.performanceLevel1VO.perwaterForecastMonth11,
                        //   "12月": this.performanceLevel1VO.perwaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perwaterMonth1,month:1, change: this.performanceLevel1VO.perwaterChangeMonth1,changerate:this.performanceLevel1VO.perwaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perwaterMonth2,month:2, change: this.performanceLevel1VO.perwaterChangeMonth2,changerate:this.performanceLevel1VO.perwaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perwaterMonth3,month:3, change: this.performanceLevel1VO.perwaterChangeMonth3,changerate:this.performanceLevel1VO.perwaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perwaterMonth4,month:4, change: this.performanceLevel1VO.perwaterChangeMonth4,changerate:this.performanceLevel1VO.perwaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perwaterMonth5,month:5, change: this.performanceLevel1VO.perwaterChangeMonth5,changerate:this.performanceLevel1VO.perwaterChangeRateMonth5 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perwaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;               
                case 5:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perwaterForecastMonth1,
                        "2月": this.performanceLevel1VO.perwaterForecastMonth2,
                        "3月": this.performanceLevel1VO.perwaterForecastMonth3,
                        "4月": this.performanceLevel1VO.perwaterForecastMonth4,
                        "5月": this.performanceLevel1VO.perwaterForecastMonth5,
                         "6月": this.performanceLevel1VO.perwaterForecastMonth6,
                          // "7月": this.performanceLevel1VO.perwaterForecastMonth7,
                          // "8月": this.performanceLevel1VO.perwaterForecastMonth8,
                          // "9月": this.performanceLevel1VO.perwaterForecastMonth9,
                          // "10月": this.performanceLevel1VO.perwaterForecastMonth10,
                          // "11月": this.performanceLevel1VO.perwaterForecastMonth11,
                          // "12月": this.performanceLevel1VO.perwaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perwaterMonth1,month:1, change: this.performanceLevel1VO.perwaterChangeMonth1,changerate:this.performanceLevel1VO.perwaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perwaterMonth2,month:2, change: this.performanceLevel1VO.perwaterChangeMonth2,changerate:this.performanceLevel1VO.perwaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perwaterMonth3,month:3, change: this.performanceLevel1VO.perwaterChangeMonth3,changerate:this.performanceLevel1VO.perwaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perwaterMonth4,month:4, change: this.performanceLevel1VO.perwaterChangeMonth4,changerate:this.performanceLevel1VO.perwaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perwaterMonth5,month:5, change: this.performanceLevel1VO.perwaterChangeMonth5,changerate:this.performanceLevel1VO.perwaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perwaterMonth6,month:6, change: this.performanceLevel1VO.perwaterChangeMonth6,changerate:this.performanceLevel1VO.perwaterChangeRateMonth6 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perwaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 6:
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perwaterForecastMonth1,
                        "2月": this.performanceLevel1VO.perwaterForecastMonth2,
                        "3月": this.performanceLevel1VO.perwaterForecastMonth3,
                        "4月": this.performanceLevel1VO.perwaterForecastMonth4,
                        "5月": this.performanceLevel1VO.perwaterForecastMonth5,
                         "6月": this.performanceLevel1VO.perwaterForecastMonth6,
                          "7月": this.performanceLevel1VO.perwaterForecastMonth7,
                          // "8月": this.performanceLevel1VO.perwaterForecastMonth8,
                          // "9月": this.performanceLevel1VO.perwaterForecastMonth9,
                          // "10月": this.performanceLevel1VO.perwaterForecastMonth10,
                          // "11月": this.performanceLevel1VO.perwaterForecastMonth11,
                          // "12月": this.performanceLevel1VO.perwaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perwaterMonth1,month:1, change: this.performanceLevel1VO.perwaterChangeMonth1,changerate:this.performanceLevel1VO.perwaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perwaterMonth2,month:2, change: this.performanceLevel1VO.perwaterChangeMonth2,changerate:this.performanceLevel1VO.perwaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perwaterMonth3,month:3, change: this.performanceLevel1VO.perwaterChangeMonth3,changerate:this.performanceLevel1VO.perwaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perwaterMonth4,month:4, change: this.performanceLevel1VO.perwaterChangeMonth4,changerate:this.performanceLevel1VO.perwaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perwaterMonth5,month:5, change: this.performanceLevel1VO.perwaterChangeMonth5,changerate:this.performanceLevel1VO.perwaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perwaterMonth6,month:6, change: this.performanceLevel1VO.perwaterChangeMonth6,changerate:this.performanceLevel1VO.perwaterChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perwaterMonth7,month:7, change: this.performanceLevel1VO.perwaterChangeMonth7,changerate:this.performanceLevel1VO.perwaterChangeRateMonth7 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perwaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 7: 
                    // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perwaterForecastMonth1,
                        "2月": this.performanceLevel1VO.perwaterForecastMonth2,
                        "3月": this.performanceLevel1VO.perwaterForecastMonth3,
                        "4月": this.performanceLevel1VO.perwaterForecastMonth4,
                        "5月": this.performanceLevel1VO.perwaterForecastMonth5,
                         "6月": this.performanceLevel1VO.perwaterForecastMonth6,
                          "7月": this.performanceLevel1VO.perwaterForecastMonth7,
                          "8月": this.performanceLevel1VO.perwaterForecastMonth8,
                          // "9月": this.performanceLevel1VO.perwaterForecastMonth9,
                          // "10月": this.performanceLevel1VO.perwaterForecastMonth10,
                          // "11月": this.performanceLevel1VO.perwaterForecastMonth11,
                          // "12月": this.performanceLevel1VO.perwaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perwaterMonth1,month:1, change: this.performanceLevel1VO.perwaterChangeMonth1,changerate:this.performanceLevel1VO.perwaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perwaterMonth2,month:2, change: this.performanceLevel1VO.perwaterChangeMonth2,changerate:this.performanceLevel1VO.perwaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perwaterMonth3,month:3, change: this.performanceLevel1VO.perwaterChangeMonth3,changerate:this.performanceLevel1VO.perwaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perwaterMonth4,month:4, change: this.performanceLevel1VO.perwaterChangeMonth4,changerate:this.performanceLevel1VO.perwaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perwaterMonth5,month:5, change: this.performanceLevel1VO.perwaterChangeMonth5,changerate:this.performanceLevel1VO.perwaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perwaterMonth6,month:6, change: this.performanceLevel1VO.perwaterChangeMonth6,changerate:this.performanceLevel1VO.perwaterChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perwaterMonth7,month:7, change: this.performanceLevel1VO.perwaterChangeMonth7,changerate:this.performanceLevel1VO.perwaterChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perwaterMonth8,month:8, change: this.performanceLevel1VO.perwaterChangeMonth8,changerate:this.performanceLevel1VO.perwaterChangeRateMonth8 },
                   
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perwaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;    
                case 8:
                        // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perwaterForecastMonth1,
                        "2月": this.performanceLevel1VO.perwaterForecastMonth2,
                        "3月": this.performanceLevel1VO.perwaterForecastMonth3,
                        "4月": this.performanceLevel1VO.perwaterForecastMonth4,
                        "5月": this.performanceLevel1VO.perwaterForecastMonth5,
                         "6月": this.performanceLevel1VO.perwaterForecastMonth6,
                          "7月": this.performanceLevel1VO.perwaterForecastMonth7,
                          "8月": this.performanceLevel1VO.perwaterForecastMonth8,
                          "9月": this.performanceLevel1VO.perwaterForecastMonth9,
                          // "10月": this.performanceLevel1VO.perwaterForecastMonth10,
                          // "11月": this.performanceLevel1VO.perwaterForecastMonth11,
                          // "12月": this.performanceLevel1VO.perwaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perwaterMonth1,month:1, change: this.performanceLevel1VO.perwaterChangeMonth1,changerate:this.performanceLevel1VO.perwaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perwaterMonth2,month:2, change: this.performanceLevel1VO.perwaterChangeMonth2,changerate:this.performanceLevel1VO.perwaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perwaterMonth3,month:3, change: this.performanceLevel1VO.perwaterChangeMonth3,changerate:this.performanceLevel1VO.perwaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perwaterMonth4,month:4, change: this.performanceLevel1VO.perwaterChangeMonth4,changerate:this.performanceLevel1VO.perwaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perwaterMonth5,month:5, change: this.performanceLevel1VO.perwaterChangeMonth5,changerate:this.performanceLevel1VO.perwaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perwaterMonth6,month:6, change: this.performanceLevel1VO.perwaterChangeMonth6,changerate:this.performanceLevel1VO.perwaterChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perwaterMonth7,month:7, change: this.performanceLevel1VO.perwaterChangeMonth7,changerate:this.performanceLevel1VO.perwaterChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perwaterMonth8,month:8, change: this.performanceLevel1VO.perwaterChangeMonth8,changerate:this.performanceLevel1VO.perwaterChangeRateMonth8 },
                     { value: this.performanceLevel1VO.perwaterMonth9,month:9, change: this.performanceLevel1VO.perwaterChangeMonth9,changerate:this.performanceLevel1VO.perwaterChangeRateMonth9 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perwaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 9:
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                      this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perwaterForecastMonth1,
                        "2月": this.performanceLevel1VO.perwaterForecastMonth2,
                        "3月": this.performanceLevel1VO.perwaterForecastMonth3,
                        "4月": this.performanceLevel1VO.perwaterForecastMonth4,
                        "5月": this.performanceLevel1VO.perwaterForecastMonth5,
                         "6月": this.performanceLevel1VO.perwaterForecastMonth6,
                          "7月": this.performanceLevel1VO.perwaterForecastMonth7,
                          "8月": this.performanceLevel1VO.perwaterForecastMonth8,
                          "9月": this.performanceLevel1VO.perwaterForecastMonth9,
                          "10月": this.performanceLevel1VO.perwaterForecastMonth10,
                          // "11月": this.performanceLevel1VO.perwaterForecastMonth11,
                          // "12月": this.performanceLevel1VO.perwaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perwaterMonth1,month:1, change: this.performanceLevel1VO.perwaterChangeMonth1,changerate:this.performanceLevel1VO.perwaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perwaterMonth2,month:2, change: this.performanceLevel1VO.perwaterChangeMonth2,changerate:this.performanceLevel1VO.perwaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perwaterMonth3,month:3, change: this.performanceLevel1VO.perwaterChangeMonth3,changerate:this.performanceLevel1VO.perwaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perwaterMonth4,month:4, change: this.performanceLevel1VO.perwaterChangeMonth4,changerate:this.performanceLevel1VO.perwaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perwaterMonth5,month:5, change: this.performanceLevel1VO.perwaterChangeMonth5,changerate:this.performanceLevel1VO.perwaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perwaterMonth6,month:6, change: this.performanceLevel1VO.perwaterChangeMonth6,changerate:this.performanceLevel1VO.perwaterChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perwaterMonth7,month:7, change: this.performanceLevel1VO.perwaterChangeMonth7,changerate:this.performanceLevel1VO.perwaterChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perwaterMonth8,month:8, change: this.performanceLevel1VO.perwaterChangeMonth8,changerate:this.performanceLevel1VO.perwaterChangeRateMonth8 },
                     { value: this.performanceLevel1VO.perwaterMonth9,month:9, change: this.performanceLevel1VO.perwaterChangeMonth9,changerate:this.performanceLevel1VO.perwaterChangeRateMonth9 },
                    { value: this.performanceLevel1VO.perwaterMonth10,month:10, change: this.performanceLevel1VO.perwaterChangeMonth10,changerate:this.performanceLevel1VO.perwaterChangeRateMonth10 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perwaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 10:
                          // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perwaterForecastMonth1,
                        "2月": this.performanceLevel1VO.perwaterForecastMonth2,
                        "3月": this.performanceLevel1VO.perwaterForecastMonth3,
                        "4月": this.performanceLevel1VO.perwaterForecastMonth4,
                        "5月": this.performanceLevel1VO.perwaterForecastMonth5,
                         "6月": this.performanceLevel1VO.perwaterForecastMonth6,
                          "7月": this.performanceLevel1VO.perwaterForecastMonth7,
                          "8月": this.performanceLevel1VO.perwaterForecastMonth8,
                          "9月": this.performanceLevel1VO.perwaterForecastMonth9,
                          "10月": this.performanceLevel1VO.perwaterForecastMonth10,
                          "11月": this.performanceLevel1VO.perwaterForecastMonth11,
                         // "12月": this.performanceLevel1VO.perwaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perwaterMonth1,month:1, change: this.performanceLevel1VO.perwaterChangeMonth1,changerate:this.performanceLevel1VO.perwaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perwaterMonth2,month:2, change: this.performanceLevel1VO.perwaterChangeMonth2,changerate:this.performanceLevel1VO.perwaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perwaterMonth3,month:3, change: this.performanceLevel1VO.perwaterChangeMonth3,changerate:this.performanceLevel1VO.perwaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perwaterMonth4,month:4, change: this.performanceLevel1VO.perwaterChangeMonth4,changerate:this.performanceLevel1VO.perwaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perwaterMonth5,month:5, change: this.performanceLevel1VO.perwaterChangeMonth5,changerate:this.performanceLevel1VO.perwaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perwaterMonth6,month:6, change: this.performanceLevel1VO.perwaterChangeMonth6,changerate:this.performanceLevel1VO.perwaterChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perwaterMonth7,month:7, change: this.performanceLevel1VO.perwaterChangeMonth7,changerate:this.performanceLevel1VO.perwaterChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perwaterMonth8,month:8, change: this.performanceLevel1VO.perwaterChangeMonth8,changerate:this.performanceLevel1VO.perwaterChangeRateMonth8 },
                     { value: this.performanceLevel1VO.perwaterMonth9,month:9, change: this.performanceLevel1VO.perwaterChangeMonth9,changerate:this.performanceLevel1VO.perwaterChangeRateMonth9 },
                    { value: this.performanceLevel1VO.perwaterMonth10,month:10, change: this.performanceLevel1VO.perwaterChangeMonth10,changerate:this.performanceLevel1VO.perwaterChangeRateMonth10 },
                   { value: this.performanceLevel1VO.perwaterMonth11,month:11, change: this.performanceLevel1VO.perwaterChangeMonth11,changerate:this.performanceLevel1VO.perwaterChangeRateMonth11 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perwaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   
                case 11: 
                         // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performanceLevel1VO.perwaterForecastMonth1,
                        "2月": this.performanceLevel1VO.perwaterForecastMonth2,
                        "3月": this.performanceLevel1VO.perwaterForecastMonth3,
                        "4月": this.performanceLevel1VO.perwaterForecastMonth4,
                        "5月": this.performanceLevel1VO.perwaterForecastMonth5,
                         "6月": this.performanceLevel1VO.perwaterForecastMonth6,
                          "7月": this.performanceLevel1VO.perwaterForecastMonth7,
                          "8月": this.performanceLevel1VO.perwaterForecastMonth8,
                          "9月": this.performanceLevel1VO.perwaterForecastMonth9,
                          "10月": this.performanceLevel1VO.perwaterForecastMonth10,
                          "11月": this.performanceLevel1VO.perwaterForecastMonth11,
                          "12月": this.performanceLevel1VO.perwaterForecastMonth12,
                     }
                  ];
                    this.dataarr=[
                              { value: this.performanceLevel1VO.perwaterMonth1,month:1, change: this.performanceLevel1VO.perwaterChangeMonth1,changerate:this.performanceLevel1VO.perwaterChangeRateMonth1 },
                             { value: this.performanceLevel1VO.perwaterMonth2,month:2, change: this.performanceLevel1VO.perwaterChangeMonth2,changerate:this.performanceLevel1VO.perwaterChangeRateMonth2 },
                             { value: this.performanceLevel1VO.perwaterMonth3,month:3, change: this.performanceLevel1VO.perwaterChangeMonth3,changerate:this.performanceLevel1VO.perwaterChangeRateMonth3 },
                             { value: this.performanceLevel1VO.perwaterMonth4,month:4, change: this.performanceLevel1VO.perwaterChangeMonth4,changerate:this.performanceLevel1VO.perwaterChangeRateMonth4 },
                             { value: this.performanceLevel1VO.perwaterMonth5,month:5, change: this.performanceLevel1VO.perwaterChangeMonth5,changerate:this.performanceLevel1VO.perwaterChangeRateMonth5 },
                      { value: this.performanceLevel1VO.perwaterMonth6,month:6, change: this.performanceLevel1VO.perwaterChangeMonth6,changerate:this.performanceLevel1VO.perwaterChangeRateMonth6 },
                     { value: this.performanceLevel1VO.perwaterMonth7,month:7, change: this.performanceLevel1VO.perwaterChangeMonth7,changerate:this.performanceLevel1VO.perwaterChangeRateMonth7 },
                   { value: this.performanceLevel1VO.perwaterMonth8,month:8, change: this.performanceLevel1VO.perwaterChangeMonth8,changerate:this.performanceLevel1VO.perwaterChangeRateMonth8 },
                     { value: this.performanceLevel1VO.perwaterMonth9,month:9, change: this.performanceLevel1VO.perwaterChangeMonth9,changerate:this.performanceLevel1VO.perwaterChangeRateMonth9 },
                    { value: this.performanceLevel1VO.perwaterMonth10,month:10, change: this.performanceLevel1VO.perwaterChangeMonth10,changerate:this.performanceLevel1VO.perwaterChangeRateMonth10 },
                   { value: this.performanceLevel1VO.perwaterMonth11,month:11, change: this.performanceLevel1VO.perwaterChangeMonth11,changerate:this.performanceLevel1VO.perwaterChangeRateMonth11 },
                   { value: this.performanceLevel1VO.perwaterMonth11,month:12, change: this.performanceLevel1VO.perwaterChangeMonth12,changerate:this.performanceLevel1VO.perwaterChangeRateMonth12 },
                  
                             
                             ];//目标值
                  
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performanceLevel1VO.perwaterEvaluateMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '5月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '6月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '7月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '8月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                            {
                            date: '9月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '10月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '11月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '12月',
                            name: this.performanceLevel1VO.perwaterEvaluateMonth12,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;   

            

             }
            // dataarr=
          }
     

    
       return {
              title: {
                text: "",
                textStyle: {
                  fontSize: 16,
                  color: "#000",
                  fontWeight: "bolder",
                },
              },
              tooltip: {
                trigger: "axis",
               
            formatter: function (params) {
               //console.log(params);
                    const item = params[0];
                  var color = params.color;//图例颜色
                  //var value = item.value;//y轴值
                 
                  var month=item.data.month;
                  var value = item.data.value;
                  var change=item.data.change;
                  var changerate=item.data.changerate;
                  if (value==null)
                      value="";
                  if (change==null)
                      change="";
                  if (changerate==null)
                      changerate="";    
                  var htmlStr ='<div align="left">';
                 
                 htmlStr += month + '月<br/>';//x轴的名称
                  //为了保证和原来的效果一样，这里自己实现了一个点的效果
                  htmlStr += '<span style="margin-right:5px;display:inline-block;width:8px;height:10px;border-radius:5px;background-color:'+color+';"></span>';
                  htmlStr +=  '能耗绩效:'+value+'<br/>';
                  htmlStr += '<span style="margin-right:5px;display:inline-block;width:8px;height:10px;border-radius:5px;background-color:'+color+';"></span>';

                  htmlStr +=  '同比变化量:'+change+'<br/>';
                  htmlStr += '<span style="margin-right:5px;display:inline-block;width:8px;height:10px;border-radius:5px;background-color:'+color+';"></span>';

                  htmlStr +=  '同比变化率:'+changerate+'<br/>';
                  // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
                  //htmlStr += '<span style="color:'+color+'">';
                  
                  //添加一个汉字，这里你可以格式你的数字或者自定义文本内容
                  //htmlStr += params.seriesName + '：'+params.value + '笔';
      
                  // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
                  //htmlStr += '</span>';
                  
                  htmlStr += '</div>';
                  
                  return htmlStr; 
           }


             },
            
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              xAxis: [
                {
                  type: "category",
                  data:this.montharr,
                },
              ],
              yAxis: [
                {
                  type: "value",
                  name: "",
                  axisLine: {show:true},
                  axisTick: {show:true},
                  splitLine:{show:true},
                  axisLabel: {
                    formatter: "{value} ",
                  },
                },
              ],
              series: [
                {
                  name: "用电量",
                  type: "line",
                  symbolSize: 6,
                   smooth:false,
                  itemStyle : {
                     normal : {
                        color:'#F1C232',
                        label : {show: true},
                     lineStyle:{
                       color:'#F6B26B',
                       width:4
                    }
                   }
                  },
                 
                  data:this.dataarr,
                },
              ],
            };
    },
   monthlyProportionRate4(flag){
     return{
           title: {
        text: '某站点用户访问来源',
       
    },
  
   
    series: [
        {
            name: '访问来源',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [
                {value: 335, name: '直接访问'},
                {value: 310, name: '邮件营销'},
                {value: 234, name: '联盟广告'},
                {value: 135, name: '视频广告'},
                {value: 1548, name: '搜索引擎'}
            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
     }
   },

   }
}
</script>
<style scoped>
   @import "../../../../../../assets/common/performance/css/month/styles.css";
   @import "../../../../../../assets/common/consumption/css/styles.css";
   @import "../../../../../../assets/common/rp_page.css";
    .pagination-container {
  background: rgba(255, 255, 255, 0.0235294117647059);
  padding: 18px 0px;
  float: left;
  z-index: 99;
position: absolute;
}
   .innerbox{
            overflow-x: hidden;
            overflow-y: auto;       
        }
        /*滚动条样式*/
   .innerbox::-webkit-scrollbar {
           	width: 8px;
            height: 8px;
            background-color: #F5F5F5;
    }
    .innerbox::-webkit-scrollbar-thumb {
            	border-radius:3px;
	box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #555;
    }
    .innerbox::-webkit-scrollbar-track {
          	box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
            border-radius: 3px;
            background-color: #F5F5F5;

    }
  .fontset{
      font-family:'PingFangSC-Regular', 'PingFang SC', sans-serif;
      font-weight:400;
      font-style:normal;
  }
</style>
